import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ApproachType: { input: any; output: any; }
  BloodType: { input: any; output: any; }
  BodyShape: { input: any; output: any; }
  CelebrityBadgePublicStatus: { input: any; output: any; }
  ChildrenExist: { input: any; output: any; }
  CompanyNamePublicSetting: { input: any; output: any; }
  /** Date custom scalar type */
  Date: { input: number; output: number; }
  Drinking: { input: any; output: any; }
  DurationType: { input: any; output: any; }
  FirstDatePaymentPreference: { input: any; output: any; }
  Gender: { input: any; output: any; }
  Graduation: { input: any; output: any; }
  Holiday: { input: any; output: any; }
  HouseWork: { input: any; output: any; }
  Housemate: { input: any; output: any; }
  IncomeEnum: { input: any; output: any; }
  IncomePublicSetting: { input: any; output: any; }
  InstallType: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  MarriageHistory: { input: any; output: any; }
  MarriageView: { input: any; output: any; }
  MatchStatus: { input: any; output: any; }
  MemberStatus: { input: any; output: any; }
  MessageType: { input: any; output: any; }
  PlatformType: { input: any; output: any; }
  Prefecture: { input: any; output: any; }
  ProductType: { input: any; output: any; }
  ProfileImagePublicStatus: { input: any; output: any; }
  ReportUserReason: { input: any; output: any; }
  ScreeningImageType: { input: any; output: any; }
  ScreeningScoreType: { input: any; output: any; }
  ScreeningStatus: { input: any; output: any; }
  Sibling: { input: any; output: any; }
  Smoking: { input: any; output: any; }
  SwipeType: { input: any; output: any; }
  UserStatus: { input: any; output: any; }
  UserWorld: { input: any; output: any; }
  WantChild: { input: any; output: any; }
};

export const AiScreeningDeniedReasonEnum = {
  ExcessiveEditing: 'ExcessiveEditing',
  FaceIsHidden: 'FaceIsHidden',
  Illustration: 'Illustration',
  MultiplePeopleInPhoto: 'MultiplePeopleInPhoto',
  NoFaceInPhoto: 'NoFaceInPhoto',
  None: 'None',
  Other: 'Other',
  PersonalInformationIncluded: 'PersonalInformationIncluded',
  PhotoIsBlurry: 'PhotoIsBlurry',
  Sexual: 'Sexual',
  WearingMask: 'WearingMask',
  WearingSunglasses: 'WearingSunglasses'
} as const;

export type AiScreeningDeniedReasonEnum = typeof AiScreeningDeniedReasonEnum[keyof typeof AiScreeningDeniedReasonEnum];
export type AbTestConfig = {
  __typename?: 'AbTestConfig';
  bPercentage: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  forceVariant?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  testKey: Scalars['String']['output'];
};

export type AcceptedMatchesInput = {
  matchTimeLimitFilter?: InputMaybe<MatchTimeLimitFilterEnum>;
  messageListFilter?: InputMaybe<MessageListFilterEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AcceptedMatchesOutput = {
  __typename?: 'AcceptedMatchesOutput';
  matches: Array<MatchWithOpponentUser>;
  pageInfo: PageInfo;
};

export type AdminForceUpdateSetting = {
  __typename?: 'AdminForceUpdateSetting';
  createdAt: Scalars['Date']['output'];
  createdByAdministratorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  minimumAvailableVersionForAndroid?: Maybe<Scalars['String']['output']>;
  minimumAvailableVersionForIos?: Maybe<Scalars['String']['output']>;
  restoredFromId?: Maybe<Scalars['Int']['output']>;
};

export type Administrator = {
  __typename?: 'Administrator';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  role: AdministratorRole;
  updatedAt: Scalars['Date']['output'];
};

export const AdministratorRole = {
  FullAccess: 'FullAccess',
  GeneralOperator: 'GeneralOperator',
  NotificationManager: 'NotificationManager',
  Screener: 'Screener',
  ScreeningReadOnly: 'ScreeningReadOnly',
  UserViewer: 'UserViewer'
} as const;

export type AdministratorRole = typeof AdministratorRole[keyof typeof AdministratorRole];
export type Advertisement = {
  __typename?: 'Advertisement';
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  insertAfter?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  targetUrl: Scalars['String']['output'];
};

export type AmbassadorReferralComment = {
  __typename?: 'AmbassadorReferralComment';
  ambassadorReferralThemeId: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isVisible: Scalars['Boolean']['output'];
};

export type AmbassadorReferralCommentOutput = {
  __typename?: 'AmbassadorReferralCommentOutput';
  ambassadorReferralComment?: Maybe<AmbassadorReferralComment>;
};

export type AmbassadorReferralRewardTicketInfoOutput = {
  __typename?: 'AmbassadorReferralRewardTicketInfoOutput';
  isReferralCampaignActive: Scalars['Boolean']['output'];
  referralCampaignHeaderImageUrl?: Maybe<Scalars['String']['output']>;
  ticketCount: Scalars['Int']['output'];
  ticketValueText: Scalars['String']['output'];
};

export type AmbassadorReferralTheme = {
  __typename?: 'AmbassadorReferralTheme';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type AmbassadorReferralWithOpponentUser = {
  __typename?: 'AmbassadorReferralWithOpponentUser';
  id: Scalars['Int']['output'];
  isReferralFromMe: Scalars['Boolean']['output'];
  opponentUser: OtherUser;
};

export type AmbassadorReferralsOutput = {
  __typename?: 'AmbassadorReferralsOutput';
  ambassadorReferrals: Array<AmbassadorReferralWithOpponentUser>;
};

export type AppReviewCreateInput = {
  rate: Scalars['Float']['input'];
  triggerEvent?: InputMaybe<Scalars['String']['input']>;
};

export type Appeal = {
  __typename?: 'Appeal';
  endedAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  isAutoAppeal: Scalars['Boolean']['output'];
  isEffectUpCampaignUsed: Scalars['Boolean']['output'];
};

export type AppealWithUser = {
  __typename?: 'AppealWithUser';
  endedAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  isAutoAppeal: Scalars['Boolean']['output'];
  isEffectUpCampaignUsed: Scalars['Boolean']['output'];
  user: User;
};

export type ApplyForCelebrityCertificationInput = {
  celebrityBadgePublicSetting?: InputMaybe<Scalars['CelebrityBadgePublicStatus']['input']>;
  firstRealName?: InputMaybe<Scalars['String']['input']>;
  idSelfieImagePath?: InputMaybe<Scalars['String']['input']>;
  identificationImagePath?: InputMaybe<Scalars['String']['input']>;
  incomePublicSetting?: InputMaybe<Scalars['IncomePublicSetting']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  lastRealName?: InputMaybe<Scalars['String']['input']>;
  officialDocumentImagePath?: InputMaybe<Scalars['String']['input']>;
  paths: Array<Scalars['String']['input']>;
  profileImagePublicSetting?: InputMaybe<Scalars['ProfileImagePublicStatus']['input']>;
  profileVisibility: CelebrityProfileVisibilityEnum;
  remarks?: InputMaybe<Scalars['String']['input']>;
  snsAccountUrl: Scalars['String']['input'];
  stageName: Scalars['String']['input'];
};

export type ApplyForScreeningInput = {
  profileImagePublicSetting: Scalars['ProfileImagePublicStatus']['input'];
};

export type ApplyStickerCreateInput = {
  gorgeousRankEnumSnapshot: Scalars['String']['input'];
  shippmentAddress: Scalars['String']['input'];
  shippmentZipCode: Scalars['Int']['input'];
};

export type ApproachingMatchesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ApproachingMatchesListOutput = {
  __typename?: 'ApproachingMatchesListOutput';
  matches: Array<Match>;
  pageInfo: PageInfo;
};

export type AuthExchangeCodeInput = {
  code: Scalars['String']['input'];
};

export type AuthOutput = {
  __typename?: 'AuthOutput';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type AutoScreeningScore = {
  __typename?: 'AutoScreeningScore';
  age: Scalars['Int']['output'];
  ambassador: Scalars['Int']['output'];
  celebrityCertification: Scalars['Float']['output'];
  companyName: Scalars['Int']['output'];
  face?: Maybe<Scalars['Float']['output']>;
  gorgeousRank: Scalars['String']['output'];
  graduation: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  income: Scalars['Int']['output'];
  overAll: Scalars['Float']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  shouldSkipScreeningImage: Scalars['Boolean']['output'];
};

export type AutoScreeningScoreInput = {
  userId: Scalars['Int']['input'];
};

export type BanUserInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type Banner = {
  __typename?: 'Banner';
  id: Scalars['Float']['output'];
  imageUrl: Scalars['String']['output'];
  isAd?: Maybe<Scalars['Boolean']['output']>;
  isReferralCampaign?: Maybe<Scalars['Boolean']['output']>;
  name: BannerKindEnum;
};

export const BannerKindEnum = {
  AlternaBankBanner: 'alternaBankBanner',
  AmbassadorReferral: 'ambassadorReferral',
  AmbassadorReferralCampaign: 'ambassadorReferralCampaign',
  CelebrityCertificationPrompt: 'celebrityCertificationPrompt',
  CelebrityConciergeLinePrompt: 'celebrityConciergeLinePrompt',
  FreeCp: 'freeCP',
  GgMarriageInvitation: 'ggMarriageInvitation',
  GorgeousDateCampaign: 'gorgeousDateCampaign',
  GorgeousJumbo: 'gorgeousJumbo',
  IdentificationPrompt: 'identificationPrompt',
  LadiesPlan: 'ladiesPlan',
  LineLinkCampaign: 'lineLinkCampaign',
  PlatinumPlan: 'platinumPlan',
  Someone: 'someone',
  Sticker: 'sticker',
  SubscriptionSpecialSale: 'subscriptionSpecialSale',
  TicketCp: 'ticketCP',
  TrustMode: 'trustMode',
  TtBanner: 'ttBanner',
  WebSubscriptionUpgradeSale: 'webSubscriptionUpgradeSale'
} as const;

export type BannerKindEnum = typeof BannerKindEnum[keyof typeof BannerKindEnum];
export type BulkDisableReferralCodesInput = {
  referralCodeIds: Array<Scalars['Int']['input']>;
};

export type BulkRejectPassedSelfIntroductionStatusInput = {
  failedReason?: InputMaybe<Scalars['String']['input']>;
  selfIntroductionIds: Array<Scalars['Int']['input']>;
  status: Scalars['ScreeningStatus']['input'];
};

export type BulkRejectUserInput = {
  screeningFailedReason?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

export type BulkUpdateApproachMessageStatusInput = {
  approachMessageIds: Array<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
};

export type BulkUpdateHobbyTagStatusInput = {
  failedReason?: InputMaybe<Scalars['String']['input']>;
  hobbyTagIds: Array<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
};

export type BulkUpdateProfileImageStatusInput = {
  profileImageIds: Array<Scalars['Int']['input']>;
  status: Scalars['ScreeningStatus']['input'];
};

export type BulkUpdateProfileItemWithScreeningStatusInput = {
  profileItemWithScreeningIds: Array<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
};

export type BulkUpdateScreeningImageStatusInput = {
  statusInputs: Array<ScreeningImageStatusInputDto>;
  type: Scalars['ScreeningImageType']['input'];
};

export type BulkUpdateSelfIntroductionStatusInput = {
  failedReason?: InputMaybe<Scalars['String']['input']>;
  selfIntroductionIds: Array<Scalars['Int']['input']>;
  status: Scalars['ScreeningStatus']['input'];
};

export type Campaign = {
  __typename?: 'Campaign';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  carouselBannerImageUrl?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  commonSaleType?: Maybe<CommonSaleTypeEnum>;
  createdAt: Scalars['Date']['output'];
  endAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  myPageBannerUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  screeningCutoffAt?: Maybe<Scalars['Date']['output']>;
  startAt: Scalars['Date']['output'];
  startQaAt: Scalars['Date']['output'];
  subscriptionSaleConfig?: Maybe<SubscriptionSaleConfig>;
  ticketSaleConfig?: Maybe<TicketSaleConfig>;
};

export type CampaignCode = {
  __typename?: 'CampaignCode';
  description?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CampaignCodeInfo = {
  __typename?: 'CampaignCodeInfo';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CampaignCodeInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CelebrityCertification = {
  __typename?: 'CelebrityCertification';
  administrator?: Maybe<Administrator>;
  administratorId?: Maybe<Scalars['Int']['output']>;
  certifiedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  failedAt?: Maybe<Scalars['Date']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  failedReasonMessage?: Maybe<Scalars['String']['output']>;
  firstRealName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  idSelfieImageUrl?: Maybe<Scalars['String']['output']>;
  identificationImageUrl?: Maybe<Scalars['String']['output']>;
  invitationCode?: Maybe<Scalars['String']['output']>;
  isApproved: Scalars['Boolean']['output'];
  isProfilePrivate: Scalars['Boolean']['output'];
  lastRealName: Scalars['String']['output'];
  officialDocumentImageUrl?: Maybe<Scalars['String']['output']>;
  profileVisibility: CelebrityProfileVisibilityEnum;
  remarks?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  screeningImage?: Maybe<ScreeningImage>;
  screeningImageId?: Maybe<Scalars['Int']['output']>;
  snsAccountUrl?: Maybe<Scalars['String']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  status: Scalars['ScreeningStatus']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export const CelebrityProfileVisibilityEnum = {
  LikeOnly: 'LIKE_ONLY',
  Public: 'PUBLIC'
} as const;

export type CelebrityProfileVisibilityEnum = typeof CelebrityProfileVisibilityEnum[keyof typeof CelebrityProfileVisibilityEnum];
export type ChanceTime = {
  __typename?: 'ChanceTime';
  endAt?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  users: Array<User>;
};

export type CheckAgreedLatestPrivacyPolicyResponse = {
  __typename?: 'CheckAgreedLatestPrivacyPolicyResponse';
  agreed: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type ClientFeatureFlagSetting = {
  __typename?: 'ClientFeatureFlagSetting';
  enabled: Scalars['Boolean']['output'];
  endAt?: Maybe<Scalars['Date']['output']>;
  key: Scalars['String']['output'];
};

export const CommonSaleTypeEnum = {
  ExtraTicketSale: 'ExtraTicketSale',
  PlatinumSale: 'PlatinumSale',
  ReferralCampaign: 'ReferralCampaign',
  SubscriptionSale: 'SubscriptionSale',
  WebUpgradeSale: 'WebUpgradeSale'
} as const;

export type CommonSaleTypeEnum = typeof CommonSaleTypeEnum[keyof typeof CommonSaleTypeEnum];
export type CompleteIncomeCertificationOutput = {
  __typename?: 'CompleteIncomeCertificationOutput';
  status: Scalars['String']['output'];
};

export type CompleteSingleCertificationOutput = {
  __typename?: 'CompleteSingleCertificationOutput';
  status: Scalars['String']['output'];
};

export type ConfirmIdentityForIncomeOutput = {
  __typename?: 'ConfirmIdentityForIncomeOutput';
  address?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redirectUri: Scalars['String']['output'];
};

export type ConfirmIdentityOutput = {
  __typename?: 'ConfirmIdentityOutput';
  address?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redirectUri: Scalars['String']['output'];
};

export type CreateAmbassadorReferralCommentInput = {
  ambassadorReferralThemeId: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  opponentUserId: Scalars['Int']['input'];
};

export type CreateCommonSaleInput = {
  bannerUrl: Scalars['String']['input'];
  carouselBannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  commonSaleType: CommonSaleTypeEnum;
  endAt: Scalars['Date']['input'];
  myPageBannerUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  screeningCutoffAt?: InputMaybe<Scalars['Date']['input']>;
  startAt: Scalars['Date']['input'];
  startQaAt: Scalars['Date']['input'];
  subscriptionSaleConfig?: InputMaybe<SubscriptionSaleConfigInput>;
  ticketSaleConfig?: InputMaybe<TicketSaleConfigInput>;
};

export type CreateFootprintInput = {
  source: Scalars['String']['input'];
  toUserId: Scalars['Int']['input'];
};

export type CreateForceUpdateSettingInput = {
  expectedCurrentId?: InputMaybe<Scalars['Int']['input']>;
  minimumAvailableVersionForAndroid?: InputMaybe<Scalars['String']['input']>;
  minimumAvailableVersionForIos?: InputMaybe<Scalars['String']['input']>;
  storeAvailabilityConfirmed: Scalars['Boolean']['input'];
};

export type CreateHobbyTagInput = {
  hobbyTagCategoryId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateProfileItemInput = {
  type: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type CreateScheduledEmailNotificationInput = {
  dynamicTemplateData: Scalars['String']['input'];
  emailName: Scalars['String']['input'];
  forceSendFlg: Scalars['Boolean']['input'];
  isAdvertisingEmail?: Scalars['Boolean']['input'];
  managementName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifyAt?: InputMaybe<Scalars['String']['input']>;
  status?: Scalars['String']['input'];
  targetUserCondition?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type CreateScheduledEmailNotificationOutput = {
  __typename?: 'CreateScheduledEmailNotificationOutput';
  createdAt: Scalars['Date']['output'];
  dynamicTemplateData: Scalars['String']['output'];
  emailName: Scalars['String']['output'];
  forceSendFlg: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAdvertisingEmail: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
};

export type CreateScheduledInAppNewsInput = {
  body: Scalars['String']['input'];
  label: Scalars['String']['input'];
  managementName?: InputMaybe<Scalars['String']['input']>;
  method: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notifyAt?: InputMaybe<Scalars['String']['input']>;
  status?: Scalars['String']['input'];
  targetUserCondition?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateScheduledInAppNewsOutput = {
  __typename?: 'CreateScheduledInAppNewsOutput';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateScheduledModalNotificationInput = {
  body: Scalars['String']['input'];
  imageHeightAspectRatio?: InputMaybe<Scalars['Float']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  managementName?: InputMaybe<Scalars['String']['input']>;
  method: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notifyAt?: InputMaybe<Scalars['String']['input']>;
  primaryButtonText?: InputMaybe<Scalars['String']['input']>;
  primaryButtonUrl?: InputMaybe<Scalars['String']['input']>;
  publishEndedAt?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  targetUserCondition?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateScheduledModalNotificationOutput = {
  __typename?: 'CreateScheduledModalNotificationOutput';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  imageHeightAspectRatio?: Maybe<Scalars['Float']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  primaryButtonText?: Maybe<Scalars['String']['output']>;
  primaryButtonUrl?: Maybe<Scalars['String']['output']>;
  publishEndedAt?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CreateScheduledPushNotificationInput = {
  body: Scalars['String']['input'];
  managementName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notificationCategory: Scalars['String']['input'];
  notifyAt?: InputMaybe<Scalars['String']['input']>;
  status?: Scalars['String']['input'];
  targetUserCondition?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateScheduledPushNotificationOutput = {
  __typename?: 'CreateScheduledPushNotificationOutput';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notificationCategory: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateUserSupportMemoInput = {
  content: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type CreateViolationNewsInput = {
  kind: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type CreateViolationNewsOutput = {
  __typename?: 'CreateViolationNewsOutput';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type CurrentDateTicket = {
  __typename?: 'CurrentDateTicket';
  bonusDateTicket: Scalars['Int']['output'];
  purchaseDateTicket: Scalars['Int']['output'];
  totalDateTicket: Scalars['Int']['output'];
};

export type CurrentTicket = {
  __typename?: 'CurrentTicket';
  bonusTicket: Scalars['Int']['output'];
  purchaseTicket: Scalars['Int']['output'];
  totalTicket: Scalars['Int']['output'];
};

export type CurrentUserOffers = {
  __typename?: 'CurrentUserOffers';
  existingNewSale: ExistingNewSale;
  extraGuerrillaCampaignSale: ExtraGuerrillaCampaignSale;
  extraTicketSale: ExtraTicketSaleV2;
  extraTicketSaleOnSubscription: ExtraTicketSaleOnSubscription;
  fiveYenTicketSale: FiveYenTicketSale;
  highIncomeHighMatchSale: HighIncomeHighMatchSale;
  id: Scalars['ID']['output'];
  infiniteWelcomeTicketSale: InfiniteWelcomeTicketSale;
  notImmediateResumeSale: NotImmediateResumeSale;
  secondWelcomeBackSale: SecondWelcomeBackSale;
  secondWelcomeSale: SecondWelcomeSale;
  secondWelcomeTicketSale: SecondWelcomeTicketSale;
  specialSale: SubscriptionSpecialSale;
  starterPackSale: StarterPackSale;
  subSubscriptionSpecialSale: SubSubscriptionSpecialSale;
  subscriptionSpecialSale: SubscriptionSpecialSaleV2;
  trialGold: TrialGold;
  trialTicketSale: TrialTicketSale;
  webSubscriptionUpgradeSale: WebSubscriptionUpgradeSale;
  welcomeBackSale: WelcomeBackSale;
  welcomeSale: WelcomeSale;
};

export type CursorPageInfo = {
  __typename?: 'CursorPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type DateTicketHistoryItem = {
  __typename?: 'DateTicketHistoryItem';
  changeValueOfBonus?: Maybe<Scalars['Int']['output']>;
  changeValueOfPurchase?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  expiredAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DebugAbTestOutput = {
  __typename?: 'DebugAbTestOutput';
  currentVariant: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /** 管理画面で全員に固定しているvariant。設定中は上書きできない */
  forceVariant?: Maybe<Scalars['String']['output']>;
  overrideVariant?: Maybe<Scalars['String']['output']>;
  testKey: Scalars['String']['output'];
};

export const DebugAbTestVariant = {
  A: 'A',
  Auto: 'Auto',
  B: 'B'
} as const;

export type DebugAbTestVariant = typeof DebugAbTestVariant[keyof typeof DebugAbTestVariant];
export const DebugAutoAppealType = {
  AutoExistingNew: 'AutoExistingNew',
  AutoNew: 'AutoNew',
  AutoNotImmediateResume: 'AutoNotImmediateResume',
  AutoResume: 'AutoResume'
} as const;

export type DebugAutoAppealType = typeof DebugAutoAppealType[keyof typeof DebugAutoAppealType];
export type DebugFiveYenTicketSaleTargetOutput = {
  __typename?: 'DebugFiveYenTicketSaleTargetOutput';
  isTarget: Scalars['Boolean']['output'];
  reasons: Array<Scalars['String']['output']>;
};

export const DebugIncomingLikeType = {
  HyperLike: 'HyperLike',
  MessageLike: 'MessageLike',
  NormalLike: 'NormalLike',
  SuperLike: 'SuperLike',
  UltraLike: 'UltraLike'
} as const;

export type DebugIncomingLikeType = typeof DebugIncomingLikeType[keyof typeof DebugIncomingLikeType];
export type DebugLoginOutput = {
  __typename?: 'DebugLoginOutput';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export const DebugMemberStatus = {
  Free: 'Free',
  Gold: 'Gold',
  Ladies: 'Ladies',
  Platinum: 'Platinum'
} as const;

export type DebugMemberStatus = typeof DebugMemberStatus[keyof typeof DebugMemberStatus];
export type DebugOperatorLoginOutput = {
  __typename?: 'DebugOperatorLoginOutput';
  /** 社内ログインした社員のメールアドレス。共通パスワードでログインした場合はdebug-password-login */
  email: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  /** デバッグAPIのリクエストでx-debug-operator-tokenヘッダーに送る、社内ログインした社員のトークン */
  token: Scalars['String']['output'];
};

export const DebugPaymentRoute = {
  App: 'App',
  HelloPay: 'HelloPay',
  Web: 'Web'
} as const;

export type DebugPaymentRoute = typeof DebugPaymentRoute[keyof typeof DebugPaymentRoute];
export type DebugPickupCountsOutput = {
  __typename?: 'DebugPickupCountsOutput';
  pickupCount: Scalars['Int']['output'];
  preloadContinuousPickupCount: Scalars['Int']['output'];
};

export type DebugProfileOutput = {
  __typename?: 'DebugProfileOutput';
  birthday: Scalars['Date']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  gender: Scalars['Gender']['output'];
  income: Scalars['IncomeEnum']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export const DebugSaleType = {
  FiveYenTicket: 'FiveYenTicket',
  InfiniteWelcomeTicket: 'InfiniteWelcomeTicket',
  NotImmediateResume: 'NotImmediateResume',
  SecondWelcomeBack: 'SecondWelcomeBack',
  SecondWelcomeSubscription: 'SecondWelcomeSubscription',
  SecondWelcomeTicket: 'SecondWelcomeTicket',
  WelcomeBack: 'WelcomeBack',
  WelcomeSubscription: 'WelcomeSubscription',
  WelcomeTicket: 'WelcomeTicket'
} as const;

export type DebugSaleType = typeof DebugSaleType[keyof typeof DebugSaleType];
export type DebugUserEmailAnonymizationCandidateOutput = {
  __typename?: 'DebugUserEmailAnonymizationCandidateOutput';
  anonymizedEmail: Scalars['String']['output'];
  currentEmail: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type DebugUserEmailAnonymizationCandidatesOutput = {
  __typename?: 'DebugUserEmailAnonymizationCandidatesOutput';
  items: Array<DebugUserEmailAnonymizationCandidateOutput>;
  totalCount: Scalars['Int']['output'];
};

export type DebugUserEmailAnonymizationResultOutput = {
  __typename?: 'DebugUserEmailAnonymizationResultOutput';
  updatedCount: Scalars['Int']['output'];
};

export type DebugUserInfoOutput = {
  __typename?: 'DebugUserInfoOutput';
  id: Scalars['Int']['output'];
  isMatched: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type DebugUserLifecycleCandidateOutput = {
  __typename?: 'DebugUserLifecycleCandidateOutput';
  gender: Scalars['Gender']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isFallback: Scalars['Boolean']['output'];
  type: UserLifecycleType;
  userId?: Maybe<Scalars['Int']['output']>;
};

export const DebugUserStatus = {
  Active: 'Active',
  Ban: 'Ban',
  Failed: 'Failed',
  FailedWithdrawn: 'FailedWithdrawn',
  IncomeUnconfirmed: 'IncomeUnconfirmed',
  Passed: 'Passed',
  Rescreening: 'Rescreening',
  Screening: 'Screening',
  Suspend: 'Suspend',
  Unidentified: 'Unidentified',
  Unscreened: 'Unscreened',
  Withdrawn: 'Withdrawn'
} as const;

export type DebugUserStatus = typeof DebugUserStatus[keyof typeof DebugUserStatus];
export type DeleteScreeningScoresInput = {
  targetUserId: Scalars['Int']['input'];
};

export type EmailInput = {
  email: Scalars['String']['input'];
};

export type EnumHasOrder = {
  __typename?: 'EnumHasOrder';
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type ExistingNewSale = {
  __typename?: 'ExistingNewSale';
  bannerImageUrl: Scalars['String']['output'];
  carouselBannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isWebHalfPrice: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
  textForWebBanner: Scalars['String']['output'];
};

export type ExtraGuerrillaCampaignSale = {
  __typename?: 'ExtraGuerrillaCampaignSale';
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
};

export type ExtraTicketSaleOnSubscription = {
  __typename?: 'ExtraTicketSaleOnSubscription';
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isHighIncomeTarget: Scalars['Boolean']['output'];
  isLowIncomeTargetOver30: Scalars['Boolean']['output'];
  isLowIncomeTargetUnder30: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
};

export type ExtraTicketSaleV2 = {
  __typename?: 'ExtraTicketSaleV2';
  bannerImageUrl: Scalars['String']['output'];
  campaignBonuses?: Maybe<Array<TicketSaleBonus>>;
  campaignDueDate: Scalars['Date']['output'];
  campaignTargetTicketKind?: Maybe<Array<Scalars['Int']['output']>>;
  campaignTextForBanner: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isCampaignAvailable: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
};

export type FacebookAdsInput = {
  appPackageName: Scalars['String']['input'];
  appVersion: Scalars['String']['input'];
  buildNumber: Scalars['String']['input'];
  carrier: Scalars['String']['input'];
  deviceModelName: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
  freeDiskSpaceGb: Scalars['Float']['input'];
  madid: Scalars['String']['input'];
  osVersion: Scalars['String']['input'];
  platformType: Scalars['PlatformType']['input'];
  screenDensity: Scalars['String']['input'];
  screenHeight: Scalars['Float']['input'];
  screenWidth: Scalars['Float']['input'];
  totalDiskSpaceGb: Scalars['Float']['input'];
  value: Scalars['Int']['input'];
};

export type FailCelebrityCertificationButPassUserInput = {
  celebrityCertificationId: Scalars['Int']['input'];
  failedReason: Scalars['String']['input'];
  notificationFailedMessage: Scalars['String']['input'];
};

export type FailCelebrityCertificationInput = {
  celebrityCertificationId: Scalars['Int']['input'];
  failedReason: Scalars['String']['input'];
  notificationFailedMessage: Scalars['String']['input'];
};

export type FeatureFlagSetting = {
  __typename?: 'FeatureFlagSetting';
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  endAt?: Maybe<Scalars['Date']['output']>;
  key: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  startAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedByAdministratorId?: Maybe<Scalars['Int']['output']>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  featureFlagAmbassadorCP20250822: Scalars['Boolean']['output'];
  featureFlagAmbassadorCampaign: Scalars['Boolean']['output'];
  featureFlagAmbassadorStampToTicket: Scalars['Boolean']['output'];
  featureFlagFreeSuperLikeForSuperLikeInactiveUser: Scalars['Boolean']['output'];
  featureFlagGiftApplication: Scalars['Boolean']['output'];
  /** @deprecated Gold会員向けに恒久開放済み。旧アプリ互換のため常にtrue */
  featureFlagGoldSearchSort: Scalars['Boolean']['output'];
  featureFlagMynaSingleCertificationMaintenance: Scalars['Boolean']['output'];
  featureFlagPlatinumPlanEnhancement: Scalars['Boolean']['output'];
  featureFlagWebPaymentError: Scalars['Boolean']['output'];
  featureSkipIncome: Scalars['Boolean']['output'];
  flagRegisteringUserPushNotification: Scalars['Boolean']['output'];
};

export type FeatureFlagsForUser = {
  __typename?: 'FeatureFlagsForUser';
  enableEmailOptOutSettings: Scalars['Boolean']['output'];
  featureFlagAIScreeningProfileImage: Scalars['Boolean']['output'];
  /** @deprecated 終了済み機能。旧アプリ互換のため一時的に維持 */
  featureFlagActiveSomeoneId: Scalars['Float']['output'];
  /** @deprecated This flag will be removed soon. Please avoid using it in new code. */
  featureFlagAmbassadorCampaign: Scalars['Boolean']['output'];
  featureFlagAppeal: Scalars['Boolean']['output'];
  featureFlagApplySticker: Scalars['Boolean']['output'];
  /** @deprecated 著名人バッジのオンオフ機能安定稼働後に削除 */
  featureFlagCelebrityBadgeVisibleSetting: Scalars['Boolean']['output'];
  featureFlagCelebrityCertification: Scalars['Boolean']['output'];
  featureFlagContinuousPickup: Scalars['Boolean']['output'];
  featureFlagEarlyScreeningImage: Scalars['Boolean']['output'];
  featureFlagExtraGuerrillaCampaign: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  featureFlagExtraTicketSale20241220: Scalars['Boolean']['output'];
  featureFlagGWAppealEffectUp2026: Scalars['Boolean']['output'];
  featureFlagGoldToPlatinumUpgradeBanner: Scalars['Boolean']['output'];
  featureFlagGorgeousDate: Scalars['Boolean']['output'];
  featureFlagGorgeousDateCancelMatchPenalty: Scalars['Boolean']['output'];
  featureFlagGorgeousDateNewCondition: Scalars['Boolean']['output'];
  featureFlagGorgeousDateNewFlow: Scalars['Boolean']['output'];
  featureFlagGorgeousJumbo: Scalars['Boolean']['output'];
  featureFlagHobbyTagCommonHighlight: Scalars['Boolean']['output'];
  featureFlagInitialSubscriptionTutorial: Scalars['Boolean']['output'];
  featureFlagIsLineLinked: Scalars['Boolean']['output'];
  featureFlagLadiesPlan: Scalars['Boolean']['output'];
  featureFlagLadiesPlaneCampaign: Scalars['Boolean']['output'];
  featureFlagLineLinkCampaign: Scalars['Boolean']['output'];
  featureFlagListPromotion: Scalars['Boolean']['output'];
  featureFlagMessageListHeader: Scalars['Boolean']['output'];
  /** @deprecated 統合やりとり画面へ移行済み。旧アプリの参照状況を計測後に削除予定 */
  featureFlagMessageListSplitTab: Scalars['Boolean']['output'];
  featureFlagMessageRealtimeRtdb: Scalars['Boolean']['output'];
  featureFlagMynaIncomeConfirmation: Scalars['Boolean']['output'];
  featureFlagMynaSingleCertification: Scalars['Boolean']['output'];
  featureFlagOnboardingBonusTicket: Scalars['Boolean']['output'];
  featureFlagOnlineStatus: Scalars['Boolean']['output'];
  featureFlagPickupAdd: Scalars['Boolean']['output'];
  featureFlagPlatinumPlan: Scalars['Boolean']['output'];
  featureFlagPlatinumPlanEnhancement: Scalars['Boolean']['output'];
  featureFlagPlatinumTicketBonus: Scalars['Boolean']['output'];
  featureFlagPreferencePrefecture: Scalars['Boolean']['output'];
  /** @deprecated メッセのSSE同期は廃止済み。旧アプリがSSEにつながないようfalseを返す */
  featureFlagRealtimeSync: Scalars['Boolean']['output'];
  featureFlagRecommendTab: Scalars['Boolean']['output'];
  featureFlagReferralComment: Scalars['Boolean']['output'];
  featureFlagReferralLimitUnlock: Scalars['Boolean']['output'];
  featureFlagRequireIdentificationSelfie: Scalars['Boolean']['output'];
  featureFlagSearchHigherLikeAppeal: Scalars['Boolean']['output'];
  featureFlagSearchRecommendSections: Scalars['Boolean']['output'];
  featureFlagSearchUser: Scalars['Boolean']['output'];
  featureFlagSeasonalReferralCampaign: Scalars['Boolean']['output'];
  featureFlagSimilarUsers: Scalars['Boolean']['output'];
  /** @deprecated 終了済み機能。旧アプリ互換のため一時的に維持 */
  featureFlagSomeoneGG: Scalars['Boolean']['output'];
  featureFlagSpecialPickupIncrease: Scalars['Boolean']['output'];
  featureFlagSubscriptionSpecialSaleCampaign: Scalars['Boolean']['output'];
  featureFlagTicketIncreaseSale20250718: Scalars['Boolean']['output'];
  featureFlagTicketPurchaseToWeb: Scalars['Boolean']['output'];
  featureFlagTopGorgeous: Scalars['Boolean']['output'];
  featureFlagTopPicks: Scalars['Boolean']['output'];
  featureFlagTopPicksBulkLike: Scalars['Boolean']['output'];
  featureFlagTrustMode: Scalars['Boolean']['output'];
  /** @deprecated QuickTrustは提供終了。旧アプリ互換のため常にfalseを返し、参照状況を計測後に削除予定 */
  featureFlagUseQuickTrustIdentification: Scalars['Boolean']['output'];
  featureFlagVideoCallClarity: Scalars['Boolean']['output'];
  featureFlagWebSubscription: Scalars['Boolean']['output'];
  featureFlagWebSubscriptionInitialDiscount: Scalars['Boolean']['output'];
  featureFlagWebSubscriptionUpgradePlan: Scalars['Boolean']['output'];
  featureFlagWelcomeBackSale24hoursLimited: Scalars['Boolean']['output'];
  featureFlagWelcomeSaleImageOnlyModal: Scalars['Boolean']['output'];
  featureFlagWomanToManSearchNormalLikeOneTicket: Scalars['Boolean']['output'];
};

export type FindProfileImageOutput = {
  __typename?: 'FindProfileImageOutput';
  resizedProfileImages: Array<ResizedProfileImage>;
  userId: Scalars['Int']['output'];
};

export type FindProfileImagesInput = {
  userIds: Array<Scalars['Int']['input']>;
};

export type FirebaseConfigInput = {
  config?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type FiveYenTicketSale = {
  __typename?: 'FiveYenTicketSale';
  bannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
  ticketCtaImageHeightAspectRatio: Scalars['Float']['output'];
  ticketCtaImageUrl: Scalars['String']['output'];
};

export type Footprint = {
  __typename?: 'Footprint';
  createdAt: Scalars['Date']['output'];
  fromUser: OtherUser;
  id: Scalars['Int']['output'];
};

export type FootprintsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
};

export type FootprintsOutput = {
  __typename?: 'FootprintsOutput';
  footprints: Array<Footprint>;
  pageInfo: CursorPageInfo;
};

export type GetAutoScreeningInfoOutput = {
  __typename?: 'GetAutoScreeningInfoOutput';
  shouldSkipScreeningImage: Scalars['Boolean']['output'];
};

export type GetLatestLegalDocumentAgreementStatusesOutput = {
  __typename?: 'GetLatestLegalDocumentAgreementStatusesOutput';
  allAgreed: Scalars['Boolean']['output'];
  documents: Array<LegalDocumentStatus>;
};

export type GetMatchedUsersHavingMessageOutput = {
  __typename?: 'GetMatchedUsersHavingMessageOutput';
  pageInfo: PageInfo;
  users: Array<User>;
};

export type GetMatchedUsersHavingMessagesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetOtherUserInput = {
  userId: Scalars['Int']['input'];
};

export type GetProfileItemForOthersOutput = {
  __typename?: 'GetProfileItemForOthersOutput';
  collectedWorkForOthers?: Maybe<ProfileItemWithScreening>;
  companyNameForMe?: Maybe<ProfileItemWithScreening>;
  companyNameForOthers?: Maybe<ProfileItemWithScreening>;
  favoriteAlcoholForOthers?: Maybe<ProfileItemWithScreening>;
  favoriteBrandForOthers?: Maybe<ProfileItemWithScreening>;
  favoriteFoodForOthers?: Maybe<ProfileItemWithScreening>;
  favoriteLuxuryItemForOthers?: Maybe<ProfileItemWithScreening>;
  goodCountryForOthers?: Maybe<ProfileItemWithScreening>;
  goodStoreForOthers?: Maybe<ProfileItemWithScreening>;
  hobbyForOthers?: Maybe<ProfileItemWithScreening>;
  jobDetailForOthers?: Maybe<ProfileItemWithScreening>;
  ownedVehicleForOthers?: Maybe<ProfileItemWithScreening>;
  qualificationForOthers?: Maybe<ProfileItemWithScreening>;
};

export type GetRewardCodeOutput = {
  __typename?: 'GetRewardCodeOutput';
  campaignCodes: Array<CampaignCode>;
  isReferred: Scalars['Boolean']['output'];
};

export type GetScheduledEmailNotificationListOutput = {
  __typename?: 'GetScheduledEmailNotificationListOutput';
  items: Array<ScheduledEmailNotificationItem>;
  totalCount: Scalars['Int']['output'];
};

export type GetScheduledEmailNotificationOutput = {
  __typename?: 'GetScheduledEmailNotificationOutput';
  createdAt: Scalars['Date']['output'];
  dynamicTemplateData: Scalars['String']['output'];
  emailName: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  forceSendFlg: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAdvertisingEmail: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type GetScheduledInAppNewsListOutput = {
  __typename?: 'GetScheduledInAppNewsListOutput';
  items: Array<ScheduledInAppNewsListItem>;
  totalCount: Scalars['Int']['output'];
};

export type GetScheduledInAppNewsOutput = {
  __typename?: 'GetScheduledInAppNewsOutput';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type GetScheduledModalNotificationListOutput = {
  __typename?: 'GetScheduledModalNotificationListOutput';
  items: Array<ScheduledModalNotificationItem>;
  totalCount: Scalars['Float']['output'];
};

export type GetScheduledModalNotificationOutput = {
  __typename?: 'GetScheduledModalNotificationOutput';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Float']['output'];
  imageHeightAspectRatio?: Maybe<Scalars['Float']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  primaryButtonText?: Maybe<Scalars['String']['output']>;
  primaryButtonUrl?: Maybe<Scalars['String']['output']>;
  publishEndedAt?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type GetScheduledNotificationListInput = {
  limit?: Scalars['Int']['input'];
  managementName?: InputMaybe<Scalars['String']['input']>;
  notificationType?: InputMaybe<ScheduledNotificationTypeEnum>;
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: Scalars['String']['input'];
  status?: InputMaybe<ScheduledNotificationStatusEnum>;
  tab?: Scalars['String']['input'];
};

export type GetScheduledNotificationListOutput = {
  __typename?: 'GetScheduledNotificationListOutput';
  items: Array<ScheduledNotificationListItem>;
  sentOrExpiredCount?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  unsentCount?: Maybe<Scalars['Int']['output']>;
};

export type GetScheduledPushNotificationListOutput = {
  __typename?: 'GetScheduledPushNotificationListOutput';
  items: Array<ScheduledPushNotificationItem>;
  totalCount: Scalars['Int']['output'];
};

export type GetScheduledPushNotificationOutput = {
  __typename?: 'GetScheduledPushNotificationOutput';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notificationCategory: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type GetUserGorgeousJumboTicketsCountByRoundInput = {
  round: Scalars['Int']['input'];
};

export type GetUserGorgeousJumboTicketsCountOutput = {
  __typename?: 'GetUserGorgeousJumboTicketsCountOutput';
  count?: Maybe<Scalars['Int']['output']>;
};

export type GiftCatalog = {
  __typename?: 'GiftCatalog';
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pointsRequired: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type GorgeousJumbo = {
  __typename?: 'GorgeousJumbo';
  id: Scalars['Int']['output'];
};

export type GrantBonusTicketFromCsInput = {
  amount: Scalars['Int']['input'];
  expiredAt?: InputMaybe<Scalars['Date']['input']>;
  platform: Scalars['PlatformType']['input'];
  userId: Scalars['Int']['input'];
};

export type HelloPaySubscription = {
  __typename?: 'HelloPaySubscription';
  cancelText?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  helloPayCardId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isPastDue: Scalars['Boolean']['output'];
  isUnderReview: Scalars['Boolean']['output'];
  productId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type HighIncomeHighMatchSale = {
  __typename?: 'HighIncomeHighMatchSale';
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
};

export type HobbyTag = {
  __typename?: 'HobbyTag';
  hobbyTagCategoryId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type HobbyTagCategory = {
  __typename?: 'HobbyTagCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type IdentificationImage = {
  __typename?: 'IdentificationImage';
  createdAt?: Maybe<Scalars['Date']['output']>;
  failedReason: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  methodType: Scalars['String']['output'];
  status?: Maybe<Scalars['ScreeningStatus']['output']>;
  type: Scalars['ScreeningImageType']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type IncomeCertificationProgressOutput = {
  __typename?: 'IncomeCertificationProgressOutput';
  errorReason: Scalars['Float']['output'];
  status: Scalars['Float']['output'];
};

export type IncomeConfirmationImage = {
  __typename?: 'IncomeConfirmationImage';
  createdAt?: Maybe<Scalars['Date']['output']>;
  failedReason: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  methodType: Scalars['String']['output'];
  status?: Maybe<Scalars['ScreeningStatus']['output']>;
  type: Scalars['ScreeningImageType']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type IncomeObject = {
  __typename?: 'IncomeObject';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  income: Scalars['IncomeEnum']['output'];
  status: Scalars['ScreeningStatus']['output'];
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
};

export type InfiniteWelcomeTicketSale = {
  __typename?: 'InfiniteWelcomeTicketSale';
  bannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isDiscountTarget: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
};

export type Inquiry = {
  __typename?: 'Inquiry';
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type InquiryCreateInput = {
  category: Scalars['String']['input'];
  content: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type InterestedUserInput = {
  targetUserId: Scalars['Int']['input'];
};

export type InterestedUserOutput = {
  __typename?: 'InterestedUserOutput';
  id: Scalars['Int']['output'];
  targetUser: OtherUser;
};

export type InterestedUsersInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<MyLikeListSortType>;
};

export type InterestedUsersListOutput = {
  __typename?: 'InterestedUsersListOutput';
  interestedUsers: Array<InterestedUserOutput>;
  pageInfo: PageInfo;
};

export type InviteAdministratorInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role?: InputMaybe<AdministratorRole>;
};

export type IssueRefreshTokenResponse = {
  __typename?: 'IssueRefreshTokenResponse';
  refreshToken: Scalars['String']['output'];
};

export type JobCategory = {
  __typename?: 'JobCategory';
  createdAt: Scalars['Date']['output'];
  deprecatedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  profiles?: Maybe<Array<Profile>>;
  updatedAt: Scalars['Date']['output'];
};

export type JobCertificationImage = {
  __typename?: 'JobCertificationImage';
  createdAt?: Maybe<Scalars['Date']['output']>;
  failedReason: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  methodType: Scalars['String']['output'];
  status?: Maybe<Scalars['ScreeningStatus']['output']>;
  type: Scalars['ScreeningImageType']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type JoinTodayAvailabilityInput = {
  day: Scalars['String']['input'];
  maximumTicketCount?: InputMaybe<Scalars['Int']['input']>;
};

export type LatestUncommentedAmbassadorReferralOutput = {
  __typename?: 'LatestUncommentedAmbassadorReferralOutput';
  ambassadorReferral?: Maybe<AmbassadorReferralWithOpponentUser>;
};

export type LegalDocumentStatus = {
  __typename?: 'LegalDocumentStatus';
  agreed: Scalars['Boolean']['output'];
  legalDocumentId?: Maybe<Scalars['Int']['output']>;
  legalDocumentType?: Maybe<LegalDocumentTypeEnum>;
};

export const LegalDocumentTypeEnum = {
  PrivacyPolicy: 'PrivacyPolicy',
  TermsOfService: 'TermsOfService'
} as const;

export type LegalDocumentTypeEnum = typeof LegalDocumentTypeEnum[keyof typeof LegalDocumentTypeEnum];
export type LikeFromInterestedListInput = {
  approachMessage?: InputMaybe<Scalars['String']['input']>;
  approachType: Scalars['String']['input'];
  targetUserId: Scalars['Int']['input'];
};

export type LikeFromInterestedListOutput = {
  __typename?: 'LikeFromInterestedListOutput';
  approachType: Scalars['ApproachType']['output'];
  hasGivenBonusTicket: Scalars['Boolean']['output'];
  isFirstMatch: Scalars['Boolean']['output'];
  isMatched: Scalars['Boolean']['output'];
  match?: Maybe<Match>;
};

export type LikeFromTodayAvailabilityInput = {
  approachMessage?: InputMaybe<Scalars['String']['input']>;
  approachType: Scalars['ApproachType']['input'];
  day: Scalars['String']['input'];
  targetUserId: Scalars['Int']['input'];
};

export type ListPromotion = {
  __typename?: 'ListPromotion';
  cardImageUrl: Scalars['String']['output'];
  cardTitle: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ListPromotionSettings = {
  __typename?: 'ListPromotionSettings';
  activeListPromotions: Array<ListPromotion>;
  id: Scalars['Int']['output'];
  showInterval: Scalars['Int']['output'];
  startShowingIndex: Scalars['Int']['output'];
};

export const LoginProviderEnum = {
  Apple: 'Apple',
  Line: 'Line',
  Phone: 'Phone'
} as const;

export type LoginProviderEnum = typeof LoginProviderEnum[keyof typeof LoginProviderEnum];
export type LoginWithAppleInput = {
  idToken: Scalars['String']['input'];
};

export type LoginWithLineInput = {
  idToken: Scalars['String']['input'];
};

export type LoginWithPhoneInput = {
  phoneNumber: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type LoginWithTokenInput = {
  adjustDeviceId?: InputMaybe<Scalars['String']['input']>;
  advertisingId?: InputMaybe<Scalars['String']['input']>;
  appInstanceId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  hasPushNotifyPermission?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrackingPermission?: InputMaybe<Scalars['Boolean']['input']>;
  lastAccessedAt?: InputMaybe<Scalars['Date']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['PlatformType']['input']>;
};

export type MaintenanceStatus = {
  __typename?: 'MaintenanceStatus';
  isUnderMaintenance: Scalars['Boolean']['output'];
};

export type MarkMessagesAsReadInput = {
  matchId: Scalars['Int']['input'];
  messageIds: Array<Scalars['Int']['input']>;
};

export type Match = {
  __typename?: 'Match';
  agoraChannelName?: Maybe<Scalars['String']['output']>;
  approachType: Scalars['ApproachType']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  firstJudgedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  lastApproachedAt?: Maybe<Scalars['Date']['output']>;
  messages?: Maybe<Array<Message>>;
  passedApproachMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['MatchStatus']['output'];
  targetUser?: Maybe<User>;
  targetUserId: Scalars['Int']['output'];
  targetUserUnreadCount: Scalars['Int']['output'];
  todayAvailabilityExpiresAt?: Maybe<Scalars['Date']['output']>;
  ultraLikeResendableAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  userUnreadCount: Scalars['Int']['output'];
};

export const MatchTimeLimitFilterEnum = {
  Active: 'Active',
  All: 'All',
  Expired: 'Expired'
} as const;

export type MatchTimeLimitFilterEnum = typeof MatchTimeLimitFilterEnum[keyof typeof MatchTimeLimitFilterEnum];
export type MatchWithOpponentUser = {
  __typename?: 'MatchWithOpponentUser';
  approachType: Scalars['String']['output'];
  assignedNickname?: Maybe<Scalars['String']['output']>;
  firstJudgedAt?: Maybe<Scalars['Date']['output']>;
  hasUserMessage: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAccepted: Scalars['Boolean']['output'];
  isBlockedByMe: Scalars['Boolean']['output'];
  isBlockedByOpponent: Scalars['Boolean']['output'];
  isFavorited: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isInactive: Scalars['Boolean']['output'];
  isOverTimeLimit: Scalars['Boolean']['output'];
  isSendMessageAvailable: Scalars['Boolean']['output'];
  isUnviewed: Scalars['Boolean']['output'];
  latestMessage?: Maybe<Message>;
  matchItemKind?: Maybe<Scalars['String']['output']>;
  opponentUser: User;
  opponentUserId: Scalars['Int']['output'];
  passedApproachMessage?: Maybe<PassedApproachMessage>;
  reMatchedAt?: Maybe<Scalars['Date']['output']>;
  timeLimitStatus: Scalars['String']['output'];
  todayAvailabilityExpiresAt?: Maybe<Scalars['Date']['output']>;
  unreadMessageCount: Scalars['Int']['output'];
};

export type Message = {
  __typename?: 'Message';
  body?: Maybe<Scalars['String']['output']>;
  bySystem?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<MessageImage>;
  images: Array<MessageImage>;
  match: Match;
  matchId: Scalars['Int']['output'];
  params?: Maybe<Scalars['String']['output']>;
  resizedImage?: Maybe<ResizedMessageImage>;
  resizedImages: Array<ResizedMessageImage>;
  targetUserReadAt?: Maybe<Scalars['Date']['output']>;
  toOnlyUser?: Maybe<User>;
  toOnlyUserId?: Maybe<Scalars['Int']['output']>;
  type: Scalars['MessageType']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  userReadAt?: Maybe<Scalars['Date']['output']>;
};

export type MessageImage = {
  __typename?: 'MessageImage';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  message?: Maybe<Message>;
  messageId: Scalars['Int']['output'];
  path?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MessageLikeFromTopPicksInput = {
  approachMessage: Scalars['String']['input'];
  fromScreenName?: InputMaybe<Scalars['String']['input']>;
  targetUserId: Scalars['Int']['input'];
};

export type MessageLikeInput = {
  approachMessage: Scalars['String']['input'];
  fromScreenName?: InputMaybe<Scalars['String']['input']>;
  recommendContentType?: InputMaybe<RecommendContentType>;
  targetUserId: Scalars['Int']['input'];
};

export const MessageListFilterEnum = {
  All: 'All',
  Favorite: 'Favorite',
  Unread: 'Unread'
} as const;

export type MessageListFilterEnum = typeof MessageListFilterEnum[keyof typeof MessageListFilterEnum];
export type MessageOrderByInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  matchId?: InputMaybe<Scalars['String']['input']>;
  receivedUserId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MessageReadStatus = {
  __typename?: 'MessageReadStatus';
  id: Scalars['Int']['output'];
  targetUserReadAt?: Maybe<Scalars['Date']['output']>;
  userReadAt?: Maybe<Scalars['Date']['output']>;
};

export type MessageWhereInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['Int']['input']>;
  receivedUserId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageWithSignedImageUrl = {
  __typename?: 'MessageWithSignedImageUrl';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  matchId: Scalars['Int']['output'];
  receivedUserId: Scalars['Int']['output'];
  signedImageUrl?: Maybe<Scalars['String']['output']>;
  signedImageUrls: Array<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type MessagesWithSignedImageUrlOutput = {
  __typename?: 'MessagesWithSignedImageUrlOutput';
  messages: Array<MessageWithSignedImageUrl>;
  totalCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptFromRejectedList?: Maybe<SwipeOutput>;
  addInterestedUser: Scalars['Boolean']['output'];
  advanceDebugMatchTime: Scalars['Boolean']['output'];
  agreeToLegalDocument?: Maybe<Scalars['Boolean']['output']>;
  allowScreenshot?: Maybe<Scalars['Boolean']['output']>;
  anonymizeDebugUserEmails: DebugUserEmailAnonymizationResultOutput;
  answerVideoCall: VideoCallSession;
  applyForCelebrityCertification: Scalars['Boolean']['output'];
  applyForScreeningV2?: Maybe<Scalars['Boolean']['output']>;
  applyRewardCode: ValidateRewardCodeOutput;
  applySticker: StickerApplication;
  approveIdentificationForDev?: Maybe<Scalars['Boolean']['output']>;
  assignPushPermissionAbGroup: TmpUser;
  authenticateWithPhone: PhoneAuthOutput;
  banUser?: Maybe<Scalars['Boolean']['output']>;
  blockUser?: Maybe<Scalars['Boolean']['output']>;
  bulkDisableReferralCodes?: Maybe<Scalars['Boolean']['output']>;
  bulkLikeTopPicks: TopPicksBulkLikeOutput;
  bulkRejectPassedSelfIntroductionStatus?: Maybe<Scalars['Boolean']['output']>;
  bulkRejectUser?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateApproachMessageStatus?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateHobbyTagStatus?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateProfileImageStatus?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateProfileItemWithScreeningStatus?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateScreeningImageStatus?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateSelfIntroductionStatus?: Maybe<Scalars['Boolean']['output']>;
  callVideo: VideoCallSession;
  cancelVideoCall: VideoCall;
  clearPushToken?: Maybe<Scalars['Boolean']['output']>;
  closePickupAlert: Scalars['Boolean']['output'];
  completeIncomeCertification: CompleteIncomeCertificationOutput;
  completePickupTutorial?: Maybe<Scalars['Boolean']['output']>;
  completeRequestAppReview?: Maybe<Scalars['Boolean']['output']>;
  completeSingleCertification: CompleteSingleCertificationOutput;
  confirmIdentityForIncome: ConfirmIdentityForIncomeOutput;
  confirmSingleCertificationIdentity: ConfirmIdentityOutput;
  connectVideoCall: VideoCall;
  consumeFreeSuperLikeForInactiveSuperLikeUserFromPickup: SwipeOutput;
  continuousPickupUsers: TodaysPickupUsersOutput;
  createAmbassadorReferralComment?: Maybe<Scalars['Boolean']['output']>;
  createAppReview: Scalars['Boolean']['output'];
  createCommonSale: Campaign;
  createDebugIncomingFootprint: Scalars['Boolean']['output'];
  createDebugIncomingLike: Scalars['Boolean']['output'];
  createDebugIncomingMessage: Scalars['Boolean']['output'];
  createDebugWebLoginUrl: Scalars['String']['output'];
  createFootprint?: Maybe<Scalars['Boolean']['output']>;
  createForceUpdateSetting: AdminForceUpdateSetting;
  createHobbyTag?: Maybe<Scalars['Boolean']['output']>;
  createInquiry: Inquiry;
  createProfileItemWithScreening?: Maybe<Scalars['Boolean']['output']>;
  createScheduledEmailNotification: CreateScheduledEmailNotificationOutput;
  createScheduledInAppNews: CreateScheduledInAppNewsOutput;
  createScheduledModalNotification: CreateScheduledModalNotificationOutput;
  createScheduledPushNotification: CreateScheduledPushNotificationOutput;
  createUserEventLog?: Maybe<Scalars['Boolean']['output']>;
  createUserHobbyTag?: Maybe<Scalars['Boolean']['output']>;
  createUserSupportMemo: UserSupportMemo;
  createViolationNews: CreateViolationNewsOutput;
  declineVideoCall: VideoCall;
  deferPushPermissionSoftPrompt: TmpUser;
  deleteAbTestConfig: Scalars['Boolean']['output'];
  deleteAdministrator: Scalars['Boolean']['output'];
  deleteCommonSale: Campaign;
  deleteFeatureFlagSetting: Scalars['Boolean']['output'];
  deleteScheduledEmailNotification: Scalars['Boolean']['output'];
  deleteScheduledInAppNews: Scalars['Boolean']['output'];
  deleteScheduledModalNotification: Scalars['Boolean']['output'];
  deleteScheduledPushNotification: Scalars['Boolean']['output'];
  deleteScreeningScores?: Maybe<Scalars['Boolean']['output']>;
  deleteUserHobbyTag?: Maybe<Scalars['Boolean']['output']>;
  detectScreenshot?: Maybe<Scalars['Boolean']['output']>;
  disableEmailDelivery?: Maybe<Scalars['Boolean']['output']>;
  disableGgMarriageMember?: Maybe<Scalars['Boolean']['output']>;
  disallowScreenshot?: Maybe<Scalars['Boolean']['output']>;
  enableEmailDelivery?: Maybe<Scalars['Boolean']['output']>;
  enableGgMarriageMember?: Maybe<Scalars['Boolean']['output']>;
  endVideoCall?: Maybe<Scalars['Boolean']['output']>;
  executeAppeal: Appeal;
  executeFreeAppeal: Appeal;
  executeInitialSubscriptionFreeAppeal: Appeal;
  executeInitialSubscriptionFreeMessageLikeFromPickup: SwipeOutput;
  executeInitialSubscriptionFreeSuperLikeFromPickup: SwipeOutput;
  failCelebrityCertification: Scalars['Boolean']['output'];
  failCelebrityCertificationButPassUser: Scalars['Boolean']['output'];
  /** @deprecated 五円セールは forceStartDebugSale(saleType: FiveYenTicket) で対象者にする */
  forceDebugFiveYenTicketSaleTarget: Scalars['Boolean']['output'];
  forceDebugHelloPayTarget: Scalars['Boolean']['output'];
  forceDebugPopularUser: Scalars['Boolean']['output'];
  forceDebugUserLifecycleType: Scalars['Boolean']['output'];
  forceJoinDebugTodayAvailabilityUsers: Scalars['Int']['output'];
  forceStartDebugAutoAppeal: Scalars['Boolean']['output'];
  /** 自分を対象者にして開始し、開催期間外で開始されないときは false を返す */
  forceStartDebugChanceTime: Scalars['Boolean']['output'];
  /** @deprecated 五円セールは forceStartDebugSale(saleType: FiveYenTicket) で対象者にする */
  forceStartDebugFiveYenTicketSale: Scalars['Boolean']['output'];
  /** 五円セールは自分を対象者にし、開催期間外で表示されないときは false を返す */
  forceStartDebugSale: Scalars['Boolean']['output'];
  freeLikeTopPicks: SwipeOutput;
  generateVideoCallToken: Scalars['String']['output'];
  getNowReceivingAppeals: Array<AppealWithUser>;
  getOrCreateReferralCode: ReferralCode;
  getStart?: Maybe<Scalars['Boolean']['output']>;
  getUnreadActionNews: Array<News>;
  getUnreadActionSpecialNews: Array<News>;
  grantBonusTicketFromCS?: Maybe<Scalars['Boolean']['output']>;
  grantDebugTicket: Scalars['Boolean']['output'];
  hideMatch: Scalars['Boolean']['output'];
  hyperLikeFromMyLikeList?: Maybe<SwipeOutput>;
  inviteAdministrator: Administrator;
  isAllowedAutoPickupSelection: Scalars['Boolean']['output'];
  issueRealtimeToken?: Maybe<Scalars['String']['output']>;
  issueRefreshToken?: Maybe<IssueRefreshTokenResponse>;
  joinTodayAvailability: TodayAvailabilityStatus;
  judgeDebugUserScreening: Scalars['Boolean']['output'];
  likeFromFootprintList?: Maybe<SwipeOutput>;
  likeFromInterestedList: LikeFromInterestedListOutput;
  likeFromTodayAvailability: SwipeOutput;
  linkCelebrityConciergeLine: Scalars['Boolean']['output'];
  linkLineAccountAndGiveTicket: Scalars['Boolean']['output'];
  loginDebugOperatorWithGoogle: DebugOperatorLoginOutput;
  loginDebugOperatorWithPassword: DebugOperatorLoginOutput;
  loginWithApple?: Maybe<AuthOutput>;
  loginWithGoogle: Scalars['String']['output'];
  loginWithLine?: Maybe<AuthOutput>;
  loginWithPhone?: Maybe<AuthOutput>;
  loginWithToken: User;
  markAllApproachMatchesAsRead: Scalars['Boolean']['output'];
  markAllFootprintsAsRead?: Maybe<Scalars['Boolean']['output']>;
  markMatchAsRead: Scalars['Boolean']['output'];
  markMessagesAsRead?: Maybe<Scalars['Boolean']['output']>;
  markNormalNewsAsDetailRead: Scalars['Boolean']['output'];
  messageLike?: Maybe<SwipeOutput>;
  messageLikeFromFootprintList?: Maybe<SwipeOutput>;
  messageLikeFromMyLikeList?: Maybe<SwipeOutput>;
  messageLikeFromRecommend?: Maybe<SwipeOutput>;
  messageLikeFromSearch?: Maybe<SwipeOutput>;
  messageLikeFromTopPicks: SwipeOutput;
  notifyLoverByGorgeousLine: Scalars['Boolean']['output'];
  passCelebrityCertification: Scalars['Boolean']['output'];
  passUser?: Maybe<Scalars['Boolean']['output']>;
  purchaseTicket?: Maybe<Scalars['Boolean']['output']>;
  purchaseTicketOnExtraSale?: Maybe<Scalars['Boolean']['output']>;
  reMatch?: Maybe<Scalars['Boolean']['output']>;
  reactivateUserByAdmin?: Maybe<Scalars['Boolean']['output']>;
  reapplyForScreening: AuthOutput;
  recalculateDebugPickupUsersWithCounts: DebugPickupCountsOutput;
  recalculateDebugTopPicks: Scalars['Int']['output'];
  refreshAccessToken?: Maybe<RefreshAccessTokenResponse>;
  registerOptionalProfile?: Maybe<Scalars['Boolean']['output']>;
  rejectUser?: Maybe<Scalars['Boolean']['output']>;
  removeAmbassadorReferralComment?: Maybe<Scalars['Boolean']['output']>;
  removeIncomeScreeningImageForStorage?: Maybe<Scalars['Boolean']['output']>;
  removeInterestedUser: Scalars['Boolean']['output'];
  removeJobScreeningImageForStorage?: Maybe<Scalars['Boolean']['output']>;
  removeProfileImage?: Maybe<Scalars['Boolean']['output']>;
  reportUser?: Maybe<Scalars['Boolean']['output']>;
  reportVideoCallCallerLeft: VideoCall;
  requestIdentificationRescreening?: Maybe<Scalars['Boolean']['output']>;
  resetDebugChanceTime: Scalars['Boolean']['output'];
  /** @deprecated 五円セールは forceStartDebugSale(saleType: FiveYenTicket) で対象者にする */
  resetDebugFiveYenTicketSale: Scalars['Boolean']['output'];
  resetDebugSales: Scalars['Boolean']['output'];
  resetDebugTicket: Scalars['Boolean']['output'];
  resetDebugTodayAvailability: Scalars['Boolean']['output'];
  resolveHelloPaySubscriptionPayment: Scalars['Boolean']['output'];
  restoreForceUpdateSetting: AdminForceUpdateSetting;
  restoreIncome?: Maybe<Scalars['Boolean']['output']>;
  restorePurchase: Scalars['Boolean']['output'];
  rotateAccessToken: RotateAccessTokenResponse;
  runCampaignNotifyJob: Scalars['Boolean']['output'];
  selectPickupUsers: TodaysPickupUsersOutput;
  sendAppSubscriptionToWebEmail: Scalars['Boolean']['output'];
  sendAppSubscriptionUpgradeToWebEmail: Scalars['Boolean']['output'];
  sendFacebookAdsEvent: Scalars['Boolean']['output'];
  sendMessage?: Maybe<Array<Scalars['Boolean']['output']>>;
  sendScheduledNotificationTest: Scalars['Boolean']['output'];
  sendTicketPurchaseToWebEmail?: Maybe<Scalars['Boolean']['output']>;
  sendVerificationCode: Scalars['Boolean']['output'];
  sendVerificationCodeToEmail: Scalars['Boolean']['output'];
  setCommonSaleActive: Campaign;
  shadowBanUser?: Maybe<Scalars['Boolean']['output']>;
  shortenDebugChanceTime: Scalars['Boolean']['output'];
  /** @deprecated 五円セールの残り時間の短縮は廃止した */
  shortenDebugFiveYenTicketSale: Scalars['Boolean']['output'];
  signUp: AuthOutput;
  signUpWithApple: AuthOutput;
  signUpWithLine: AuthOutput;
  signUpWithPhone: AuthOutput;
  startIncomeCertification: StartIncomeCertificationOutput;
  startSingleCertification: StartSingleCertificationOutput;
  startVideoCall: VideoCall;
  submitIncomeScreeningImages?: Maybe<Scalars['Boolean']['output']>;
  submitJobScreeningImages?: Maybe<Scalars['Boolean']['output']>;
  superLike?: Maybe<SwipeOutput>;
  superLikeFromFootprintList?: Maybe<SwipeOutput>;
  superLikeFromMyLikeList?: Maybe<SwipeOutput>;
  superLikeFromRecommend?: Maybe<SwipeOutput>;
  superLikeFromSearch?: Maybe<SwipeOutput>;
  superLikeTopPicks: SwipeOutput;
  suspendUser?: Maybe<Scalars['Boolean']['output']>;
  swipe?: Maybe<SwipeOutput>;
  swipeLikeFromReceivingAppeal?: Maybe<SwipeOutput>;
  swipeLikeFromRecommend?: Maybe<SwipeOutput>;
  swipeLikeFromSearch?: Maybe<SwipeOutput>;
  swipeTopPicks: SwipeOutput;
  switchDebugLoginUser: DebugLoginOutput;
  syncSubscription: Scalars['Boolean']['output'];
  testResetPickup: Scalars['String']['output'];
  testSelectPickupUsers: TestTodaysPickupUsersOutput;
  testSwipe?: Maybe<SwipeOutput>;
  toggleFavoriteMatch?: Maybe<Scalars['Boolean']['output']>;
  ultraLikeFromMyLikeList?: Maybe<SwipeOutput>;
  unbanUser?: Maybe<Scalars['Boolean']['output']>;
  undoReject?: Maybe<Scalars['Boolean']['output']>;
  undoSkip?: Maybe<Scalars['Boolean']['output']>;
  unhideMatch: Scalars['Boolean']['output'];
  unsuspendUser?: Maybe<Scalars['Boolean']['output']>;
  unsuspendUserByAdmin?: Maybe<Scalars['Boolean']['output']>;
  updateAbTestConfig: AbTestConfig;
  updateAccountType?: Maybe<Scalars['Boolean']['output']>;
  updateAdministratorRole: Administrator;
  updateApproachFilterCondition?: Maybe<Scalars['Boolean']['output']>;
  updateCelebrityProfileVisibility: Scalars['Boolean']['output'];
  updateCommonSale: Campaign;
  updateCompanyInfo?: Maybe<Scalars['Boolean']['output']>;
  /** ログイン中の本人のABテストの割り当てを上書きする。HelloPayはforceDebugHelloPayTargetと同じ処理を行う */
  updateDebugAbTestVariant: Scalars['Boolean']['output'];
  updateDebugCertificationStatuses: Scalars['Boolean']['output'];
  updateDebugMatch: Scalars['Boolean']['output'];
  updateDebugMemberStatus: Scalars['Boolean']['output'];
  updateDebugProfile: Scalars['Boolean']['output'];
  updateDebugUserStatus: Scalars['Boolean']['output'];
  updateFeatureFlagSetting: FeatureFlagSetting;
  updateFeatureFlagSettingConfig: FeatureFlagSetting;
  updateForceGorgeousRankEnum?: Maybe<Scalars['Boolean']['output']>;
  updateJobInfo?: Maybe<Scalars['Boolean']['output']>;
  updateMatchUserNickname?: Maybe<Scalars['Boolean']['output']>;
  updateOpenedAt: Scalars['Boolean']['output'];
  updateProfileTraits?: Maybe<Scalars['Boolean']['output']>;
  updateProfiles?: Maybe<UpdateProfileOutput>;
  updatePushToken?: Maybe<Scalars['Boolean']['output']>;
  updateRegistrationBeforeScreening?: Maybe<Scalars['Boolean']['output']>;
  updateScheduledEmailNotification: UpdateScheduledEmailNotificationOutput;
  updateScheduledInAppNews: UpdateScheduledInAppNewsOutput;
  updateScheduledModalNotification: UpdateScheduledModalNotificationOutput;
  updateScheduledNotificationStatuses: Scalars['Int']['output'];
  updateScheduledPushNotification: UpdateScheduledPushNotificationOutput;
  updateSearchUserCondition?: Maybe<Scalars['Boolean']['output']>;
  updateSearchUserSortCondition?: Maybe<Scalars['Boolean']['output']>;
  updateSelfIntroduction?: Maybe<Scalars['Boolean']['output']>;
  updateTrustModeSelectedJobCategories?: Maybe<Scalars['Boolean']['output']>;
  updateUserAbTestOverride?: Maybe<Scalars['Boolean']['output']>;
  updateUserEmail?: Maybe<Scalars['Boolean']['output']>;
  updateUserInfoWhenForeground: User;
  updateUserLoginToPhone?: Maybe<Scalars['Boolean']['output']>;
  updateUserMemberStatus?: Maybe<Scalars['Boolean']['output']>;
  updateUserNameAndBirthday?: Maybe<Scalars['Boolean']['output']>;
  updateUserSetting?: Maybe<Scalars['Boolean']['output']>;
  updateUserSettingPreference?: Maybe<Scalars['Boolean']['output']>;
  upsertCelebrityCertificationScore?: Maybe<Scalars['Boolean']['output']>;
  upsertFirebaseConfig: Scalars['Boolean']['output'];
  upsertScreeningScores?: Maybe<Scalars['Boolean']['output']>;
  upsertTmpUser: TmpUser;
  useReferralCode: UseReferralCodeOutput;
  validateReferralCode: Scalars['Boolean']['output'];
  validateRewardCode: ValidateRewardCodeOutput;
  webAgreeDateCancellationFee?: Maybe<Scalars['Boolean']['output']>;
  /** 本人認証の戻りURLのsetup_intent_idが登録と一致し、HelloPay上で認証が完了していないときだけカード登録を取り消す。完了していれば取り消さずに状態を返す */
  webCancelHelloPayCardSetup: WebHelloPayCardRegistrationOutput;
  /** 期間末で解約する。取り消しはできない */
  webCancelHelloPaySubscription: HelloPaySubscription;
  webCancelSubscription: Scalars['Boolean']['output'];
  /** 次回の更新と、更新失敗中の請求の再試行に使うカードを変える */
  webChangeHelloPaySubscriptionCard: HelloPaySubscription;
  webCheckHasValidWebPaymentCard: Scalars['Boolean']['output'];
  webCreateCardEditLink: WebCreateCardEditLinkOutput;
  webCreateDateTicketCheckoutLink: WebCreateCheckoutLinkOutput;
  webCreateSubscriptionCheckoutLink: WebCreateCheckoutLinkOutput;
  webCreateSubscriptionUpgradeCheckoutLink: WebCreateUpgradeCheckoutLinkOutput;
  webCreateTicketCheckoutLink: WebCreateCheckoutLinkOutput;
  webCreateTicketOrder: WebTicketOrderOutput;
  webDeleteHelloPayCard: Scalars['Boolean']['output'];
  webLoginWithApple?: Maybe<WebAuthOutput>;
  webLoginWithAuthExchangeCode?: Maybe<WebAuthOutput>;
  webLoginWithLine?: Maybe<WebAuthOutput>;
  webLoginWithPhone?: Maybe<WebAuthOutput>;
  webPayHelloPayTicketOrder: WebTicketOrderOutput;
  webSendVerificationCode: Scalars['Boolean']['output'];
  webStartHelloPayCardRegistration: WebHelloPayCardRegistrationOutput;
  /** 初回請求の結果まで同期して返す。Pendingなら同じrequestIdで再送するか、webHelloPaySubscriptionで状態を確認する */
  webStartHelloPaySubscription: HelloPaySubscription;
  webSyncHelloPayCardRegistration: WebHelloPayCardRegistrationOutput;
  /** 確認中の申込をHelloPayから取得し直して返す。Webhookや作成の応答を失っても、照合ジョブを待たずに結果を確かめられる。確認中でなければ最新の契約をそのまま返す */
  webSyncHelloPaySubscription?: Maybe<HelloPaySubscription>;
  webSyncSubscription: Scalars['Boolean']['output'];
  /** 差額の請求結果まで同期して返す。解約予約中でも解約は維持し、期間末までプラチナになる */
  webUpgradeHelloPaySubscription: HelloPaySubscription;
  withdraw?: Maybe<Scalars['Boolean']['output']>;
  withdrawUserByAdmin?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptFromRejectedListArgs = {
  input: SwipeInput;
};


export type MutationAddInterestedUserArgs = {
  input: InterestedUserInput;
};


export type MutationAdvanceDebugMatchTimeArgs = {
  hours: Scalars['Int']['input'];
  targetUserId: Scalars['Int']['input'];
};


export type MutationAgreeToLegalDocumentArgs = {
  legalDocumentId: Scalars['Int']['input'];
};


export type MutationAllowScreenshotArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationAnswerVideoCallArgs = {
  videoCallId: Scalars['Int']['input'];
};


export type MutationApplyForCelebrityCertificationArgs = {
  input: ApplyForCelebrityCertificationInput;
};


export type MutationApplyForScreeningV2Args = {
  input: ApplyForScreeningInput;
};


export type MutationApplyRewardCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationApplyStickerArgs = {
  input: ApplyStickerCreateInput;
};


export type MutationApproveIdentificationForDevArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationAssignPushPermissionAbGroupArgs = {
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  tmpUserId: Scalars['Int']['input'];
};


export type MutationAuthenticateWithPhoneArgs = {
  loginWithPhoneInput: LoginWithPhoneInput;
};


export type MutationBanUserArgs = {
  input: BanUserInput;
};


export type MutationBlockUserArgs = {
  targetUserId: Scalars['Int']['input'];
};


export type MutationBulkDisableReferralCodesArgs = {
  input: BulkDisableReferralCodesInput;
};


export type MutationBulkLikeTopPicksArgs = {
  input: TopPicksBulkLikeInput;
};


export type MutationBulkRejectPassedSelfIntroductionStatusArgs = {
  bulkRejectPassedSelfIntroductionStatusInput: BulkRejectPassedSelfIntroductionStatusInput;
};


export type MutationBulkRejectUserArgs = {
  input: BulkRejectUserInput;
};


export type MutationBulkUpdateApproachMessageStatusArgs = {
  input: BulkUpdateApproachMessageStatusInput;
};


export type MutationBulkUpdateHobbyTagStatusArgs = {
  input: BulkUpdateHobbyTagStatusInput;
};


export type MutationBulkUpdateProfileImageStatusArgs = {
  bulkUpdateProfileImageStatusInput: BulkUpdateProfileImageStatusInput;
};


export type MutationBulkUpdateProfileItemWithScreeningStatusArgs = {
  input: BulkUpdateProfileItemWithScreeningStatusInput;
};


export type MutationBulkUpdateScreeningImageStatusArgs = {
  bulkUpdateScreeningImageStatusInput: BulkUpdateScreeningImageStatusInput;
};


export type MutationBulkUpdateSelfIntroductionStatusArgs = {
  bulkUpdateSelfIntroductionStatusInput: BulkUpdateSelfIntroductionStatusInput;
};


export type MutationCallVideoArgs = {
  matchId: Scalars['Int']['input'];
};


export type MutationCancelVideoCallArgs = {
  reason: VideoCallCancelReasonEnum;
  videoCallId: Scalars['Int']['input'];
};


export type MutationCompleteIncomeCertificationArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationCompleteSingleCertificationArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationConfirmIdentityForIncomeArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationConfirmSingleCertificationIdentityArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationConnectVideoCallArgs = {
  videoCallId: Scalars['Int']['input'];
};


export type MutationConsumeFreeSuperLikeForInactiveSuperLikeUserFromPickupArgs = {
  input: SuperLikeInput;
};


export type MutationContinuousPickupUsersArgs = {
  displayedNumberOfContinuousPickup?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateAmbassadorReferralCommentArgs = {
  input: CreateAmbassadorReferralCommentInput;
};


export type MutationCreateAppReviewArgs = {
  appReviewCreateInput: AppReviewCreateInput;
};


export type MutationCreateCommonSaleArgs = {
  input: CreateCommonSaleInput;
};


export type MutationCreateDebugIncomingFootprintArgs = {
  fromUserId: Scalars['Int']['input'];
};


export type MutationCreateDebugIncomingLikeArgs = {
  approachType: DebugIncomingLikeType;
  approachUserId: Scalars['Int']['input'];
};


export type MutationCreateDebugIncomingMessageArgs = {
  fromUserId: Scalars['Int']['input'];
};


export type MutationCreateFootprintArgs = {
  input: CreateFootprintInput;
};


export type MutationCreateForceUpdateSettingArgs = {
  input: CreateForceUpdateSettingInput;
};


export type MutationCreateHobbyTagArgs = {
  input: CreateHobbyTagInput;
};


export type MutationCreateInquiryArgs = {
  inquiryCreateInput: InquiryCreateInput;
};


export type MutationCreateProfileItemWithScreeningArgs = {
  input: CreateProfileItemInput;
};


export type MutationCreateScheduledEmailNotificationArgs = {
  input: CreateScheduledEmailNotificationInput;
};


export type MutationCreateScheduledInAppNewsArgs = {
  input: CreateScheduledInAppNewsInput;
};


export type MutationCreateScheduledModalNotificationArgs = {
  input: CreateScheduledModalNotificationInput;
};


export type MutationCreateScheduledPushNotificationArgs = {
  input: CreateScheduledPushNotificationInput;
};


export type MutationCreateUserEventLogArgs = {
  userEventLogInput: UserEventLogInput;
};


export type MutationCreateUserHobbyTagArgs = {
  hobbyTagId: Scalars['Int']['input'];
};


export type MutationCreateUserSupportMemoArgs = {
  createUserSupportMemoInput: CreateUserSupportMemoInput;
};


export type MutationCreateViolationNewsArgs = {
  input: CreateViolationNewsInput;
};


export type MutationDeclineVideoCallArgs = {
  videoCallId: Scalars['Int']['input'];
};


export type MutationDeferPushPermissionSoftPromptArgs = {
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  tmpUserId: Scalars['Int']['input'];
};


export type MutationDeleteAbTestConfigArgs = {
  testKey: Scalars['String']['input'];
};


export type MutationDeleteAdministratorArgs = {
  administratorId: Scalars['Int']['input'];
};


export type MutationDeleteCommonSaleArgs = {
  campaignId: Scalars['Int']['input'];
};


export type MutationDeleteFeatureFlagSettingArgs = {
  key: Scalars['String']['input'];
};


export type MutationDeleteScheduledEmailNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteScheduledInAppNewsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteScheduledModalNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteScheduledPushNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteScreeningScoresArgs = {
  deleteScreeningScoresInput: DeleteScreeningScoresInput;
};


export type MutationDeleteUserHobbyTagArgs = {
  hobbyTagId: Scalars['Int']['input'];
};


export type MutationDetectScreenshotArgs = {
  fromScreenName: Scalars['String']['input'];
};


export type MutationDisableEmailDeliveryArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationDisableGgMarriageMemberArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationDisallowScreenshotArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationEnableEmailDeliveryArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationEnableGgMarriageMemberArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationEndVideoCallArgs = {
  videoCallId: Scalars['Int']['input'];
};


export type MutationExecuteInitialSubscriptionFreeMessageLikeFromPickupArgs = {
  input: MessageLikeInput;
};


export type MutationExecuteInitialSubscriptionFreeSuperLikeFromPickupArgs = {
  input: SuperLikeInput;
};


export type MutationFailCelebrityCertificationArgs = {
  input: FailCelebrityCertificationInput;
};


export type MutationFailCelebrityCertificationButPassUserArgs = {
  input: FailCelebrityCertificationButPassUserInput;
};


export type MutationForceDebugHelloPayTargetArgs = {
  enabled?: Scalars['Boolean']['input'];
};


export type MutationForceDebugPopularUserArgs = {
  targetUserId: Scalars['Int']['input'];
};


export type MutationForceDebugUserLifecycleTypeArgs = {
  type: UserLifecycleType;
};


export type MutationForceStartDebugAutoAppealArgs = {
  appealType: DebugAutoAppealType;
};


export type MutationForceStartDebugSaleArgs = {
  saleType: DebugSaleType;
};


export type MutationFreeLikeTopPicksArgs = {
  topPicksLikeInput: TopPicksLikeInput;
};


export type MutationGenerateVideoCallTokenArgs = {
  matchId: Scalars['Int']['input'];
};


export type MutationGetOrCreateReferralCodeArgs = {
  type: Scalars['String']['input'];
};


export type MutationGetUnreadActionSpecialNewsArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
  kinds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationGrantBonusTicketFromCsArgs = {
  grantBonusTicketFromCSInput: GrantBonusTicketFromCsInput;
};


export type MutationGrantDebugTicketArgs = {
  count: Scalars['Int']['input'];
};


export type MutationHideMatchArgs = {
  matchId: Scalars['Int']['input'];
};


export type MutationHyperLikeFromMyLikeListArgs = {
  input: SwipeInput;
};


export type MutationInviteAdministratorArgs = {
  input: InviteAdministratorInput;
};


export type MutationJoinTodayAvailabilityArgs = {
  input: JoinTodayAvailabilityInput;
};


export type MutationJudgeDebugUserScreeningArgs = {
  judge: Scalars['String']['input'];
  screeningFailedReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLikeFromFootprintListArgs = {
  input: SwipeInput;
};


export type MutationLikeFromInterestedListArgs = {
  input: LikeFromInterestedListInput;
};


export type MutationLikeFromTodayAvailabilityArgs = {
  input: LikeFromTodayAvailabilityInput;
};


export type MutationLinkCelebrityConciergeLineArgs = {
  idToken: Scalars['String']['input'];
};


export type MutationLinkLineAccountAndGiveTicketArgs = {
  idToken: Scalars['String']['input'];
};


export type MutationLoginDebugOperatorWithGoogleArgs = {
  idToken: Scalars['String']['input'];
};


export type MutationLoginDebugOperatorWithPasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationLoginWithAppleArgs = {
  loginWithAppleInput: LoginWithAppleInput;
};


export type MutationLoginWithGoogleArgs = {
  token: Scalars['String']['input'];
};


export type MutationLoginWithLineArgs = {
  loginWithLineInput: LoginWithLineInput;
};


export type MutationLoginWithPhoneArgs = {
  loginWithPhoneInput: LoginWithPhoneInput;
};


export type MutationLoginWithTokenArgs = {
  input: LoginWithTokenInput;
};


export type MutationMarkMatchAsReadArgs = {
  matchId: Scalars['Int']['input'];
};


export type MutationMarkMessagesAsReadArgs = {
  input: MarkMessagesAsReadInput;
};


export type MutationMarkNormalNewsAsDetailReadArgs = {
  newsId: Scalars['Int']['input'];
};


export type MutationMessageLikeArgs = {
  input: MessageLikeInput;
};


export type MutationMessageLikeFromFootprintListArgs = {
  input: MessageLikeInput;
};


export type MutationMessageLikeFromMyLikeListArgs = {
  input: MessageLikeInput;
};


export type MutationMessageLikeFromRecommendArgs = {
  input: MessageLikeInput;
};


export type MutationMessageLikeFromSearchArgs = {
  input: MessageLikeInput;
};


export type MutationMessageLikeFromTopPicksArgs = {
  input: MessageLikeFromTopPicksInput;
};


export type MutationNotifyLoverByGorgeousLineArgs = {
  input: NotifyLoverByGorgeousLineInput;
};


export type MutationPassCelebrityCertificationArgs = {
  input: PassCelebrityCertificationInput;
};


export type MutationPassUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationPurchaseTicketArgs = {
  ticketMenuId: Scalars['Int']['input'];
};


export type MutationPurchaseTicketOnExtraSaleArgs = {
  ticketMenuId: Scalars['Int']['input'];
};


export type MutationReMatchArgs = {
  matchId: Scalars['Int']['input'];
};


export type MutationReactivateUserByAdminArgs = {
  input: ReactivateUserByAdminInput;
};


export type MutationReapplyForScreeningArgs = {
  input: ReapplyForScreeningInput;
};


export type MutationRefreshAccessTokenArgs = {
  refreshAccessTokenInput: RefreshAccessTokenInput;
};


export type MutationRegisterOptionalProfileArgs = {
  input: RegisterOptionalProfileInput;
};


export type MutationRejectUserArgs = {
  input: RejectUserInput;
};


export type MutationRemoveAmbassadorReferralCommentArgs = {
  commentId: Scalars['Int']['input'];
};


export type MutationRemoveIncomeScreeningImageForStorageArgs = {
  removeIncomeScreeningImageForStorageInput: RemoveIncomeScreeningImageForStorageInput;
};


export type MutationRemoveInterestedUserArgs = {
  input: InterestedUserInput;
};


export type MutationRemoveJobScreeningImageForStorageArgs = {
  removeJobScreeningImageForStorageInput: RemoveJobScreeningImageForStorageInput;
};


export type MutationRemoveProfileImageArgs = {
  removeProfileImageInput: RemoveProfileImageInput;
};


export type MutationReportUserArgs = {
  reportUserInput: ReportUserInput;
};


export type MutationReportVideoCallCallerLeftArgs = {
  videoCallId: Scalars['Int']['input'];
};


export type MutationRequestIdentificationRescreeningArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationResetDebugTodayAvailabilityArgs = {
  allUsers: Scalars['Boolean']['input'];
};


export type MutationResolveHelloPaySubscriptionPaymentArgs = {
  input: ResolveHelloPayPaymentInput;
};


export type MutationRestoreForceUpdateSettingArgs = {
  input: RestoreForceUpdateSettingInput;
};


export type MutationSendAppSubscriptionToWebEmailArgs = {
  plan?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendFacebookAdsEventArgs = {
  facebookAdsInput: FacebookAdsInput;
};


export type MutationSendMessageArgs = {
  sendMessageInput: SendMessageInput;
};


export type MutationSendScheduledNotificationTestArgs = {
  notificationId: Scalars['Int']['input'];
  notificationType: ScheduledNotificationTypeEnum;
  requestId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSendTicketPurchaseToWebEmailArgs = {
  ticketMenuId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendVerificationCodeArgs = {
  phoneNumberInput: PhoneNumberInput;
};


export type MutationSendVerificationCodeToEmailArgs = {
  emailInput: EmailInput;
};


export type MutationSetCommonSaleActiveArgs = {
  campaignId: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationShadowBanUserArgs = {
  input: ShadowBanUserInput;
};


export type MutationSignUpArgs = {
  signUpInput: SignUpInput;
};


export type MutationSignUpWithAppleArgs = {
  signUpWithAppleInput: SignUpWithAppleInput;
};


export type MutationSignUpWithLineArgs = {
  signUpWithLineInput: SignUpWithLineInput;
};


export type MutationSignUpWithPhoneArgs = {
  signUpWithPhoneInput: SignUpWithPhoneInput;
};


export type MutationStartVideoCallArgs = {
  matchId: Scalars['Int']['input'];
};


export type MutationSubmitIncomeScreeningImagesArgs = {
  submitIncomeScreeningImagesInput: SubmitIncomeScreeningImagesInput;
};


export type MutationSubmitJobScreeningImagesArgs = {
  submitJobScreeningImagesInput: SubmitJobScreeningImagesInput;
};


export type MutationSuperLikeArgs = {
  input: SuperLikeInput;
};


export type MutationSuperLikeFromFootprintListArgs = {
  input: SwipeInput;
};


export type MutationSuperLikeFromMyLikeListArgs = {
  input: SwipeInput;
};


export type MutationSuperLikeFromRecommendArgs = {
  input: SwipeInput;
};


export type MutationSuperLikeFromSearchArgs = {
  input: SwipeInput;
};


export type MutationSuperLikeTopPicksArgs = {
  topPicksLikeInput: TopPicksLikeInput;
};


export type MutationSwipeArgs = {
  swipeInput: SwipeInput;
};


export type MutationSwipeLikeFromReceivingAppealArgs = {
  input: SwipeInput;
};


export type MutationSwipeLikeFromRecommendArgs = {
  input: SwipeInput;
};


export type MutationSwipeLikeFromSearchArgs = {
  input: SwipeInput;
};


export type MutationSwipeTopPicksArgs = {
  topPicksLikeInput: TopPicksLikeInput;
};


export type MutationSwitchDebugLoginUserArgs = {
  targetUserId: Scalars['Int']['input'];
};


export type MutationTestResetPickupArgs = {
  userId: Scalars['Float']['input'];
};


export type MutationTestSelectPickupUsersArgs = {
  testPickupInput: TestPickupInput;
};


export type MutationTestSwipeArgs = {
  testSwipeInput: TestSwipeInput;
};


export type MutationToggleFavoriteMatchArgs = {
  matchId: Scalars['Int']['input'];
};


export type MutationUltraLikeFromMyLikeListArgs = {
  input: SwipeInput;
};


export type MutationUnbanUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationUndoRejectArgs = {
  input: UndoSkipInput;
};


export type MutationUndoSkipArgs = {
  input: UndoSkipInput;
};


export type MutationUnhideMatchArgs = {
  matchId: Scalars['Int']['input'];
};


export type MutationUnsuspendUserByAdminArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationUpdateAbTestConfigArgs = {
  input: UpdateAbTestConfigInput;
  testKey: Scalars['String']['input'];
};


export type MutationUpdateAccountTypeArgs = {
  input: UpdateAccountTypeInput;
};


export type MutationUpdateAdministratorRoleArgs = {
  input: UpdateAdministratorRoleInput;
};


export type MutationUpdateApproachFilterConditionArgs = {
  input: UpdateApproachFilterConditionInput;
};


export type MutationUpdateCelebrityProfileVisibilityArgs = {
  input: UpdateCelebrityProfileVisibilityInput;
};


export type MutationUpdateCommonSaleArgs = {
  campaignId: Scalars['Int']['input'];
  input: UpdateCommonSaleInput;
};


export type MutationUpdateCompanyInfoArgs = {
  input: UpdateCompanyInfoInput;
};


export type MutationUpdateDebugAbTestVariantArgs = {
  testKey: Scalars['String']['input'];
  variant: DebugAbTestVariant;
};


export type MutationUpdateDebugCertificationStatusesArgs = {
  input: UpdateDebugCertificationStatusesInput;
};


export type MutationUpdateDebugMatchArgs = {
  isMatched: Scalars['Boolean']['input'];
  targetUserId: Scalars['Int']['input'];
};


export type MutationUpdateDebugMemberStatusArgs = {
  memberStatus: DebugMemberStatus;
  paymentRoute?: InputMaybe<DebugPaymentRoute>;
};


export type MutationUpdateDebugProfileArgs = {
  input: UpdateDebugProfileInput;
};


export type MutationUpdateDebugUserStatusArgs = {
  status: DebugUserStatus;
};


export type MutationUpdateFeatureFlagSettingArgs = {
  enabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
};


export type MutationUpdateFeatureFlagSettingConfigArgs = {
  input: UpdateFeatureFlagSettingInput;
  key: Scalars['String']['input'];
};


export type MutationUpdateForceGorgeousRankEnumArgs = {
  forceGorgeousRankEnum: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdateJobInfoArgs = {
  input: UpdateJobInfoInput;
};


export type MutationUpdateMatchUserNicknameArgs = {
  input: UpdateMatchUserNicknameInput;
};


export type MutationUpdateOpenedAtArgs = {
  notificationId: Scalars['String']['input'];
};


export type MutationUpdateProfileTraitsArgs = {
  input: UpdateProfileTraitsInput;
};


export type MutationUpdateProfilesArgs = {
  updateProfileInput: UpdateProfileInput;
};


export type MutationUpdatePushTokenArgs = {
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRegistrationBeforeScreeningArgs = {
  input: UpdateRegistrationBeforeScreeningInput;
};


export type MutationUpdateScheduledEmailNotificationArgs = {
  input: UpdateScheduledEmailNotificationInput;
};


export type MutationUpdateScheduledInAppNewsArgs = {
  input: UpdateScheduledInAppNewsInput;
};


export type MutationUpdateScheduledModalNotificationArgs = {
  input: UpdateScheduledModalNotificationInput;
};


export type MutationUpdateScheduledNotificationStatusesArgs = {
  input: UpdateScheduledNotificationStatusesInput;
};


export type MutationUpdateScheduledPushNotificationArgs = {
  input: UpdateScheduledPushNotificationInput;
};


export type MutationUpdateSearchUserConditionArgs = {
  input: UpdateSearchUserConditionInput;
};


export type MutationUpdateSearchUserSortConditionArgs = {
  input: UpdateSearchUserSortConditionInput;
};


export type MutationUpdateSelfIntroductionArgs = {
  selfIntroduction: Scalars['String']['input'];
};


export type MutationUpdateTrustModeSelectedJobCategoriesArgs = {
  input: UpdateTrustModeSelectedJobCategoriesInput;
};


export type MutationUpdateUserAbTestOverrideArgs = {
  testKey: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
  variant: Scalars['String']['input'];
};


export type MutationUpdateUserEmailArgs = {
  updateUserEmailInput: UpdateUserEmailInput;
};


export type MutationUpdateUserInfoWhenForegroundArgs = {
  input: UserInfoInput;
};


export type MutationUpdateUserLoginToPhoneArgs = {
  input: UpdateUserLoginToPhoneInput;
};


export type MutationUpdateUserMemberStatusArgs = {
  input: UpdateUserMemberStatusInput;
};


export type MutationUpdateUserNameAndBirthdayArgs = {
  input: UpdateUserNameAndBirthdayInput;
};


export type MutationUpdateUserSettingArgs = {
  input: UpdateUserSettingInput;
};


export type MutationUpdateUserSettingPreferenceArgs = {
  input: UpdateUserSettingPreferenceInput;
};


export type MutationUpsertCelebrityCertificationScoreArgs = {
  upsertCelebrityCertificationScoreInput: UpsertCelebrityCertificationScoreInput;
};


export type MutationUpsertFirebaseConfigArgs = {
  firebaseConfigInput: FirebaseConfigInput;
};


export type MutationUpsertScreeningScoresArgs = {
  upsertScreeningScoreInput: UpsertScreeningScoreInput;
};


export type MutationUpsertTmpUserArgs = {
  input: UpsertTmpUserInput;
};


export type MutationUseReferralCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationValidateReferralCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationValidateRewardCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationWebCancelHelloPayCardSetupArgs = {
  input: WebCancelHelloPayCardSetupInput;
};


export type MutationWebChangeHelloPaySubscriptionCardArgs = {
  input: WebChangeHelloPaySubscriptionCardInput;
};


export type MutationWebCreateDateTicketCheckoutLinkArgs = {
  input: WebCreateDateTicketCheckoutLinkInput;
};


export type MutationWebCreateSubscriptionCheckoutLinkArgs = {
  input: WebCreateSubscriptionCheckoutLinkInput;
};


export type MutationWebCreateSubscriptionUpgradeCheckoutLinkArgs = {
  input: WebCreateSubscriptionUpgradeCheckoutLinkInput;
};


export type MutationWebCreateTicketCheckoutLinkArgs = {
  input: WebCreateTicketCheckoutLinkInput;
};


export type MutationWebCreateTicketOrderArgs = {
  input: WebCreateTicketOrderInput;
};


export type MutationWebDeleteHelloPayCardArgs = {
  input: WebHelloPayCardRegistrationInput;
};


export type MutationWebLoginWithAppleArgs = {
  loginWithAppleInput: LoginWithAppleInput;
};


export type MutationWebLoginWithAuthExchangeCodeArgs = {
  authExchangeCodeInput: AuthExchangeCodeInput;
};


export type MutationWebLoginWithLineArgs = {
  loginWithLineInput: LoginWithLineInput;
};


export type MutationWebLoginWithPhoneArgs = {
  loginWithPhoneInput: LoginWithPhoneInput;
};


export type MutationWebPayHelloPayTicketOrderArgs = {
  input: WebPayHelloPayTicketOrderInput;
};


export type MutationWebSendVerificationCodeArgs = {
  phoneNumberInput: PhoneNumberInput;
};


export type MutationWebStartHelloPayCardRegistrationArgs = {
  input: WebStartHelloPayCardRegistrationInput;
};


export type MutationWebStartHelloPaySubscriptionArgs = {
  input: WebStartHelloPaySubscriptionInput;
};


export type MutationWebSyncHelloPayCardRegistrationArgs = {
  input: WebHelloPayCardRegistrationInput;
};


export type MutationWebUpgradeHelloPaySubscriptionArgs = {
  input: WebUpgradeHelloPaySubscriptionInput;
};


export type MutationWithdrawArgs = {
  withdrawInput?: InputMaybe<WithdrawInput>;
};


export type MutationWithdrawUserByAdminArgs = {
  withdrawUserByAdminInput: WithdrawUserByAdminInput;
};

export type MyApproachedMatchesListOutput = {
  __typename?: 'MyApproachedMatchesListOutput';
  matches: Array<Match>;
  pageInfo: PageInfo;
};

export type MyApproachingMatchesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<MyLikeListSortType>;
};

export const MyLikeListSortType = {
  LikedOrderNewest: 'LikedOrderNewest',
  LikedOrderOldest: 'LikedOrderOldest',
  Recommend: 'Recommend'
} as const;

export type MyLikeListSortType = typeof MyLikeListSortType[keyof typeof MyLikeListSortType];
export const MynaConnectCertificationFilter = {
  All: 'All',
  Approved: 'Approved',
  Rejected: 'Rejected'
} as const;

export type MynaConnectCertificationFilter = typeof MynaConnectCertificationFilter[keyof typeof MynaConnectCertificationFilter];
export const MynaConnectCertificationOutcome = {
  Approved: 'Approved',
  Rejected: 'Rejected',
  Unresolved: 'Unresolved'
} as const;

export type MynaConnectCertificationOutcome = typeof MynaConnectCertificationOutcome[keyof typeof MynaConnectCertificationOutcome];
export type MynaConnectIncomeSessionForAdmin = {
  __typename?: 'MynaConnectIncomeSessionForAdmin';
  certifiedIncome?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  outcome: MynaConnectCertificationOutcome;
  progressStatus: Scalars['String']['output'];
  registeredIncome?: Maybe<Scalars['String']['output']>;
  rejectionCount: Scalars['Int']['output'];
  resultStatus?: Maybe<Scalars['String']['output']>;
  totalAttemptCount: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type MynaConnectIncomeSessionsForAdminPage = {
  __typename?: 'MynaConnectIncomeSessionsForAdminPage';
  items: Array<MynaConnectIncomeSessionForAdmin>;
  totalCount: Scalars['Int']['output'];
};

export type MynaConnectMarriageSessionForAdmin = {
  __typename?: 'MynaConnectMarriageSessionForAdmin';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  outcome: MynaConnectCertificationOutcome;
  progressStatus: Scalars['String']['output'];
  rejectionCount: Scalars['Int']['output'];
  singleCertificationStatus?: Maybe<Scalars['String']['output']>;
  totalAttemptCount: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type MynaConnectMarriageSessionsForAdminPage = {
  __typename?: 'MynaConnectMarriageSessionsForAdminPage';
  items: Array<MynaConnectMarriageSessionForAdmin>;
  totalCount: Scalars['Int']['output'];
};

export type News = {
  __typename?: 'News';
  body: Scalars['String']['output'];
  closeButtonText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  detailReadAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  imageHeightAspectRatio?: Maybe<Scalars['Float']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  newsRelease?: Maybe<NewsRelease>;
  primaryButtonText?: Maybe<Scalars['String']['output']>;
  primaryButtonUrl?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type NewsRelease = {
  __typename?: 'NewsRelease';
  newsId: Scalars['Int']['output'];
  primaryButtonLink?: Maybe<Scalars['String']['output']>;
  primaryButtonText?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type NormalNewsInput = {
  cursor?: InputMaybe<Scalars['Float']['input']>;
};

export type NotImmediateResumeSale = {
  __typename?: 'NotImmediateResumeSale';
  bannerImageUrl: Scalars['String']['output'];
  carouselBannerImageUrl: Scalars['String']['output'];
  discountRatePercentages: Scalars['Float']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
  textForWebBanner: Scalars['String']['output'];
};

export type NotifyLoverByGorgeousLineInput = {
  idToken: Scalars['String']['input'];
  lineLinkUuid: Scalars['String']['input'];
};

export type OnboardingBonusTicketStatus = {
  __typename?: 'OnboardingBonusTicketStatus';
  profile: OnboardingProfileBonusTicketStatus;
};

export type OnboardingProfileBonusTicketStatus = {
  __typename?: 'OnboardingProfileBonusTicketStatus';
  birthPrefecture: Scalars['Boolean']['output'];
  birthPrefectureDetail: Scalars['Boolean']['output'];
  bloodType: Scalars['Boolean']['output'];
  bodyShape: Scalars['Boolean']['output'];
  childrenExist: Scalars['Boolean']['output'];
  collectedWorkInput: Scalars['Boolean']['output'];
  communicationType: Scalars['Boolean']['output'];
  companyName: Scalars['Boolean']['output'];
  drinking: Scalars['Boolean']['output'];
  favoriteAlcoholInput: Scalars['Boolean']['output'];
  favoriteBrandInput: Scalars['Boolean']['output'];
  favoriteFoodInput: Scalars['Boolean']['output'];
  favoriteLuxuryItemInput: Scalars['Boolean']['output'];
  firstDatePaymentPreference: Scalars['Boolean']['output'];
  goodCountryInput: Scalars['Boolean']['output'];
  goodStoreInput: Scalars['Boolean']['output'];
  height: Scalars['Boolean']['output'];
  hobbyInput: Scalars['Boolean']['output'];
  holiday: Scalars['Boolean']['output'];
  houseWork: Scalars['Boolean']['output'];
  housemate: Scalars['Boolean']['output'];
  jobDetail: Scalars['Boolean']['output'];
  marriageHistory: Scalars['Boolean']['output'];
  marriageView: Scalars['Boolean']['output'];
  mbti: Scalars['Boolean']['output'];
  ownedVehicleInput: Scalars['Boolean']['output'];
  qualificationInput: Scalars['Boolean']['output'];
  recentDeliciousFood: Scalars['Boolean']['output'];
  recentFavorite: Scalars['Boolean']['output'];
  recentPurchasedItem: Scalars['Boolean']['output'];
  recentViewedMovie: Scalars['Boolean']['output'];
  recentVisitedTown: Scalars['Boolean']['output'];
  residencePrefectureDetail: Scalars['Boolean']['output'];
  selfIntroduction: Scalars['Boolean']['output'];
  sibling: Scalars['Boolean']['output'];
  smoking: Scalars['Boolean']['output'];
  universityName: Scalars['Boolean']['output'];
  wantChild: Scalars['Boolean']['output'];
};

export type OtherUser = {
  __typename?: 'OtherUser';
  abTestAppSubscriptionsToWeb?: Maybe<Scalars['String']['output']>;
  abTestContinuousBlur?: Maybe<Scalars['String']['output']>;
  abTestPaidPlanScreen?: Maybe<Scalars['String']['output']>;
  abTestPickupLikeLimitForMan: Scalars['String']['output'];
  abTestRecommendPaidPlanForMan: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  activeWebSubscription?: Maybe<WebPaymentSubscription>;
  age: Scalars['Int']['output'];
  appVersion?: Maybe<Scalars['String']['output']>;
  approachStatus: Scalars['String']['output'];
  birthday?: Maybe<Scalars['Date']['output']>;
  canReapplyForScreening: Scalars['Boolean']['output'];
  canReferralTradingCompany: Scalars['Boolean']['output'];
  canStartSingleCertification: Scalars['Boolean']['output'];
  canUnsuspend: Scalars['Boolean']['output'];
  canUseGoldSearchFilters: Scalars['Boolean']['output'];
  canUseHobbyTagSearch: Scalars['Boolean']['output'];
  canViewOnlineStatus: Scalars['Boolean']['output'];
  celebrityCertificationStatus?: Maybe<Scalars['ScreeningStatus']['output']>;
  celebrityCertifications?: Maybe<Array<CelebrityCertification>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentPaymentPlatform: PaymentPlatformTypeEnum;
  email?: Maybe<Scalars['String']['output']>;
  expoPushToken?: Maybe<Scalars['String']['output']>;
  extraGuerrillaCampaignSale: ExtraGuerrillaCampaignSale;
  extraTicketSale: ExtraTicketSaleV2;
  extraTicketSaleOnSubscription: ExtraTicketSaleOnSubscription;
  featureFlags: FeatureFlagsForUser;
  fiveLevelRank: Scalars['String']['output'];
  gender: Scalars['Gender']['output'];
  hasFirstDateEnded: Scalars['Boolean']['output'];
  hasFirstMessageTemplate: Scalars['Boolean']['output'];
  hasPushNotifyPermission: Scalars['Boolean']['output'];
  hasSubscribed: Scalars['Boolean']['output'];
  hasUnreadRankReward: Scalars['Boolean']['output'];
  highIncomeHighMatchSale: HighIncomeHighMatchSale;
  id: Scalars['Int']['output'];
  identificationStatus: Scalars['ScreeningStatus']['output'];
  incomeConfirmationStatus: Scalars['ScreeningStatus']['output'];
  infiniteWelcomeTicketSale: InfiniteWelcomeTicketSale;
  inquiries?: Maybe<Array<Inquiry>>;
  isAllCertified: Scalars['Boolean']['output'];
  isApproachedFromLoginUser: Scalars['Boolean']['output'];
  isAvailableFlashReferralCampaign: Scalars['Boolean']['output'];
  isAvailableTopPicksBulkLike: Scalars['Boolean']['output'];
  isBoosting: Scalars['Boolean']['output'];
  isCelebrityCertified: Scalars['Boolean']['output'];
  /** @deprecated （友人推薦）アプリ内導線強化 が安定後削除予定 */
  isCompletedALLBonusTicket: Scalars['Boolean']['output'];
  /** @deprecated （友人推薦）アプリ内導線強化 が安定後削除予定 */
  isCompletedAmbassadorBonusTicket: Scalars['Boolean']['output'];
  isCompletedOnboardingBonusTicket: Scalars['Boolean']['output'];
  isContinuationBonusAvailable: Scalars['Boolean']['output'];
  isDateCancellationFeeAgreed: Scalars['Boolean']['output'];
  isEligibleForIntroPrice: Scalars['Boolean']['output'];
  isFirstPassedDateEntryValidCardCheck: Scalars['Boolean']['output'];
  isFreeGoldSearchFilterAvailable: Scalars['Boolean']['output'];
  isFreeGoldSearchFilterPromotionTarget: Scalars['Boolean']['output'];
  isGoldMember: Scalars['Boolean']['output'];
  isGorgeousDateAvailable: Scalars['Boolean']['output'];
  isIdentificationPromotionActive: Scalars['Boolean']['output'];
  isIdentified: Scalars['Boolean']['output'];
  isIncomeConfirmed: Scalars['Boolean']['output'];
  isIncomeGte: Scalars['Boolean']['output'];
  isInterested: Scalars['Boolean']['output'];
  isJobCertified: Scalars['Boolean']['output'];
  isLineUser: Scalars['Boolean']['output'];
  isMan: Scalars['Boolean']['output'];
  isMatched: Scalars['Boolean']['output'];
  isMessageFreePeriod: Scalars['Boolean']['output'];
  isMessageListUpgradeBannerTarget: Scalars['Boolean']['output'];
  isNewUser: Scalars['Boolean']['output'];
  isPaidContentAvailable: Scalars['Boolean']['output'];
  isPaidMember: Scalars['Boolean']['output'];
  isPaidPlanJoinable: Scalars['Boolean']['output'];
  isPaidWithoutFreeMember: Scalars['Boolean']['output'];
  isPlatinumMember: Scalars['Boolean']['output'];
  isPlatinumUpgradableInApp: Scalars['Boolean']['output'];
  isProfileFilledForGorgeousDate: Scalars['Boolean']['output'];
  isProfileImagePrivate: Scalars['Boolean']['output'];
  isRankRewardUnlocked: Scalars['Boolean']['output'];
  isReadStatusDisplayEnabled: Scalars['Boolean']['output'];
  isReferralLimitUnlocked: Scalars['Boolean']['output'];
  isRescreening: Scalars['Boolean']['output'];
  isScreeningFailedByPhoto: Scalars['Boolean']['output'];
  isScreeningReapplicationSuspended: Scalars['Boolean']['output'];
  isScreenshotAllowed: Scalars['Boolean']['output'];
  isSearchSortBadgeTarget: Scalars['Boolean']['output'];
  isSingleCertified: Scalars['Boolean']['output'];
  isSuspending: Scalars['Boolean']['output'];
  isTopGorgeous: Scalars['Boolean']['output'];
  isTopGorgeousAmbassadorReferralBonusActive: Scalars['Boolean']['output'];
  isTopPicksBulkLikeBadgeTarget: Scalars['Boolean']['output'];
  isTopPicksBulkLikeDiscountCampaignActive: Scalars['Boolean']['output'];
  isTrialGold: Scalars['Boolean']['output'];
  isTrustMode: Scalars['Boolean']['output'];
  isWelcomeReferralCampaignActive: Scalars['Boolean']['output'];
  isWelcomeSale: Scalars['Boolean']['output'];
  jobCertificationStatus: Scalars['ScreeningStatus']['output'];
  lastAccessedAt?: Maybe<Scalars['Date']['output']>;
  lastCelebrityCertificationFailedMessage?: Maybe<Scalars['String']['output']>;
  latestIncome?: Maybe<IncomeObject>;
  latestSelfIntroduction?: Maybe<SelfIntroduction>;
  latestSubscription?: Maybe<Subscription>;
  memberStatus: Scalars['MemberStatus']['output'];
  needsGorgeousDateOnboarding: Scalars['Boolean']['output'];
  needsRequestAppReview: Scalars['Boolean']['output'];
  needsShowFirstHyperLikeFromMyLikeListGuide: Scalars['Boolean']['output'];
  needsShowFirstLikeFromFootprintListGuide: Scalars['Boolean']['output'];
  needsShowFirstLikeFromSearchGuide: Scalars['Boolean']['output'];
  needsShowFirstLikeFromTopPicksGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromFootprintListGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromMyLikeListGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromPickupGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromSearchGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromTopPicksGuide: Scalars['Boolean']['output'];
  needsShowFirstUltraLikeFromMyLikeListGuide: Scalars['Boolean']['output'];
  needsShowMessageTutorial: Scalars['Boolean']['output'];
  needsShowPickupTutorial: Scalars['Boolean']['output'];
  onboardingBonusTicketStatus?: Maybe<OnboardingBonusTicketStatus>;
  onlineStatus?: Maybe<Scalars['String']['output']>;
  /** @deprecated 終了済み機能。旧アプリ互換のため一時的に維持 */
  passedSomeoneIds: Array<Scalars['Int']['output']>;
  platform?: Maybe<Scalars['PlatformType']['output']>;
  profile?: Maybe<Profile>;
  profileImages?: Maybe<Array<ProfileImage>>;
  profileInputRate: Scalars['Float']['output'];
  receivedAmbassadorReferralComments: Array<ReceivedAmbassadorReferralComment>;
  recommendHigherLikeWhenLikedByOthers?: Maybe<Scalars['Boolean']['output']>;
  remainingReferralCount: Scalars['Int']['output'];
  resizedProfileImages?: Maybe<Array<ResizedProfileImage>>;
  satisfiesGorgeousDateEntryRequirement: Scalars['Boolean']['output'];
  screeningFailedReason: Scalars['String']['output'];
  secondWelcomeBackSale: SecondWelcomeBackSale;
  secondWelcomeSale: SecondWelcomeSale;
  secondWelcomeTicketSale: SecondWelcomeTicketSale;
  shouldShowCelebrityBadge: Scalars['Boolean']['output'];
  singleCertificationStatus: SingleCertificationDisplayStatus;
  singleCertifiedAt?: Maybe<Scalars['Date']['output']>;
  specialSale: SubscriptionSpecialSale;
  status: Scalars['UserStatus']['output'];
  subSubscriptionSpecialSale: SubSubscriptionSpecialSale;
  subWebSubscriptionSpecialSale: SubWebSubscriptionSpecialSale;
  subscriptionSpecialSale: SubscriptionSpecialSaleV2;
  trialGold: TrialGold;
  trialTicketSale: TrialTicketSale;
  ultraLikeResendableAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userComputed?: Maybe<UserComputed>;
  userHistory?: Maybe<UserHistory>;
  userHobbyTags?: Maybe<Array<UserHobbyTag>>;
  userInstallConversion?: Maybe<UserInstallConversion>;
  userSetting?: Maybe<UserSetting>;
  userSettingPreference?: Maybe<UserSettingPreference>;
  uuid: Scalars['String']['output'];
  visibleReceivedAmbassadorReferralComments: Array<ReceivedAmbassadorReferralComment>;
  webSubscriptionSpecialSale: SubscriptionSpecialSaleV2;
  webSubscriptionUpgradeSale: WebSubscriptionUpgradeSale;
  welcomeBackSale: WelcomeBackSale;
  welcomeSale: WelcomeSale;
  world: Scalars['UserWorld']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentLimit: Scalars['Int']['output'];
  currentOffset: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
};

export type PassCelebrityCertificationInput = {
  celebrityCertificationId: Scalars['Int']['input'];
};

export type PassedApproachMessage = {
  __typename?: 'PassedApproachMessage';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export const PaymentPlatformTypeEnum = {
  Android: 'Android',
  Ios: 'Ios',
  None: 'None',
  Web: 'Web'
} as const;

export type PaymentPlatformTypeEnum = typeof PaymentPlatformTypeEnum[keyof typeof PaymentPlatformTypeEnum];
export type PhoneAuthOutput = {
  __typename?: 'PhoneAuthOutput';
  auth?: Maybe<AuthOutput>;
  phoneSignUpToken?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type PickupUser = {
  __typename?: 'PickupUser';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isPreloadContinuousPickup?: Maybe<Scalars['Boolean']['output']>;
  isTrustModePickup: Scalars['Boolean']['output'];
  lastPickedAt: Scalars['Date']['output'];
  swipedAt?: Maybe<Scalars['Date']['output']>;
  swipedType?: Maybe<Scalars['SwipeType']['output']>;
  targetUser: User;
  targetUserId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
};

/** 都道府県絞り込みタイプ */
export const PrefectureFilterType = {
  Neighborhood: 'Neighborhood',
  Same: 'Same'
} as const;

export type PrefectureFilterType = typeof PrefectureFilterType[keyof typeof PrefectureFilterType];
export type Product = {
  __typename?: 'Product';
  androidProductId?: Maybe<Scalars['String']['output']>;
  androidProductIdV2?: Maybe<Scalars['String']['output']>;
  androidProductIdV2OfferId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['DurationType']['output']>;
  id: Scalars['Int']['output'];
  iosProductId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  renewalPrice?: Maybe<Scalars['Int']['output']>;
  type: Scalars['ProductType']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  birthPrefecture: Scalars['Prefecture']['output'];
  birthPrefectureDetail?: Maybe<Scalars['String']['output']>;
  birthPrefectureDetailForMe?: Maybe<ProfileItemWithScreening>;
  birthPrefectureDetailForOthers?: Maybe<ProfileItemWithScreening>;
  bloodType: Scalars['BloodType']['output'];
  bodyShape: Scalars['BodyShape']['output'];
  childrenExist: Scalars['ChildrenExist']['output'];
  collectedWork: Array<Scalars['String']['output']>;
  collectedWorkForMe?: Maybe<ProfileItemWithScreening>;
  collectedWorkForOthers?: Maybe<ProfileItemWithScreening>;
  communicationType?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyNameForMe?: Maybe<ProfileItemWithScreening>;
  companyNameForOthers?: Maybe<ProfileItemWithScreening>;
  companyNamePublicSetting: Scalars['CompanyNamePublicSetting']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  drinking: Scalars['Drinking']['output'];
  favoriteAlcohol: Array<Scalars['String']['output']>;
  favoriteAlcoholForMe?: Maybe<ProfileItemWithScreening>;
  favoriteAlcoholForOthers?: Maybe<ProfileItemWithScreening>;
  favoriteBrand: Array<Scalars['String']['output']>;
  favoriteBrandForMe?: Maybe<ProfileItemWithScreening>;
  favoriteBrandForOthers?: Maybe<ProfileItemWithScreening>;
  favoriteFood: Array<Scalars['String']['output']>;
  favoriteFoodForMe?: Maybe<ProfileItemWithScreening>;
  favoriteFoodForOthers?: Maybe<ProfileItemWithScreening>;
  favoriteLuxuryItem: Array<Scalars['String']['output']>;
  favoriteLuxuryItemForMe?: Maybe<ProfileItemWithScreening>;
  favoriteLuxuryItemForOthers?: Maybe<ProfileItemWithScreening>;
  firstDatePaymentPreference: Scalars['FirstDatePaymentPreference']['output'];
  goodCountry: Array<Scalars['String']['output']>;
  goodCountryForMe?: Maybe<ProfileItemWithScreening>;
  goodCountryForOthers?: Maybe<ProfileItemWithScreening>;
  goodStore: Array<Scalars['String']['output']>;
  goodStoreForMe?: Maybe<ProfileItemWithScreening>;
  goodStoreForOthers?: Maybe<ProfileItemWithScreening>;
  graduation: Scalars['Graduation']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  hobby: Array<Scalars['String']['output']>;
  hobbyForMe?: Maybe<ProfileItemWithScreening>;
  hobbyForOthers?: Maybe<ProfileItemWithScreening>;
  holiday: Scalars['Holiday']['output'];
  houseWork: Scalars['HouseWork']['output'];
  housemate: Scalars['Housemate']['output'];
  id: Scalars['Int']['output'];
  income: Scalars['IncomeEnum']['output'];
  incomePublicSetting: Scalars['IncomePublicSetting']['output'];
  isCompanyNamePrivate: Scalars['Boolean']['output'];
  jobCategory?: Maybe<JobCategory>;
  jobCategoryId?: Maybe<Scalars['Int']['output']>;
  jobDetail?: Maybe<Scalars['String']['output']>;
  jobDetailForMe?: Maybe<ProfileItemWithScreening>;
  jobDetailForOthers?: Maybe<ProfileItemWithScreening>;
  marriageHistory: Scalars['MarriageHistory']['output'];
  marriageView: Scalars['MarriageView']['output'];
  mbti: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  ownedVehicle: Array<Scalars['String']['output']>;
  ownedVehicleForMe?: Maybe<ProfileItemWithScreening>;
  ownedVehicleForOthers?: Maybe<ProfileItemWithScreening>;
  profileTraits: Array<Scalars['String']['output']>;
  qualification: Array<Scalars['String']['output']>;
  qualificationForMe?: Maybe<ProfileItemWithScreening>;
  qualificationForOthers?: Maybe<ProfileItemWithScreening>;
  recentDeliciousFood?: Maybe<Scalars['String']['output']>;
  recentFavorite?: Maybe<Scalars['String']['output']>;
  recentPurchasedItem?: Maybe<Scalars['String']['output']>;
  recentViewedMovie?: Maybe<Scalars['String']['output']>;
  recentVisitedTown?: Maybe<Scalars['String']['output']>;
  residencePrefecture: Scalars['Prefecture']['output'];
  residencePrefectureDetail?: Maybe<Scalars['String']['output']>;
  residencePrefectureDetailForMe?: Maybe<ProfileItemWithScreening>;
  residencePrefectureDetailForOthers?: Maybe<ProfileItemWithScreening>;
  selfIntroduction?: Maybe<Scalars['String']['output']>;
  sibling: Scalars['Sibling']['output'];
  smoking: Scalars['Smoking']['output'];
  universityName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  wantChild: Scalars['WantChild']['output'];
};

export type ProfileImage = {
  __typename?: 'ProfileImage';
  aiApproval?: Maybe<Scalars['Boolean']['output']>;
  aiDeniedReason?: Maybe<AiScreeningDeniedReasonEnum>;
  createdAt: Scalars['Date']['output'];
  displayMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isMain: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isValidFace?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  publicSetting: Scalars['ProfileImagePublicStatus']['output'];
  status?: Maybe<Scalars['ScreeningStatus']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type ProfileItemWithScreening = {
  __typename?: 'ProfileItemWithScreening';
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  acceptedMatches: AcceptedMatchesOutput;
  acceptedMatchesHavingUserMessage: AcceptedMatchesOutput;
  acceptedTimeLimitedMatchesNotHavingUserMessage: AcceptedMatchesOutput;
  activeVideoCall?: Maybe<VideoCall>;
  adminAbTests: Array<AbTestConfig>;
  adminAdministrators: Array<Administrator>;
  adminCommonSales: Array<Campaign>;
  adminFeatureFlagSetting: FeatureFlagSetting;
  adminFeatureFlagSettings: Array<FeatureFlagSetting>;
  adminForceUpdateSettings: Array<AdminForceUpdateSetting>;
  adminUserAbTestOverrides: Array<UserAbTestOverrideInfo>;
  adminUserAbTests: Array<UserAbTestInfo>;
  advertisements: Array<Advertisement>;
  allAcceptedMatches: AcceptedMatchesOutput;
  ambassadorReferralComment: AmbassadorReferralCommentOutput;
  ambassadorReferralThemes: Array<AmbassadorReferralTheme>;
  ambassadorReferrals: AmbassadorReferralsOutput;
  autoScreeningScore: AutoScreeningScore;
  banner: Array<Banner>;
  checkAgreedLatestPrivacyPolicy: CheckAgreedLatestPrivacyPolicyResponse;
  commonHobbyTags: Array<HobbyTag>;
  communicationTypeEnum: Array<EnumHasOrder>;
  currentAdmin: Administrator;
  currentDateTicket: CurrentDateTicket;
  currentTicket: CurrentTicket;
  currentUser: User;
  currentUserOffers: CurrentUserOffers;
  debugAbTests: Array<DebugAbTestOutput>;
  /** @deprecated 五円セールは forceStartDebugSale(saleType: FiveYenTicket) で対象者にする */
  debugFiveYenTicketSaleTarget: DebugFiveYenTicketSaleTargetOutput;
  /** デバッグメニューの社内ログインで、AndroidのGoogleログインにserverClientIdとして渡すWebクライアントID。Android用クライアントが未設定ならnull */
  debugOperatorGoogleAndroidServerClientId?: Maybe<Scalars['String']['output']>;
  /** デバッグメニューの社内ログインで使う、iOS用のGoogle OAuthクライアントID。未設定ならnull */
  debugOperatorGoogleClientId?: Maybe<Scalars['String']['output']>;
  debugProfile: DebugProfileOutput;
  debugUserEmailAnonymizationCandidates: DebugUserEmailAnonymizationCandidatesOutput;
  debugUserInfo: DebugUserInfoOutput;
  debugUserLifecycleCandidates: Array<DebugUserLifecycleCandidateOutput>;
  featureFlagSetting: ClientFeatureFlagSetting;
  featureFlags: FeatureFlags;
  findManyResizedProfileImages: Array<FindProfileImageOutput>;
  footprintCount: Scalars['Int']['output'];
  footprintUsers: SpecialUsersOutput;
  footprints: FootprintsOutput;
  getActiveChanceTime: ChanceTime;
  getActiveListPromotion: ListPromotionSettings;
  getAmbassadorReferralRewardTicketInfo: AmbassadorReferralRewardTicketInfoOutput;
  getAutoScreeningInfo: GetAutoScreeningInfoOutput;
  getCurrentUserLoginProvider?: Maybe<LoginProviderEnum>;
  getIsEligibleForSuperLikeInactiveUserOnPickup: Scalars['Boolean']['output'];
  getIsFreeAppealRunnable: Scalars['Boolean']['output'];
  getIsInitialSubscriptionFreeAppealAvailable: Scalars['Boolean']['output'];
  getIsInitialSubscriptionFreeMessageLikeAvailable: Scalars['Boolean']['output'];
  getIsInitialSubscriptionFreeSuperLikeAvailable: Scalars['Boolean']['output'];
  getIsTopPicksFreeLikable: Scalars['Boolean']['output'];
  getLatestLegalDocumentAgreementStatuses: GetLatestLegalDocumentAgreementStatusesOutput;
  getMatch: Match;
  getMatchedUsersHavingMessage: GetMatchedUsersHavingMessageOutput;
  getMyRunningAppeal?: Maybe<Appeal>;
  getProfileItemForOthers: GetProfileItemForOthersOutput;
  getRewardCode: GetRewardCodeOutput;
  getScheduledEmailNotification: GetScheduledEmailNotificationOutput;
  getScheduledEmailNotificationList: GetScheduledEmailNotificationListOutput;
  getScheduledInAppNews: GetScheduledInAppNewsOutput;
  getScheduledInAppNewsList: GetScheduledInAppNewsListOutput;
  getScheduledModalNotification: GetScheduledModalNotificationOutput;
  getScheduledModalNotificationList: GetScheduledModalNotificationListOutput;
  getScheduledNotificationList: GetScheduledNotificationListOutput;
  getScheduledNotificationManagementNames: Array<Scalars['String']['output']>;
  getScheduledNotificationsForExport: Array<ScheduledNotificationExportItem>;
  getScheduledPushNotification: GetScheduledPushNotificationOutput;
  getScheduledPushNotificationList: GetScheduledPushNotificationListOutput;
  getStickerApplicationStatus: StickerApplicationStatusOutput;
  getTodayAvailability: TodayAvailabilityOutput;
  getUnreadCount: UnreadCount;
  getUserGorgeousJumboStatus: UserGorgeousJumboStatusOutput;
  getUserGorgeousJumboTicketsCountByRound: GetUserGorgeousJumboTicketsCountOutput;
  giftCatalogs: Array<GiftCatalog>;
  hiddenMatches: AcceptedMatchesOutput;
  hobbyTagCategories: Array<HobbyTagCategory>;
  hobbyTags: Array<HobbyTag>;
  hobbyTagsByIds: Array<HobbyTag>;
  incomeCertificationProgress: IncomeCertificationProgressOutput;
  isAppealEffectUpCampaignActive: Scalars['Boolean']['output'];
  isCurrentUserGgMarriageInvitationTarget: Scalars['Boolean']['output'];
  isFlashReferralCampaignActive: Scalars['Boolean']['output'];
  jobCategories: Array<JobCategory>;
  latestIdentificationImage?: Maybe<IdentificationImage>;
  latestIncomeConfirmationImage?: Maybe<IncomeConfirmationImage>;
  latestJobCertificationImage?: Maybe<JobCertificationImage>;
  latestRejectedUser?: Maybe<User>;
  latestSkippedUser?: Maybe<User>;
  latestUncommentedAmbassadorReferral: LatestUncommentedAmbassadorReferralOutput;
  likedUsers: SpecialUsersOutput;
  maintenanceStatus?: Maybe<MaintenanceStatus>;
  matchWithOpponentUser: MatchWithOpponentUser;
  messages: Array<Message>;
  messagesFilteredCount?: Maybe<Scalars['Int']['output']>;
  messagesWithSignedImageUrls: MessagesWithSignedImageUrlOutput;
  mynaConnectIncomeSessionsForAdmin: MynaConnectIncomeSessionsForAdminPage;
  mynaConnectMarriageSessionsForAdmin: MynaConnectMarriageSessionsForAdminPage;
  normalNews: Array<News>;
  normalNewsDetail?: Maybe<News>;
  normalNewsDetailByTitle?: Maybe<News>;
  otherUser: OtherUser;
  paginatedApproachingMatches: ApproachingMatchesListOutput;
  paginatedInterestedUsers: InterestedUsersListOutput;
  paginatedMyApproachedMatches: MyApproachedMatchesListOutput;
  products: Array<Product>;
  quickTrustLatestVerificationSessionByUserId?: Maybe<QuickTrustPendingReviewSession>;
  recentFootprintUsers: Array<RecentFootprintUserOutput>;
  recentUsers: SpecialUsersOutput;
  recommendedHobbyTags: Array<HobbyTag>;
  registrationAbTestVariant: Scalars['String']['output'];
  rejectedMatches: RejectedMatchesListOutput;
  screeningPendingCounts: ScreeningPendingCounts;
  searchHobbyTags: Array<HobbyTag>;
  searchUserAdvertisements: SearchUserAdvertisementsOutput;
  searchUserPreviews: SearchUserPreviewsOutput;
  searchUsers: SearchUsersOutput;
  selectTopPicks: TodaysPickupUsersOutput;
  selectedJobCategoryIdsForTrustMode: Array<Scalars['Int']['output']>;
  similarUsers: SpecialUsersOutput;
  singleCertificationProgress: SingleCertificationProgressOutput;
  syncMessageRoom: SyncMessageRoomOutput;
  testHealth: Scalars['String']['output'];
  ticketHistories: TicketHistoryOutput;
  ticketMenus: Array<TicketMenu>;
  ticketPurchaseMenu: TicketPurchaseMenu;
  tmpUser?: Maybe<TmpUser>;
  todaysPassedRate: TodaysPassedRate;
  todaysPickupUsersSelectedInfo: TodaysPickupUsersSelectedInfoOutput;
  topPicksBulkLikePrice: TopPicksBulkLikePriceOutput;
  topRejectedMatches: RejectedMatchesListOutput;
  unviewedApproachMatches: UnviewedApproachMatchesOutput;
  userInfoForIdentify: UserInfoForIdentifyOutput;
  versionRequirement?: Maybe<VersionRequirement>;
  videoCall: VideoCall;
  webCurrentDateTicket: CurrentDateTicket;
  webCurrentTicket: CurrentTicket;
  webCurrentUser: WebCurrentUser;
  webDateTicketHistories: WebDateTicketHistoriesOutput;
  webGetCurrentUserLoginProvider?: Maybe<LoginProviderEnum>;
  webGetSubscriptionUpgradePrice: WebGetSubscriptionUpgradePriceOutput;
  webHelloPayAvailability: WebHelloPayAvailabilityOutput;
  webHelloPayCards: WebHelloPayCardsOutput;
  /** 最新のHelloPay契約。申込がなければnull */
  webHelloPaySubscription?: Maybe<HelloPaySubscription>;
  /** 本人の申込について確定した初回決済の失敗 */
  webHelloPaySubscriptionInitialFailure?: Maybe<WebHelloPaySubscriptionInitialFailure>;
  /** 同じ期間のプラチナへのアップグレード差額。15分以内にwebUpgradeHelloPaySubscriptionへ渡す */
  webHelloPaySubscriptionUpgradeQuote: WebHelloPaySubscriptionUpgradeQuote;
  webProducts: Array<Product>;
  webTicketMenus: Array<TicketMenu>;
  webTicketOrder: WebTicketOrderOutput;
  webTicketPurchaseMenu: TicketPurchaseMenu;
  withdrawalReasonEnum: Array<EnumHasOrder>;
};


export type QueryAcceptedMatchesArgs = {
  input: AcceptedMatchesInput;
};


export type QueryAcceptedMatchesHavingUserMessageArgs = {
  input: AcceptedMatchesInput;
};


export type QueryAcceptedTimeLimitedMatchesNotHavingUserMessageArgs = {
  input: AcceptedMatchesInput;
};


export type QueryActiveVideoCallArgs = {
  matchId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminAbTestsArgs = {
  includeRetired?: Scalars['Boolean']['input'];
};


export type QueryAdminFeatureFlagSettingArgs = {
  key: Scalars['String']['input'];
};


export type QueryAdminForceUpdateSettingsArgs = {
  beforeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminUserAbTestOverridesArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryAdminUserAbTestsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryAllAcceptedMatchesArgs = {
  input: AcceptedMatchesInput;
};


export type QueryAmbassadorReferralCommentArgs = {
  opponentUserId: Scalars['Int']['input'];
};


export type QueryAutoScreeningScoreArgs = {
  autoScreeningScoreInput: AutoScreeningScoreInput;
};


export type QueryCommonHobbyTagsArgs = {
  matchId: Scalars['Int']['input'];
};


export type QueryDebugUserEmailAnonymizationCandidatesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryDebugUserInfoArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryFeatureFlagSettingArgs = {
  key: Scalars['String']['input'];
};


export type QueryFindManyResizedProfileImagesArgs = {
  findProfileImagesInput: FindProfileImagesInput;
};


export type QueryFootprintUsersArgs = {
  input: SpecialUsersInput;
};


export type QueryFootprintsArgs = {
  input: FootprintsInput;
};


export type QueryGetIsFreeAppealRunnableArgs = {
  startAtMonthDate: Scalars['Date']['input'];
};


export type QueryGetMatchArgs = {
  matchId: Scalars['Int']['input'];
};


export type QueryGetMatchedUsersHavingMessageArgs = {
  input: GetMatchedUsersHavingMessagesInput;
};


export type QueryGetProfileItemForOthersArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryGetScheduledEmailNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetScheduledInAppNewsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetScheduledModalNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetScheduledNotificationListArgs = {
  input?: InputMaybe<GetScheduledNotificationListInput>;
};


export type QueryGetScheduledNotificationsForExportArgs = {
  targets: Array<ScheduledNotificationExportTargetInput>;
};


export type QueryGetScheduledPushNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetTodayAvailabilityArgs = {
  input: TodayAvailabilityUsersInput;
};


export type QueryGetUserGorgeousJumboTicketsCountByRoundArgs = {
  input: GetUserGorgeousJumboTicketsCountByRoundInput;
};


export type QueryHiddenMatchesArgs = {
  input: AcceptedMatchesInput;
};


export type QueryHobbyTagsArgs = {
  hobbyTagCategoryId: Scalars['Int']['input'];
};


export type QueryHobbyTagsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryIncomeCertificationProgressArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryLikedUsersArgs = {
  input: SpecialUsersInput;
};


export type QueryMatchWithOpponentUserArgs = {
  matchId: Scalars['Int']['input'];
};


export type QueryMessagesArgs = {
  matchId: Scalars['Int']['input'];
};


export type QueryMessagesFilteredCountArgs = {
  where?: InputMaybe<MessageWhereInput>;
};


export type QueryMessagesWithSignedImageUrlsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessageOrderByInput>>;
  where?: InputMaybe<MessageWhereInput>;
};


export type QueryMynaConnectIncomeSessionsForAdminArgs = {
  filter: MynaConnectCertificationFilter;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMynaConnectMarriageSessionsForAdminArgs = {
  filter: MynaConnectCertificationFilter;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNormalNewsArgs = {
  input: NormalNewsInput;
};


export type QueryNormalNewsDetailArgs = {
  newsId: Scalars['Int']['input'];
};


export type QueryNormalNewsDetailByTitleArgs = {
  title: Scalars['String']['input'];
};


export type QueryOtherUserArgs = {
  input: GetOtherUserInput;
};


export type QueryPaginatedApproachingMatchesArgs = {
  input: ApproachingMatchesInput;
};


export type QueryPaginatedInterestedUsersArgs = {
  input?: InputMaybe<InterestedUsersInput>;
};


export type QueryPaginatedMyApproachedMatchesArgs = {
  input: MyApproachingMatchesInput;
};


export type QueryQuickTrustLatestVerificationSessionByUserIdArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryRecentFootprintUsersArgs = {
  includeRead?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRecentUsersArgs = {
  input: SpecialUsersInput;
};


export type QueryRegistrationAbTestVariantArgs = {
  testKey: Scalars['String']['input'];
  tmpUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRejectedMatchesArgs = {
  input: RejectedMatchesInput;
};


export type QuerySearchHobbyTagsArgs = {
  input: SearchHobbyTagsInput;
};


export type QuerySearchUserPreviewsArgs = {
  input: SearchUsersInput;
};


export type QuerySearchUsersArgs = {
  input: SearchUsersInput;
};


export type QuerySimilarUsersArgs = {
  input: SimilarUsersInput;
};


export type QuerySingleCertificationProgressArgs = {
  sessionId: Scalars['String']['input'];
};


export type QuerySyncMessageRoomArgs = {
  input: SyncMessageRoomInput;
};


export type QueryTicketHistoriesArgs = {
  input: TicketHistoryInput;
};


export type QueryTmpUserArgs = {
  id: Scalars['Int']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopPicksBulkLikePriceArgs = {
  input: TopPicksBulkLikePriceInput;
};


export type QueryTopRejectedMatchesArgs = {
  input: RejectedMatchesInput;
};


export type QueryVideoCallArgs = {
  videoCallId: Scalars['Int']['input'];
};


export type QueryWebGetSubscriptionUpgradePriceArgs = {
  input: WebGetSubscriptionUpgradePriceInput;
};


export type QueryWebHelloPaySubscriptionInitialFailureArgs = {
  requestId: Scalars['String']['input'];
};


export type QueryWebHelloPaySubscriptionUpgradeQuoteArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryWebTicketOrderArgs = {
  input: WebTicketOrderInput;
};

export type QuickTrustPendingReviewSession = {
  __typename?: 'QuickTrustPendingReviewSession';
  createdAt: Scalars['Date']['output'];
  faceMatchSimilarity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  status: QuickTrustSessionStatus;
  userId: Scalars['Int']['output'];
};

export const QuickTrustSessionStatus = {
  ApprovedByManualReview: 'ApprovedByManualReview',
  Created: 'Created',
  FaceMatchApproved: 'FaceMatchApproved',
  FaceMatchPendingReview: 'FaceMatchPendingReview',
  FaceMatchRejected: 'FaceMatchRejected',
  RejectedByManualReview: 'RejectedByManualReview',
  SessionApproved: 'SessionApproved',
  SessionPendingReview: 'SessionPendingReview',
  SessionRejected: 'SessionRejected'
} as const;

export type QuickTrustSessionStatus = typeof QuickTrustSessionStatus[keyof typeof QuickTrustSessionStatus];
export type ReactivateUserByAdminInput = {
  memo: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type ReapplyForScreeningInput = {
  adjustDeviceId?: InputMaybe<Scalars['String']['input']>;
  afCampaign?: InputMaybe<Scalars['String']['input']>;
  afConversionData?: InputMaybe<Scalars['String']['input']>;
  afMediaSource?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  campaignCode?: InputMaybe<CampaignCodeInput>;
  celebrityBadgePublicSetting?: InputMaybe<Scalars['CelebrityBadgePublicStatus']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstPrivacyPolicyAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  firstTermsOfServiceAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['Gender']['input']>;
  graduation?: InputMaybe<Scalars['Graduation']['input']>;
  income?: InputMaybe<Scalars['IncomeEnum']['input']>;
  incomePublicSetting?: InputMaybe<Scalars['IncomePublicSetting']['input']>;
  initialPrivacyPolicyRevisedAt?: InputMaybe<Scalars['Date']['input']>;
  installType?: InputMaybe<Scalars['String']['input']>;
  jobCategoryId?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['PlatformType']['input'];
  profileImagePublicSetting?: InputMaybe<Scalars['ProfileImagePublicStatus']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  residencePrefecture?: InputMaybe<Scalars['Prefecture']['input']>;
  tmpUserId?: InputMaybe<Scalars['Int']['input']>;
  tmpUserSessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type ReceivedAmbassadorReferralComment = {
  __typename?: 'ReceivedAmbassadorReferralComment';
  ambassadorReferralThemeId: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isVisible: Scalars['Boolean']['output'];
  nickname: Scalars['String']['output'];
};

export type RecentFootprintUserOutput = {
  __typename?: 'RecentFootprintUserOutput';
  imageUrlSmall: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export const RecommendContentType = {
  DateFirst: 'DateFirst',
  Footprint: 'Footprint',
  Liked: 'Liked',
  Recent: 'Recent',
  Trusted: 'Trusted'
} as const;

export type RecommendContentType = typeof RecommendContentType[keyof typeof RecommendContentType];
export type ReferralCode = {
  __typename?: 'ReferralCode';
  code: Scalars['String']['output'];
  expiredAt: Scalars['Date']['output'];
  type: Scalars['String']['output'];
};

export type ReferralCommentVisibilityItem = {
  commentId: Scalars['Int']['input'];
  isVisible: Scalars['Boolean']['input'];
};

export type RefreshAccessTokenInput = {
  refreshToken: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type RefreshAccessTokenResponse = {
  __typename?: 'RefreshAccessTokenResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
};

export type RegisterOptionalProfileInput = {
  birthPrefecture?: InputMaybe<Scalars['Prefecture']['input']>;
  birthPrefectureDetail?: InputMaybe<Scalars['String']['input']>;
  bloodType?: InputMaybe<Scalars['BloodType']['input']>;
  bodyShape?: InputMaybe<Scalars['BodyShape']['input']>;
  childrenExist?: InputMaybe<Scalars['ChildrenExist']['input']>;
  communicationType?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  drinking?: InputMaybe<Scalars['Drinking']['input']>;
  firstDatePaymentPreference?: InputMaybe<Scalars['FirstDatePaymentPreference']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  holiday?: InputMaybe<Scalars['Holiday']['input']>;
  houseWork?: InputMaybe<Scalars['HouseWork']['input']>;
  housemate?: InputMaybe<Scalars['Housemate']['input']>;
  marriageHistory?: InputMaybe<Scalars['MarriageHistory']['input']>;
  marriageView?: InputMaybe<Scalars['MarriageView']['input']>;
  mbti?: InputMaybe<Scalars['String']['input']>;
  recentDeliciousFood?: InputMaybe<Scalars['String']['input']>;
  recentFavorite?: InputMaybe<Scalars['String']['input']>;
  recentPurchasedItem?: InputMaybe<Scalars['String']['input']>;
  recentViewedMovie?: InputMaybe<Scalars['String']['input']>;
  recentVisitedTown?: InputMaybe<Scalars['String']['input']>;
  residencePrefectureDetail?: InputMaybe<Scalars['String']['input']>;
  sibling?: InputMaybe<Scalars['Sibling']['input']>;
  smoking?: InputMaybe<Scalars['Smoking']['input']>;
  universityName?: InputMaybe<Scalars['String']['input']>;
  wantChild?: InputMaybe<Scalars['WantChild']['input']>;
};

export type RejectUserInput = {
  screeningFailedReason?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type RejectedMatchesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RejectedMatchesListOutput = {
  __typename?: 'RejectedMatchesListOutput';
  matches: Array<MatchWithOpponentUser>;
  pageInfo: PageInfo;
};

export type RemoveIncomeScreeningImageForStorageInput = {
  path: Scalars['String']['input'];
};

export type RemoveJobScreeningImageForStorageInput = {
  path: Scalars['String']['input'];
};

export type RemoveProfileImageInput = {
  profileImageId: Scalars['Int']['input'];
};

export type ReportUserInput = {
  body: Scalars['String']['input'];
  reason: Scalars['ReportUserReason']['input'];
  targetUserId: Scalars['Int']['input'];
};

export type ResizedMessageImage = {
  __typename?: 'ResizedMessageImage';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  imageUrlMedium: Scalars['String']['output'];
  message?: Maybe<Message>;
  messageId: Scalars['Int']['output'];
  path?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ResizedProfileImage = {
  __typename?: 'ResizedProfileImage';
  aiApproval?: Maybe<Scalars['Boolean']['output']>;
  aiDeniedReason?: Maybe<AiScreeningDeniedReasonEnum>;
  createdAt: Scalars['Date']['output'];
  displayMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrlMedium: Scalars['String']['output'];
  imageUrlMediumNonBlur?: Maybe<Scalars['String']['output']>;
  imageUrlSmall: Scalars['String']['output'];
  isMain: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isValidFace?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  publicSetting: Scalars['ProfileImagePublicStatus']['output'];
  status?: Maybe<Scalars['ScreeningStatus']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type ResolveHelloPayPaymentInput = {
  attemptId: Scalars['String']['input'];
  /** 課金なし、未完了リクエストなし、今後この試行が請求されないことをHelloPayに確認した */
  confirmedNoChargeOrPendingRequest: Scalars['Boolean']['input'];
  /** HelloPayに確認した日時（タイムゾーンを含む ISO 8601） */
  providerConfirmedAt: Scalars['String']['input'];
  providerContact: Scalars['String']['input'];
  providerReference: Scalars['String']['input'];
  providerResponse: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  workerStopReference?: InputMaybe<Scalars['String']['input']>;
  workerStopTarget?: InputMaybe<Scalars['String']['input']>;
  /** 未完了送信時、当該旧世代の停止を確認した日時 */
  workerStoppedAt?: InputMaybe<Scalars['String']['input']>;
};

export type RestoreForceUpdateSettingInput = {
  expectedCurrentId?: InputMaybe<Scalars['Int']['input']>;
  sourceId: Scalars['Int']['input'];
  storeAvailabilityConfirmed: Scalars['Boolean']['input'];
};

export type RotateAccessTokenResponse = {
  __typename?: 'RotateAccessTokenResponse';
  newAccessToken: Scalars['String']['output'];
};

export type ScheduledEmailNotificationItem = {
  __typename?: 'ScheduledEmailNotificationItem';
  createdAt: Scalars['Date']['output'];
  dynamicTemplateData: Scalars['String']['output'];
  emailName: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  forceSendFlg: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAdvertisingEmail: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ScheduledInAppNewsListItem = {
  __typename?: 'ScheduledInAppNewsListItem';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ScheduledModalNotificationItem = {
  __typename?: 'ScheduledModalNotificationItem';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Float']['output'];
  imageHeightAspectRatio?: Maybe<Scalars['Float']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  primaryButtonText?: Maybe<Scalars['String']['output']>;
  primaryButtonUrl?: Maybe<Scalars['String']['output']>;
  publishEndedAt?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ScheduledNotificationExportItem = {
  __typename?: 'ScheduledNotificationExportItem';
  body?: Maybe<Scalars['String']['output']>;
  dynamicTemplateData?: Maybe<Scalars['String']['output']>;
  emailName?: Maybe<Scalars['String']['output']>;
  forceSendFlg?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  imageHeightAspectRatio?: Maybe<Scalars['Float']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isAdvertisingEmail?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notificationCategory?: Maybe<Scalars['String']['output']>;
  notificationType: ScheduledNotificationTypeEnum;
  notifyAt: Scalars['Date']['output'];
  primaryButtonText?: Maybe<Scalars['String']['output']>;
  primaryButtonUrl?: Maybe<Scalars['String']['output']>;
  publishEndedAt?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ScheduledNotificationExportTargetInput = {
  id: Scalars['Int']['input'];
  notificationType: ScheduledNotificationTypeEnum;
};

export type ScheduledNotificationListItem = {
  __typename?: 'ScheduledNotificationListItem';
  createdAt: Scalars['Date']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  managementName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notificationType: ScheduledNotificationTypeEnum;
  notifyAt: Scalars['Date']['output'];
  status: ScheduledNotificationStatusEnum;
  summary: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export const ScheduledNotificationStatusEnum = {
  Active: 'Active',
  Draft: 'Draft',
  Executed: 'Executed'
} as const;

export type ScheduledNotificationStatusEnum = typeof ScheduledNotificationStatusEnum[keyof typeof ScheduledNotificationStatusEnum];
export type ScheduledNotificationStatusTargetInput = {
  id: Scalars['Int']['input'];
  notificationType: ScheduledNotificationTypeEnum;
};

export const ScheduledNotificationTypeEnum = {
  Email: 'Email',
  InAppNews: 'InAppNews',
  Modal: 'Modal',
  Push: 'Push'
} as const;

export type ScheduledNotificationTypeEnum = typeof ScheduledNotificationTypeEnum[keyof typeof ScheduledNotificationTypeEnum];
export type ScheduledPushNotificationItem = {
  __typename?: 'ScheduledPushNotificationItem';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notificationCategory: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ScreeningImage = {
  __typename?: 'ScreeningImage';
  createdAt?: Maybe<Scalars['Date']['output']>;
  failedReason: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  methodType: Scalars['String']['output'];
  status?: Maybe<Scalars['ScreeningStatus']['output']>;
  type: Scalars['ScreeningImageType']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type ScreeningImageStatusInputDto = {
  failedReason?: InputMaybe<Scalars['String']['input']>;
  screeningImageId: Scalars['Int']['input'];
  status: Scalars['ScreeningStatus']['input'];
  userId: Scalars['Int']['input'];
};

export type ScreeningPendingCounts = {
  __typename?: 'ScreeningPendingCounts';
  approachMessage: Scalars['Int']['output'];
  celebrityCertification: Scalars['Int']['output'];
  hobbyTags: Scalars['Int']['output'];
  identification: Scalars['Int']['output'];
  incomeConfirmation: Scalars['Int']['output'];
  jobCertification: Scalars['Int']['output'];
  profileImages: Scalars['Int']['output'];
  profileItems: Scalars['Int']['output'];
  screening: Scalars['Int']['output'];
  selfIntroductions: Scalars['Int']['output'];
};

export type SearchHobbyTagsInput = {
  keyword: Scalars['String']['input'];
};

export type SearchUserAdvertisement = {
  __typename?: 'SearchUserAdvertisement';
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  targetUrl: Scalars['String']['output'];
};

export type SearchUserAdvertisementSettings = {
  __typename?: 'SearchUserAdvertisementSettings';
  promotionOffset: Scalars['Int']['output'];
  showInterval: Scalars['Int']['output'];
  startShowingIndex: Scalars['Int']['output'];
};

export type SearchUserAdvertisementsOutput = {
  __typename?: 'SearchUserAdvertisementsOutput';
  advertisements: Array<SearchUserAdvertisement>;
  settings: SearchUserAdvertisementSettings;
};

export type SearchUserConditionInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  birthPrefectures?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyShapes?: InputMaybe<Array<Scalars['String']['input']>>;
  childrenExists?: InputMaybe<Array<Scalars['String']['input']>>;
  communicationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  drinkings?: InputMaybe<Array<Scalars['String']['input']>>;
  firstDatePaymentPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  graduations?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSelfIntroduction?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubProfileImages?: InputMaybe<Scalars['Boolean']['input']>;
  heightFrom?: InputMaybe<Scalars['Int']['input']>;
  heightTo?: InputMaybe<Scalars['Int']['input']>;
  hobbyTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  holidays?: InputMaybe<Array<Scalars['String']['input']>>;
  houseWorks?: InputMaybe<Array<Scalars['String']['input']>>;
  housemates?: InputMaybe<Array<Scalars['String']['input']>>;
  incomeFrom?: InputMaybe<Scalars['Int']['input']>;
  incomeTo?: InputMaybe<Scalars['Int']['input']>;
  isHighDatingIntent?: InputMaybe<Scalars['Boolean']['input']>;
  isIdentified?: InputMaybe<Scalars['Boolean']['input']>;
  isIncomeConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  isJobCertified?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleCertified?: InputMaybe<Scalars['Boolean']['input']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  marriageHistories?: InputMaybe<Array<Scalars['String']['input']>>;
  marriageViews?: InputMaybe<Array<Scalars['String']['input']>>;
  mbtis?: InputMaybe<Array<Scalars['String']['input']>>;
  profileImagePublicSettings?: InputMaybe<Array<Scalars['String']['input']>>;
  residencePrefectures?: InputMaybe<Array<Scalars['String']['input']>>;
  shouldShowApproachedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  smokings?: InputMaybe<Array<Scalars['String']['input']>>;
  wantChilds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchUserPreview = {
  __typename?: 'SearchUserPreview';
  age: Scalars['Int']['output'];
  approachStatus: Scalars['String']['output'];
  fiveLevelRank: Scalars['String']['output'];
  gender: Scalars['Gender']['output'];
  id: Scalars['Int']['output'];
  identificationStatus: Scalars['ScreeningStatus']['output'];
  incomeConfirmationStatus: Scalars['ScreeningStatus']['output'];
  isApproachedFromLoginUser: Scalars['Boolean']['output'];
  isCelebrityCertified: Scalars['Boolean']['output'];
  isMatched: Scalars['Boolean']['output'];
  isNewUser: Scalars['Boolean']['output'];
  isProfileImagePrivate: Scalars['Boolean']['output'];
  isSingleCertified: Scalars['Boolean']['output'];
  isTopGorgeous: Scalars['Boolean']['output'];
  isTrustMode: Scalars['Boolean']['output'];
  jobCertificationStatus: Scalars['ScreeningStatus']['output'];
  mainProfileImage?: Maybe<ResizedProfileImage>;
  onlineStatus?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<SearchUserPreviewProfile>;
  recommendHigherLikeWhenLikedByOthers?: Maybe<Scalars['Boolean']['output']>;
  shouldShowCelebrityBadge: Scalars['Boolean']['output'];
  ultraLikeResendableAt?: Maybe<Scalars['Date']['output']>;
};

export type SearchUserPreviewProfile = {
  __typename?: 'SearchUserPreviewProfile';
  communicationType?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyNamePublicSetting: Scalars['CompanyNamePublicSetting']['output'];
  graduation: Scalars['Graduation']['output'];
  income: Scalars['IncomeEnum']['output'];
  incomePublicSetting: Scalars['IncomePublicSetting']['output'];
  jobCategoryId?: Maybe<Scalars['Int']['output']>;
  jobDetail?: Maybe<Scalars['String']['output']>;
  nickname: Scalars['String']['output'];
  residencePrefecture: Scalars['Prefecture']['output'];
  selfIntroduction?: Maybe<Scalars['String']['output']>;
  universityName?: Maybe<Scalars['String']['output']>;
};

export type SearchUserPreviewsOutput = {
  __typename?: 'SearchUserPreviewsOutput';
  /** @deprecated Gold会員向けに恒久開放済み。旧アプリ互換のため常にtrue */
  featureFlagGoldSearchSort: Scalars['Boolean']['output'];
  pageInfo: CursorPageInfo;
  users: Array<SearchUserPreview>;
};

export type SearchUsersInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
};

export type SearchUsersOutput = {
  __typename?: 'SearchUsersOutput';
  /** @deprecated Gold会員向けに恒久開放済み。旧アプリ互換のため常にtrue */
  featureFlagGoldSearchSort: Scalars['Boolean']['output'];
  pageInfo: CursorPageInfo;
  users: Array<User>;
};

export type SecondWelcomeBackSale = {
  __typename?: 'SecondWelcomeBackSale';
  bannerImageUrl: Scalars['String']['output'];
  carouselBannerImageUrl: Scalars['String']['output'];
  discountRatePercentages: Scalars['Float']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isAvailableForGold: Scalars['Boolean']['output'];
  isAvailableForPlatinum: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
  textForWebBanner: Scalars['String']['output'];
};

export type SecondWelcomeSale = {
  __typename?: 'SecondWelcomeSale';
  bannerImageUrl: Scalars['String']['output'];
  carouselBannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
  textForWebBanner: Scalars['String']['output'];
};

export type SecondWelcomeTicketSale = {
  __typename?: 'SecondWelcomeTicketSale';
  bannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isBoostTarget: Scalars['Boolean']['output'];
  isCampaignAvailable: Scalars['Boolean']['output'];
  isDiscountTarget: Scalars['Boolean']['output'];
  isHighIncomeTarget: Scalars['Boolean']['output'];
  isLowIncomeTargetOver30: Scalars['Boolean']['output'];
  isLowIncomeTargetUnder30: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
};

export type SelfIntroduction = {
  __typename?: 'SelfIntroduction';
  aiReviewedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  failedReason: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  selfIntroduction?: Maybe<Scalars['String']['output']>;
  status: Scalars['ScreeningStatus']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId: Scalars['Int']['output'];
};

export type SendMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['Int']['input'];
  type: Scalars['MessageType']['input'];
};

export type ShadowBanUserInput = {
  userId: Scalars['Int']['input'];
};

export type SignUpInput = {
  adjustDeviceId?: InputMaybe<Scalars['String']['input']>;
  afCampaign?: InputMaybe<Scalars['String']['input']>;
  afConversionData?: InputMaybe<Scalars['String']['input']>;
  afMediaSource?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  campaignCode?: InputMaybe<CampaignCodeInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstPrivacyPolicyAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  firstTermsOfServiceAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['Gender']['input']>;
  graduation?: InputMaybe<Scalars['Graduation']['input']>;
  income?: InputMaybe<Scalars['IncomeEnum']['input']>;
  initialPrivacyPolicyRevisedAt?: InputMaybe<Scalars['Date']['input']>;
  installType?: InputMaybe<Scalars['String']['input']>;
  jobCategoryId?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phoneConfirmedAt?: InputMaybe<Scalars['Date']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneSignUpToken?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['PlatformType']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  residencePrefecture?: InputMaybe<Scalars['Prefecture']['input']>;
  tmpUserId?: InputMaybe<Scalars['Int']['input']>;
  tmpUserSessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type SignUpWithAppleInput = {
  adjustDeviceId?: InputMaybe<Scalars['String']['input']>;
  afCampaign?: InputMaybe<Scalars['String']['input']>;
  afConversionData?: InputMaybe<Scalars['String']['input']>;
  afMediaSource?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  campaignCode?: InputMaybe<CampaignCodeInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstPrivacyPolicyAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  firstTermsOfServiceAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['Gender']['input']>;
  graduation?: InputMaybe<Scalars['Graduation']['input']>;
  idToken: Scalars['String']['input'];
  income?: InputMaybe<Scalars['IncomeEnum']['input']>;
  initialPrivacyPolicyRevisedAt?: InputMaybe<Scalars['Date']['input']>;
  installType?: InputMaybe<Scalars['String']['input']>;
  jobCategoryId?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['PlatformType']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  residencePrefecture?: InputMaybe<Scalars['Prefecture']['input']>;
  tmpUserId?: InputMaybe<Scalars['Int']['input']>;
  tmpUserSessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type SignUpWithLineInput = {
  adjustDeviceId?: InputMaybe<Scalars['String']['input']>;
  afCampaign?: InputMaybe<Scalars['String']['input']>;
  afConversionData?: InputMaybe<Scalars['String']['input']>;
  afMediaSource?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  campaignCode?: InputMaybe<CampaignCodeInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstPrivacyPolicyAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  firstTermsOfServiceAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['Gender']['input']>;
  graduation?: InputMaybe<Scalars['Graduation']['input']>;
  idToken: Scalars['String']['input'];
  income?: InputMaybe<Scalars['IncomeEnum']['input']>;
  initialPrivacyPolicyRevisedAt?: InputMaybe<Scalars['Date']['input']>;
  installType?: InputMaybe<Scalars['String']['input']>;
  jobCategoryId?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['PlatformType']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  residencePrefecture?: InputMaybe<Scalars['Prefecture']['input']>;
  tmpUserId?: InputMaybe<Scalars['Int']['input']>;
  tmpUserSessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type SignUpWithPhoneInput = {
  adjustDeviceId?: InputMaybe<Scalars['String']['input']>;
  afCampaign?: InputMaybe<Scalars['String']['input']>;
  afConversionData?: InputMaybe<Scalars['String']['input']>;
  afMediaSource?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  campaignCode?: InputMaybe<CampaignCodeInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstPrivacyPolicyAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  firstTermsOfServiceAgreedAt?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['Gender']['input']>;
  graduation?: InputMaybe<Scalars['Graduation']['input']>;
  income?: InputMaybe<Scalars['IncomeEnum']['input']>;
  initialPrivacyPolicyRevisedAt?: InputMaybe<Scalars['Date']['input']>;
  installType?: InputMaybe<Scalars['String']['input']>;
  jobCategoryId?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneSignUpToken?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['PlatformType']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  residencePrefecture?: InputMaybe<Scalars['Prefecture']['input']>;
  tmpUserId?: InputMaybe<Scalars['Int']['input']>;
  tmpUserSessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type SimilarUsersInput = {
  targetUserId: Scalars['Int']['input'];
};

export const SingleCertificationDisplayStatus = {
  Certified: 'Certified',
  Expired: 'Expired',
  ExpiringSoon: 'ExpiringSoon',
  None: 'None'
} as const;

export type SingleCertificationDisplayStatus = typeof SingleCertificationDisplayStatus[keyof typeof SingleCertificationDisplayStatus];
export type SingleCertificationProgressOutput = {
  __typename?: 'SingleCertificationProgressOutput';
  errorReason: Scalars['Float']['output'];
  status: Scalars['Float']['output'];
};

export type SpecialUsersInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  prefectureFilterType?: InputMaybe<PrefectureFilterType>;
};

export type SpecialUsersOutput = {
  __typename?: 'SpecialUsersOutput';
  pageInfo: CursorPageInfo;
  users: Array<User>;
};

export type StartIncomeCertificationOutput = {
  __typename?: 'StartIncomeCertificationOutput';
  redirectUri: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type StartSingleCertificationOutput = {
  __typename?: 'StartSingleCertificationOutput';
  redirectUri: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type StarterPackSale = {
  __typename?: 'StarterPackSale';
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['Int']['output'];
  shortName: Scalars['String']['output'];
};

export type StickerApplication = {
  __typename?: 'StickerApplication';
  createdAt: Scalars['Date']['output'];
  gorgeousRankEnumSnapshot: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  shippmentAddress: Scalars['String']['output'];
  shippmentZipCode: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type StickerApplicationStatusOutput = {
  __typename?: 'StickerApplicationStatusOutput';
  status: Scalars['String']['output'];
};

export type SubSubscriptionSpecialSale = {
  __typename?: 'SubSubscriptionSpecialSale';
  bannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailableForGold: Scalars['Boolean']['output'];
  isAvailableForPlatinum: Scalars['Boolean']['output'];
  isSubscrptionSaleAvailable: Scalars['Boolean']['output'];
  planName: Scalars['String']['output'];
  textForBanner: Scalars['String']['output'];
};

export type SubWebSubscriptionSpecialSale = {
  __typename?: 'SubWebSubscriptionSpecialSale';
  bannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailableForGold: Scalars['Boolean']['output'];
  isAvailableForPlatinum: Scalars['Boolean']['output'];
  isWebSubscrptionSaleAvailable: Scalars['Boolean']['output'];
  planName: Scalars['String']['output'];
  textForBanner: Scalars['String']['output'];
};

export type SubmitIncomeScreeningImagesInput = {
  paths: Array<Scalars['String']['input']>;
};

export type SubmitJobScreeningImagesInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNamePublicSetting?: InputMaybe<Scalars['CompanyNamePublicSetting']['input']>;
  isCompanyNamePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  methodType?: InputMaybe<Scalars['String']['input']>;
  paths: Array<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  billingIssuesDetectedAt?: Maybe<Scalars['Date']['output']>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  expiredAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  isSandbox: Scalars['Boolean']['output'];
  platform: Scalars['PlatformType']['output'];
  productId: Scalars['Int']['output'];
  purchasedAt: Scalars['Date']['output'];
  refundedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
};

export type SubscriptionSaleAppPlanPrice = {
  __typename?: 'SubscriptionSaleAppPlanPrice';
  plan: SubscriptionSalePlanEnum;
  price: SubscriptionSaleAppPriceEnum;
};

export const SubscriptionSaleAppPriceEnum = {
  Regular: 'Regular',
  Special: 'Special'
} as const;

export type SubscriptionSaleAppPriceEnum = typeof SubscriptionSaleAppPriceEnum[keyof typeof SubscriptionSaleAppPriceEnum];
export type SubscriptionSaleConfig = {
  __typename?: 'SubscriptionSaleConfig';
  /** trueは対象区分を選ばず、Webでも従来の固定条件の対象者に売るセール。旧APIが読めるよう、targetSegmentsには4区分すべてを入れて保存する */
  fixedTarget?: Maybe<Scalars['Boolean']['output']>;
  /** プランごとの価格。省略すると保存済みの値を引き継ぐ。nullは旧形式（webGold/PlatinumSalePriceOption）から読む */
  planPrices?: Maybe<Array<SubscriptionSalePlanPrice>>;
  priceMode: SubscriptionSalePriceModeEnum;
  segmentPriceModes?: Maybe<Array<SubscriptionSaleSegmentPriceMode>>;
  targetSegments: Array<SubscriptionSaleSegmentEnum>;
  version: Scalars['Int']['output'];
  webGoldSalePriceOption?: Maybe<WebSubscriptionSalePriceOptionEnum>;
  webPlatinumSalePriceOption?: Maybe<WebSubscriptionSalePriceOptionEnum>;
};

export type SubscriptionSaleConfigInput = {
  /** trueは対象区分を選ばず、Webでも従来の固定条件の対象者に売るセール。旧APIが読めるよう、targetSegmentsには4区分すべてを入れて保存する */
  fixedTarget?: InputMaybe<Scalars['Boolean']['input']>;
  /** プランごとの価格。省略すると保存済みの値を引き継ぐ。nullは旧形式（webGold/PlatinumSalePriceOption）から読む */
  planPrices?: InputMaybe<Array<SubscriptionSalePlanPriceInput>>;
  priceMode: SubscriptionSalePriceModeEnum;
  segmentPriceModes?: InputMaybe<Array<SubscriptionSaleSegmentPriceModeInput>>;
  targetSegments: Array<SubscriptionSaleSegmentEnum>;
  version: Scalars['Int']['input'];
  webGoldSalePriceOption?: InputMaybe<WebSubscriptionSalePriceOptionEnum>;
  webPlatinumSalePriceOption?: InputMaybe<WebSubscriptionSalePriceOptionEnum>;
};

export const SubscriptionSalePlanEnum = {
  GoldOneMonth: 'GoldOneMonth',
  GoldOneYear: 'GoldOneYear',
  GoldSixMonths: 'GoldSixMonths',
  GoldThreeMonths: 'GoldThreeMonths',
  PlatinumOneMonth: 'PlatinumOneMonth',
  PlatinumOneYear: 'PlatinumOneYear',
  PlatinumSixMonths: 'PlatinumSixMonths',
  PlatinumThreeMonths: 'PlatinumThreeMonths'
} as const;

export type SubscriptionSalePlanEnum = typeof SubscriptionSalePlanEnum[keyof typeof SubscriptionSalePlanEnum];
export type SubscriptionSalePlanPrice = {
  __typename?: 'SubscriptionSalePlanPrice';
  /** アプリで売る価格。nullはプランごとの既定（1ヶ月は定価、ほかは特別セール価格） */
  appPrice?: Maybe<SubscriptionSaleAppPriceEnum>;
  plan: SubscriptionSalePlanEnum;
  /** 特別セール価格の区分へWebで売る商品ID。nullは特別セール価格 */
  webProductId?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionSalePlanPriceInput = {
  /** アプリで売る価格。nullはプランごとの既定（1ヶ月は定価、ほかは特別セール価格） */
  appPrice?: InputMaybe<SubscriptionSaleAppPriceEnum>;
  plan: SubscriptionSalePlanEnum;
  /** 特別セール価格の区分へWebで売る商品ID。nullは特別セール価格 */
  webProductId?: InputMaybe<Scalars['Int']['input']>;
};

export const SubscriptionSalePriceModeEnum = {
  Half: 'Half',
  Special: 'Special'
} as const;

export type SubscriptionSalePriceModeEnum = typeof SubscriptionSalePriceModeEnum[keyof typeof SubscriptionSalePriceModeEnum];
export const SubscriptionSaleSegmentEnum = {
  ExistingNew: 'ExistingNew',
  ImmediateReturn: 'ImmediateReturn',
  LaterReturn: 'LaterReturn',
  New: 'New'
} as const;

export type SubscriptionSaleSegmentEnum = typeof SubscriptionSaleSegmentEnum[keyof typeof SubscriptionSaleSegmentEnum];
export type SubscriptionSaleSegmentPriceMode = {
  __typename?: 'SubscriptionSaleSegmentPriceMode';
  priceMode: SubscriptionSalePriceModeEnum;
  segment: SubscriptionSaleSegmentEnum;
};

export type SubscriptionSaleSegmentPriceModeInput = {
  priceMode: SubscriptionSalePriceModeEnum;
  segment: SubscriptionSaleSegmentEnum;
};

export type SubscriptionSpecialSale = {
  __typename?: 'SubscriptionSpecialSale';
  bannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isAvailableForGold: Scalars['Boolean']['output'];
  isAvailableForPlatinum: Scalars['Boolean']['output'];
  isAvailableHigumaSale: Scalars['Boolean']['output'];
  isSubscrptionSaleAvailable: Scalars['Boolean']['output'];
  isTarget: Scalars['Boolean']['output'];
  isTicketSaleAvailable: Scalars['Boolean']['output'];
  planName: Scalars['String']['output'];
  textForBanner: Scalars['String']['output'];
};

export type SubscriptionSpecialSaleV2 = {
  __typename?: 'SubscriptionSpecialSaleV2';
  /** 管理画面でプランごとに指定したアプリの価格。対象区分と価格の設定がないセールでは空 */
  appPlanPrices: Array<SubscriptionSaleAppPlanPrice>;
  bannerImageUrl: Scalars['String']['output'];
  carouselBannerImageUrl?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isAvailableForGold: Scalars['Boolean']['output'];
  isAvailableForPlatinum: Scalars['Boolean']['output'];
  isAvailableHigumaSale: Scalars['Boolean']['output'];
  isCommonSaleHalfPrice: Scalars['Boolean']['output'];
  isSubscrptionSaleAvailable: Scalars['Boolean']['output'];
  isTarget: Scalars['Boolean']['output'];
  isTaxiAdCampaignTarget: Scalars['Boolean']['output'];
  isTicketSaleAvailable: Scalars['Boolean']['output'];
  isWebSubscrptionSaleAvailable: Scalars['Boolean']['output'];
  planName: Scalars['String']['output'];
  textForBanner: Scalars['String']['output'];
  /** 管理画面でプランごとに指定したWebの商品ID。特別セール価格のままのプランは含まない。半額の区分では空 */
  webSalePriceProductIds: Array<Scalars['Int']['output']>;
};

export type SuperLikeInput = {
  targetUserId: Scalars['Int']['input'];
};

export type SwipeInput = {
  fromScreenName?: InputMaybe<Scalars['String']['input']>;
  recommendContentType?: InputMaybe<RecommendContentType>;
  swipedType: Scalars['SwipeType']['input'];
  targetUserId: Scalars['Int']['input'];
};

export type SwipeOutput = {
  __typename?: 'SwipeOutput';
  approachType?: Maybe<Scalars['ApproachType']['output']>;
  hasGivenBonusTicket: Scalars['Boolean']['output'];
  isFirstMatch: Scalars['Boolean']['output'];
  isMatched: Scalars['Boolean']['output'];
  match?: Maybe<Match>;
};

export type SyncMessageRoomInput = {
  matchId: Scalars['Int']['input'];
  oldestUnreadMyMessageId?: InputMaybe<Scalars['Int']['input']>;
};

export type SyncMessageRoomOutput = {
  __typename?: 'SyncMessageRoomOutput';
  messages: Array<Message>;
  readMyMessages: Array<MessageReadStatus>;
};

export type TestPickupInput = {
  controlledDate: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type TestPickupUser = {
  __typename?: 'TestPickupUser';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isPreloadContinuousPickup?: Maybe<Scalars['Boolean']['output']>;
  isTrustModePickup: Scalars['Boolean']['output'];
  lastPickedAt: Scalars['Date']['output'];
  latestMessageDate?: Maybe<Scalars['Date']['output']>;
  likedCount: Scalars['Int']['output'];
  pickedRule: Scalars['String']['output'];
  swipedAt?: Maybe<Scalars['Date']['output']>;
  swipedType?: Maybe<Scalars['SwipeType']['output']>;
  targetUser: User;
  targetUserId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
};

export type TestSwipeInput = {
  fromUserId: Scalars['Int']['input'];
  swipedDate: Scalars['String']['input'];
  swipedType: Scalars['SwipeType']['input'];
  targetUserId: Scalars['Int']['input'];
};

export type TestTodaysPickupUsersOutput = {
  __typename?: 'TestTodaysPickupUsersOutput';
  activeBonusPickupRule: Scalars['String']['output'];
  likedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  unSwipedEnablePickupUsers: Array<TestPickupUser>;
};

export type TicketHistoryForCustomer = {
  __typename?: 'TicketHistoryForCustomer';
  changeValueOfBonus?: Maybe<Scalars['Int']['output']>;
  changeValueOfPurchase?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  expiredAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TicketHistoryInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketHistoryOutput = {
  __typename?: 'TicketHistoryOutput';
  histories: Array<TicketHistoryForCustomer>;
  pageInfo: PageInfo;
};

export type TicketMenu = {
  __typename?: 'TicketMenu';
  androidProductId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  iosProductId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfTicket: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  webProductId?: Maybe<Scalars['String']['output']>;
};

export type TicketPurchaseItem = {
  __typename?: 'TicketPurchaseItem';
  androidProductId: Scalars['String']['output'];
  bonusCount: Scalars['Int']['output'];
  iosProductId: Scalars['String']['output'];
  isDiscount: Scalars['Boolean']['output'];
  isRecommended: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numberOfTicket: Scalars['Int']['output'];
  offeringIdentifier?: Maybe<Scalars['String']['output']>;
  packageIdentifier?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  referencePrice: Scalars['Int']['output'];
  ticketMenuId: Scalars['Int']['output'];
  webProductId?: Maybe<Scalars['String']['output']>;
};

export type TicketPurchaseMenu = {
  __typename?: 'TicketPurchaseMenu';
  isV4: Scalars['Boolean']['output'];
  items: Array<TicketPurchaseItem>;
  saleEndsAt?: Maybe<Scalars['Date']['output']>;
  saleKind: Scalars['String']['output'];
  viewerId: Scalars['Int']['output'];
};

export type TicketSaleAudience = {
  __typename?: 'TicketSaleAudience';
  genders: Array<Scalars['String']['output']>;
  incomes: Array<Scalars['String']['output']>;
  memberStatuses: Array<Scalars['String']['output']>;
};

export type TicketSaleAudienceInput = {
  genders: Array<Scalars['String']['input']>;
  incomes: Array<Scalars['String']['input']>;
  memberStatuses: Array<Scalars['String']['input']>;
};

export type TicketSaleBonus = {
  __typename?: 'TicketSaleBonus';
  bonusCount: Scalars['Int']['output'];
  ticketCount: Scalars['Int']['output'];
};

export type TicketSaleBonusInput = {
  bonusCount: Scalars['Int']['input'];
  ticketCount: Scalars['Int']['input'];
};

export type TicketSaleConfig = {
  __typename?: 'TicketSaleConfig';
  audiences: Array<TicketSaleAudience>;
  bonuses: Array<TicketSaleBonus>;
  v4Bonuses?: Maybe<Array<TicketSaleBonus>>;
  version: Scalars['Int']['output'];
};

export type TicketSaleConfigInput = {
  audiences: Array<TicketSaleAudienceInput>;
  bonuses: Array<TicketSaleBonusInput>;
  v4Bonuses?: InputMaybe<Array<TicketSaleBonusInput>>;
  version: Scalars['Int']['input'];
};

export type TmpUser = {
  __typename?: 'TmpUser';
  createdAt: Scalars['Date']['output'];
  expoPushToken?: Maybe<Scalars['String']['output']>;
  featureFlagPushSoftPromptEnabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lastAccessedAt?: Maybe<Scalars['Date']['output']>;
  pushSoftPromptDeferredAt?: Maybe<Scalars['Date']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type TodayAvailabilityOutput = {
  __typename?: 'TodayAvailabilityOutput';
  pageInfo: CursorPageInfo;
  status: TodayAvailabilityStatus;
  users: Array<SearchUserPreview>;
};

export type TodayAvailabilityStatus = {
  __typename?: 'TodayAvailabilityStatus';
  day: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  gate?: Maybe<Scalars['String']['output']>;
  isParticipating: Scalars['Boolean']['output'];
  ticketCount: Scalars['Int']['output'];
};

export type TodayAvailabilityUsersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
};

export type TodaysPassedRate = {
  __typename?: 'TodaysPassedRate';
  todaysPassedRate: Scalars['String']['output'];
};

export type TodaysPickupUsersOutput = {
  __typename?: 'TodaysPickupUsersOutput';
  activeBonusAdditionalNumberOfPickup: Scalars['Int']['output'];
  activeBonusNumberOfDays: Scalars['Int']['output'];
  activeBonusPickupRule: Scalars['String']['output'];
  isAvailableContinuousPickup: Scalars['Boolean']['output'];
  isAvailablePickupIncrease: Scalars['Boolean']['output'];
  isAvailableSpecialPickupIncrease: Scalars['Boolean']['output'];
  isSelectionDeferred?: Maybe<Scalars['Boolean']['output']>;
  likedCount: Scalars['Int']['output'];
  numberOfContinuousPickup: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  totalNumberOfPickup: Scalars['Int']['output'];
  unSwipedEnablePickupUsers: Array<PickupUser>;
};

export type TodaysPickupUsersSelectedInfoOutput = {
  __typename?: 'TodaysPickupUsersSelectedInfoOutput';
  isTodaysPickupUsersSelected: Scalars['Boolean']['output'];
};

export type TopPicksBulkLikeInput = {
  expectedTicketCount: Scalars['Int']['input'];
  isSuperLike: Scalars['Boolean']['input'];
  targetUserIds: Array<Scalars['Int']['input']>;
};

export type TopPicksBulkLikeOutput = {
  __typename?: 'TopPicksBulkLikeOutput';
  sentCount: Scalars['Int']['output'];
};

export type TopPicksBulkLikePriceInput = {
  targetUserIds: Array<Scalars['Int']['input']>;
};

export type TopPicksBulkLikePriceOutput = {
  __typename?: 'TopPicksBulkLikePriceOutput';
  isDiscountApplied: Scalars['Boolean']['output'];
  isDiscountCampaignActive: Scalars['Boolean']['output'];
  isFreeLikeApplied: Scalars['Boolean']['output'];
  normalLikeTicketCount: Scalars['Int']['output'];
  normalLikeTicketCountBeforeDiscount: Scalars['Int']['output'];
  superLikeTicketCount: Scalars['Int']['output'];
  superLikeTicketCountBeforeDiscount: Scalars['Int']['output'];
  targetCount: Scalars['Int']['output'];
  targetUserIds: Array<Scalars['Int']['output']>;
};

export type TopPicksLikeInput = {
  fromScreenName?: InputMaybe<Scalars['String']['input']>;
  targetUserId: Scalars['Int']['input'];
};

export type TrialGold = {
  __typename?: 'TrialGold';
  bannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isOnFire: Scalars['Boolean']['output'];
  isTarget: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
};

export type TrialTicketSale = {
  __typename?: 'TrialTicketSale';
  bannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
};

export type UndoSkipInput = {
  targetUserId: Scalars['Int']['input'];
};

export type UnreadCount = {
  __typename?: 'UnreadCount';
  actionNewsCount: Scalars['Int']['output'];
  ambassadorReferralCount: Scalars['Int']['output'];
  ambassadorReferralFirstViewCount: Scalars['Int']['output'];
  approachedCount: Scalars['Int']['output'];
  dateMessageCount: Scalars['Int']['output'];
  footprintCount: Scalars['Int']['output'];
  messageCount: Scalars['Int']['output'];
  messageCountForUnifiedMessageList: Scalars['Int']['output'];
  messageCountOfMatchHasNoUserMessage: Scalars['Int']['output'];
  messageCountOfMatchHasUserMessage: Scalars['Int']['output'];
  normalNewsCount: Scalars['Int']['output'];
  pickupCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type UnviewedApproachMatch = {
  __typename?: 'UnviewedApproachMatch';
  id: Scalars['Int']['output'];
  opponentUserId: Scalars['Int']['output'];
  opponentUserResizedProfileImages: Array<ResizedProfileImage>;
};

export type UnviewedApproachMatchesOutput = {
  __typename?: 'UnviewedApproachMatchesOutput';
  matches: Array<UnviewedApproachMatch>;
  totalCount: Scalars['Int']['output'];
};

export type UpdateAbTestConfigInput = {
  bPercentage?: InputMaybe<Scalars['Int']['input']>;
  forceVariant?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountTypeInput = {
  accountType: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type UpdateAdministratorRoleInput = {
  administratorId: Scalars['Int']['input'];
  role: AdministratorRole;
};

export type UpdateApproachFilterConditionInput = {
  approachFilterCondition?: InputMaybe<SearchUserConditionInput>;
};

export type UpdateCelebrityProfileVisibilityInput = {
  profileVisibility: CelebrityProfileVisibilityEnum;
};

export type UpdateCommonSaleInput = {
  bannerUrl: Scalars['String']['input'];
  carouselBannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['Date']['input'];
  myPageBannerUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  screeningCutoffAt?: InputMaybe<Scalars['Date']['input']>;
  startAt: Scalars['Date']['input'];
  startQaAt: Scalars['Date']['input'];
  subscriptionSaleConfig?: InputMaybe<SubscriptionSaleConfigInput>;
  ticketSaleConfig?: InputMaybe<TicketSaleConfigInput>;
};

export type UpdateCompanyInfoInput = {
  companyName: Scalars['String']['input'];
  companyNamePublicSetting?: InputMaybe<Scalars['CompanyNamePublicSetting']['input']>;
  isCompanyNamePrivate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDebugCertificationStatusesInput = {
  celebrityCertificationStatus?: InputMaybe<Scalars['ScreeningStatus']['input']>;
  identificationStatus: Scalars['ScreeningStatus']['input'];
  incomeConfirmationStatus: Scalars['ScreeningStatus']['input'];
  jobCertificationStatus: Scalars['ScreeningStatus']['input'];
  singleCertificationStatus: SingleCertificationDisplayStatus;
};

export type UpdateDebugProfileInput = {
  birthday: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  gender: Scalars['Gender']['input'];
  income?: InputMaybe<Scalars['IncomeEnum']['input']>;
  lastName: Scalars['String']['input'];
  setOneWeekSinceStarted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFeatureFlagSettingInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['Date']['input']>;
  mode: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateJobInfoInput = {
  jobCategoryId: Scalars['Float']['input'];
  jobDetail: Scalars['String']['input'];
};

export type UpdateMatchUserNicknameInput = {
  matchId: Scalars['Int']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type UpdateProfileInput = {
  birthPrefecture?: InputMaybe<Scalars['Prefecture']['input']>;
  birthPrefectureDetail?: InputMaybe<Scalars['String']['input']>;
  bloodType?: InputMaybe<Scalars['BloodType']['input']>;
  bodyShape?: InputMaybe<Scalars['BodyShape']['input']>;
  celebrityBadgePublicSetting?: InputMaybe<Scalars['CelebrityBadgePublicStatus']['input']>;
  childrenExist?: InputMaybe<Scalars['ChildrenExist']['input']>;
  communicationType?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  drinking?: InputMaybe<Scalars['Drinking']['input']>;
  firstDatePaymentPreference?: InputMaybe<Scalars['FirstDatePaymentPreference']['input']>;
  graduation: Scalars['Graduation']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  holiday?: InputMaybe<Scalars['Holiday']['input']>;
  houseWork?: InputMaybe<Scalars['HouseWork']['input']>;
  housemate?: InputMaybe<Scalars['Housemate']['input']>;
  income: Scalars['IncomeEnum']['input'];
  isCelebrityBadgeVisible?: InputMaybe<Scalars['Boolean']['input']>;
  jobCategoryId?: InputMaybe<Scalars['Float']['input']>;
  marriageHistory?: InputMaybe<Scalars['MarriageHistory']['input']>;
  marriageView?: InputMaybe<Scalars['MarriageView']['input']>;
  mbti?: InputMaybe<Scalars['String']['input']>;
  nickname: Scalars['String']['input'];
  profileImagePublicSetting: Scalars['ProfileImagePublicStatus']['input'];
  recentDeliciousFood?: InputMaybe<Scalars['String']['input']>;
  recentFavorite?: InputMaybe<Scalars['String']['input']>;
  recentPurchasedItem?: InputMaybe<Scalars['String']['input']>;
  recentViewedMovie?: InputMaybe<Scalars['String']['input']>;
  recentVisitedTown?: InputMaybe<Scalars['String']['input']>;
  referralCommentVisibility?: InputMaybe<Array<ReferralCommentVisibilityItem>>;
  residencePrefecture: Scalars['Prefecture']['input'];
  residencePrefectureDetail?: InputMaybe<Scalars['String']['input']>;
  sibling?: InputMaybe<Scalars['Sibling']['input']>;
  smoking?: InputMaybe<Scalars['Smoking']['input']>;
  universityName?: InputMaybe<Scalars['String']['input']>;
  wantChild?: InputMaybe<Scalars['WantChild']['input']>;
};

export type UpdateProfileOutput = {
  __typename?: 'UpdateProfileOutput';
  addedBonusTicketCount: Scalars['Float']['output'];
};

export type UpdateProfileTraitsInput = {
  traits: Array<Scalars['String']['input']>;
};

export type UpdateRegistrationBeforeScreeningInput = {
  birthday?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['Gender']['input']>;
  graduation?: InputMaybe<Scalars['Graduation']['input']>;
  income?: InputMaybe<Scalars['IncomeEnum']['input']>;
  jobCategoryId?: InputMaybe<Scalars['Int']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  residencePrefecture?: InputMaybe<Scalars['Prefecture']['input']>;
};

export type UpdateScheduledEmailNotificationInput = {
  dynamicTemplateData: Scalars['String']['input'];
  emailName: Scalars['String']['input'];
  forceSendFlg: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  isAdvertisingEmail?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notifyAt?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  targetUserCondition?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type UpdateScheduledEmailNotificationOutput = {
  __typename?: 'UpdateScheduledEmailNotificationOutput';
  dynamicTemplateData: Scalars['String']['output'];
  emailName: Scalars['String']['output'];
  forceSendFlg: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAdvertisingEmail: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type UpdateScheduledInAppNewsInput = {
  body: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  method: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notifyAt?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  targetUserCondition?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateScheduledInAppNewsOutput = {
  __typename?: 'UpdateScheduledInAppNewsOutput';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type UpdateScheduledModalNotificationInput = {
  body: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  imageHeightAspectRatio?: InputMaybe<Scalars['Float']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  method: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notifyAt?: InputMaybe<Scalars['String']['input']>;
  primaryButtonText?: InputMaybe<Scalars['String']['input']>;
  primaryButtonUrl?: InputMaybe<Scalars['String']['input']>;
  publishEndedAt?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  targetUserCondition?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateScheduledModalNotificationOutput = {
  __typename?: 'UpdateScheduledModalNotificationOutput';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  executedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Float']['output'];
  imageHeightAspectRatio?: Maybe<Scalars['Float']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  primaryButtonText?: Maybe<Scalars['String']['output']>;
  primaryButtonUrl?: Maybe<Scalars['String']['output']>;
  publishEndedAt?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  targetUserCondition?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type UpdateScheduledNotificationStatusesInput = {
  status: ScheduledNotificationStatusEnum;
  targets: Array<ScheduledNotificationStatusTargetInput>;
};

export type UpdateScheduledPushNotificationInput = {
  body: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  notificationCategory: Scalars['String']['input'];
  notifyAt?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  targetUserCondition?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScheduledPushNotificationOutput = {
  __typename?: 'UpdateScheduledPushNotificationOutput';
  body: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notificationCategory: Scalars['String']['output'];
  notifyAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UpdateSearchUserConditionInput = {
  searchCondition?: InputMaybe<SearchUserConditionInput>;
};

export type UpdateSearchUserSortConditionInput = {
  searchConditionSortType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrustModeSelectedJobCategoriesInput = {
  jobCategoryIds: Array<Scalars['Int']['input']>;
};

export type UpdateUserEmailInput = {
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type UpdateUserLoginToPhoneInput = {
  phoneNumber: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type UpdateUserMemberStatusInput = {
  memberStatus: Scalars['MemberStatus']['input'];
  userId: Scalars['Int']['input'];
};

export type UpdateUserNameAndBirthdayInput = {
  birthday?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type UpdateUserSettingInput = {
  celebrityBadgePublicSetting?: InputMaybe<Scalars['CelebrityBadgePublicStatus']['input']>;
  enableFirstMessageTemplateDialog?: InputMaybe<Scalars['Boolean']['input']>;
  firstMessageTemplate?: InputMaybe<Scalars['String']['input']>;
  incomePublicSetting?: InputMaybe<Scalars['IncomePublicSetting']['input']>;
  isAdvertisingEmailEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isCelebrityBadgeVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isFootprintHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPickupHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isSearchAndRecommendHidden?: InputMaybe<Scalars['Boolean']['input']>;
  receiveAdminNotification?: InputMaybe<Scalars['Boolean']['input']>;
  receiveDailyPickupNotification?: InputMaybe<Scalars['Boolean']['input']>;
  receiveLikeNotification?: InputMaybe<Scalars['Boolean']['input']>;
  receiveMatchNotification?: InputMaybe<Scalars['Boolean']['input']>;
  receiveMessageNotification?: InputMaybe<Scalars['Boolean']['input']>;
  receiveVideoCallNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserSettingPreferenceInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertCelebrityCertificationScoreInput = {
  remarks?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  targetCertificationId: Scalars['Int']['input'];
};

export type UpsertScreeningScoreInput = {
  faceScore: Scalars['Int']['input'];
  remarks: Scalars['String']['input'];
  targetUserId: Scalars['Int']['input'];
};

export type UpsertTmpUserInput = {
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastAccessedAt?: InputMaybe<Scalars['Date']['input']>;
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type UseReferralCodeOutput = {
  __typename?: 'UseReferralCodeOutput';
  message: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  abTestAppSubscriptionsToWeb?: Maybe<Scalars['String']['output']>;
  abTestContinuousBlur?: Maybe<Scalars['String']['output']>;
  abTestPaidPlanScreen?: Maybe<Scalars['String']['output']>;
  abTestPickupLikeLimitForMan: Scalars['String']['output'];
  abTestRecommendPaidPlanForMan: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  activeWebSubscription?: Maybe<WebPaymentSubscription>;
  age: Scalars['Int']['output'];
  appVersion?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['Date']['output']>;
  canReapplyForScreening: Scalars['Boolean']['output'];
  canReferralTradingCompany: Scalars['Boolean']['output'];
  canStartSingleCertification: Scalars['Boolean']['output'];
  canUnsuspend: Scalars['Boolean']['output'];
  canUseGoldSearchFilters: Scalars['Boolean']['output'];
  canUseHobbyTagSearch: Scalars['Boolean']['output'];
  canViewOnlineStatus: Scalars['Boolean']['output'];
  celebrityCertificationStatus?: Maybe<Scalars['ScreeningStatus']['output']>;
  celebrityCertifications?: Maybe<Array<CelebrityCertification>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentPaymentPlatform: PaymentPlatformTypeEnum;
  email?: Maybe<Scalars['String']['output']>;
  expoPushToken?: Maybe<Scalars['String']['output']>;
  extraGuerrillaCampaignSale: ExtraGuerrillaCampaignSale;
  extraTicketSale: ExtraTicketSaleV2;
  extraTicketSaleOnSubscription: ExtraTicketSaleOnSubscription;
  featureFlags: FeatureFlagsForUser;
  fiveLevelRank: Scalars['String']['output'];
  gender: Scalars['Gender']['output'];
  hasFirstDateEnded: Scalars['Boolean']['output'];
  hasFirstMessageTemplate: Scalars['Boolean']['output'];
  hasPushNotifyPermission: Scalars['Boolean']['output'];
  hasSubscribed: Scalars['Boolean']['output'];
  hasUnreadRankReward: Scalars['Boolean']['output'];
  highIncomeHighMatchSale: HighIncomeHighMatchSale;
  id: Scalars['Int']['output'];
  identificationStatus: Scalars['ScreeningStatus']['output'];
  incomeConfirmationStatus: Scalars['ScreeningStatus']['output'];
  infiniteWelcomeTicketSale: InfiniteWelcomeTicketSale;
  inquiries?: Maybe<Array<Inquiry>>;
  isAllCertified: Scalars['Boolean']['output'];
  isAvailableFlashReferralCampaign: Scalars['Boolean']['output'];
  isAvailableTopPicksBulkLike: Scalars['Boolean']['output'];
  isBoosting: Scalars['Boolean']['output'];
  isCelebrityCertified: Scalars['Boolean']['output'];
  /** @deprecated （友人推薦）アプリ内導線強化 が安定後削除予定 */
  isCompletedALLBonusTicket: Scalars['Boolean']['output'];
  /** @deprecated （友人推薦）アプリ内導線強化 が安定後削除予定 */
  isCompletedAmbassadorBonusTicket: Scalars['Boolean']['output'];
  isCompletedOnboardingBonusTicket: Scalars['Boolean']['output'];
  isContinuationBonusAvailable: Scalars['Boolean']['output'];
  isDateCancellationFeeAgreed: Scalars['Boolean']['output'];
  isEligibleForIntroPrice: Scalars['Boolean']['output'];
  isFirstPassedDateEntryValidCardCheck: Scalars['Boolean']['output'];
  isFreeGoldSearchFilterAvailable: Scalars['Boolean']['output'];
  isFreeGoldSearchFilterPromotionTarget: Scalars['Boolean']['output'];
  isGoldMember: Scalars['Boolean']['output'];
  isGorgeousDateAvailable: Scalars['Boolean']['output'];
  isIdentificationPromotionActive: Scalars['Boolean']['output'];
  isIdentified: Scalars['Boolean']['output'];
  isIncomeConfirmed: Scalars['Boolean']['output'];
  isIncomeGte: Scalars['Boolean']['output'];
  isJobCertified: Scalars['Boolean']['output'];
  isLineUser: Scalars['Boolean']['output'];
  isMan: Scalars['Boolean']['output'];
  isMessageFreePeriod: Scalars['Boolean']['output'];
  isMessageListUpgradeBannerTarget: Scalars['Boolean']['output'];
  isNewUser: Scalars['Boolean']['output'];
  isPaidContentAvailable: Scalars['Boolean']['output'];
  isPaidMember: Scalars['Boolean']['output'];
  isPaidPlanJoinable: Scalars['Boolean']['output'];
  isPaidWithoutFreeMember: Scalars['Boolean']['output'];
  isPlatinumMember: Scalars['Boolean']['output'];
  isPlatinumUpgradableInApp: Scalars['Boolean']['output'];
  isProfileFilledForGorgeousDate: Scalars['Boolean']['output'];
  isProfileImagePrivate: Scalars['Boolean']['output'];
  isRankRewardUnlocked: Scalars['Boolean']['output'];
  isReadStatusDisplayEnabled: Scalars['Boolean']['output'];
  isReferralLimitUnlocked: Scalars['Boolean']['output'];
  isRescreening: Scalars['Boolean']['output'];
  isScreeningFailedByPhoto: Scalars['Boolean']['output'];
  isScreeningReapplicationSuspended: Scalars['Boolean']['output'];
  isScreenshotAllowed: Scalars['Boolean']['output'];
  isSearchSortBadgeTarget: Scalars['Boolean']['output'];
  isSingleCertified: Scalars['Boolean']['output'];
  isSuspending: Scalars['Boolean']['output'];
  isTopGorgeous: Scalars['Boolean']['output'];
  isTopGorgeousAmbassadorReferralBonusActive: Scalars['Boolean']['output'];
  isTopPicksBulkLikeBadgeTarget: Scalars['Boolean']['output'];
  isTopPicksBulkLikeDiscountCampaignActive: Scalars['Boolean']['output'];
  isTrialGold: Scalars['Boolean']['output'];
  isTrustMode: Scalars['Boolean']['output'];
  isWelcomeReferralCampaignActive: Scalars['Boolean']['output'];
  isWelcomeSale: Scalars['Boolean']['output'];
  jobCertificationStatus: Scalars['ScreeningStatus']['output'];
  lastAccessedAt?: Maybe<Scalars['Date']['output']>;
  lastCelebrityCertificationFailedMessage?: Maybe<Scalars['String']['output']>;
  latestIncome?: Maybe<IncomeObject>;
  latestSelfIntroduction?: Maybe<SelfIntroduction>;
  latestSubscription?: Maybe<Subscription>;
  memberStatus: Scalars['MemberStatus']['output'];
  needsGorgeousDateOnboarding: Scalars['Boolean']['output'];
  needsRequestAppReview: Scalars['Boolean']['output'];
  needsShowFirstHyperLikeFromMyLikeListGuide: Scalars['Boolean']['output'];
  needsShowFirstLikeFromFootprintListGuide: Scalars['Boolean']['output'];
  needsShowFirstLikeFromSearchGuide: Scalars['Boolean']['output'];
  needsShowFirstLikeFromTopPicksGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromFootprintListGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromMyLikeListGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromPickupGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromSearchGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromTopPicksGuide: Scalars['Boolean']['output'];
  needsShowFirstUltraLikeFromMyLikeListGuide: Scalars['Boolean']['output'];
  needsShowMessageTutorial: Scalars['Boolean']['output'];
  needsShowPickupTutorial: Scalars['Boolean']['output'];
  onboardingBonusTicketStatus?: Maybe<OnboardingBonusTicketStatus>;
  onlineStatus?: Maybe<Scalars['String']['output']>;
  /** @deprecated 終了済み機能。旧アプリ互換のため一時的に維持 */
  passedSomeoneIds: Array<Scalars['Int']['output']>;
  platform?: Maybe<Scalars['PlatformType']['output']>;
  profile?: Maybe<Profile>;
  profileImages?: Maybe<Array<ProfileImage>>;
  profileInputRate: Scalars['Float']['output'];
  receivedAmbassadorReferralComments: Array<ReceivedAmbassadorReferralComment>;
  recommendHigherLikeWhenLikedByOthers?: Maybe<Scalars['Boolean']['output']>;
  remainingReferralCount: Scalars['Int']['output'];
  resizedProfileImages?: Maybe<Array<ResizedProfileImage>>;
  satisfiesGorgeousDateEntryRequirement: Scalars['Boolean']['output'];
  screeningFailedReason: Scalars['String']['output'];
  secondWelcomeBackSale: SecondWelcomeBackSale;
  secondWelcomeSale: SecondWelcomeSale;
  secondWelcomeTicketSale: SecondWelcomeTicketSale;
  shouldShowCelebrityBadge: Scalars['Boolean']['output'];
  singleCertificationStatus: SingleCertificationDisplayStatus;
  singleCertifiedAt?: Maybe<Scalars['Date']['output']>;
  specialSale: SubscriptionSpecialSale;
  status: Scalars['UserStatus']['output'];
  subSubscriptionSpecialSale: SubSubscriptionSpecialSale;
  subWebSubscriptionSpecialSale: SubWebSubscriptionSpecialSale;
  subscriptionSpecialSale: SubscriptionSpecialSaleV2;
  trialGold: TrialGold;
  trialTicketSale: TrialTicketSale;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userComputed?: Maybe<UserComputed>;
  userHistory?: Maybe<UserHistory>;
  userHobbyTags?: Maybe<Array<UserHobbyTag>>;
  userInstallConversion?: Maybe<UserInstallConversion>;
  userSetting?: Maybe<UserSetting>;
  userSettingPreference?: Maybe<UserSettingPreference>;
  uuid: Scalars['String']['output'];
  visibleReceivedAmbassadorReferralComments: Array<ReceivedAmbassadorReferralComment>;
  webSubscriptionSpecialSale: SubscriptionSpecialSaleV2;
  webSubscriptionUpgradeSale: WebSubscriptionUpgradeSale;
  welcomeBackSale: WelcomeBackSale;
  welcomeSale: WelcomeSale;
  world: Scalars['UserWorld']['output'];
};

export type UserAbTestInfo = {
  __typename?: 'UserAbTestInfo';
  currentVariant: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  forceVariant?: Maybe<Scalars['String']['output']>;
  overrideVariant?: Maybe<Scalars['String']['output']>;
  testKey: Scalars['String']['output'];
};

export type UserAbTestOverrideInfo = {
  __typename?: 'UserAbTestOverrideInfo';
  testKey: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type UserComputed = {
  __typename?: 'UserComputed';
  createdUserCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  identificationImageSubmitCount: Scalars['Int']['output'];
  incomeConfirmationImageSubmitCount: Scalars['Int']['output'];
  isInvitedByAmbassador: Scalars['Boolean']['output'];
  isTrustMode: Scalars['Boolean']['output'];
  jobCertificationImageSubmitCount: Scalars['Int']['output'];
  passedSomeoneIds: Array<Scalars['Int']['output']>;
  user: User;
  userId: Scalars['Float']['output'];
};

export type UserEventLogInput = {
  eventName?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSONObject']['input']>;
  screenName?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type UserGorgeousJumboStatusOutput = {
  __typename?: 'UserGorgeousJumboStatusOutput';
  status: Scalars['String']['output'];
};

export type UserHistory = {
  __typename?: 'UserHistory';
  firstLikedAt?: Maybe<Scalars['Date']['output']>;
  firstMatchedAt?: Maybe<Scalars['Date']['output']>;
  firstMessageReceivedAt?: Maybe<Scalars['Date']['output']>;
  firstMessageTemplateTutorialShownAt?: Maybe<Scalars['Date']['output']>;
  firstMessagedAt?: Maybe<Scalars['Date']['output']>;
  firstSubscribedAt?: Maybe<Scalars['Date']['output']>;
  firstSuperLikedAt?: Maybe<Scalars['Date']['output']>;
  getStartedAt?: Maybe<Scalars['Date']['output']>;
  incomeConfirmedAt?: Maybe<Scalars['Date']['output']>;
  lastPickupAlertClosedAt?: Maybe<Scalars['Date']['output']>;
  screenShotCount: Scalars['Int']['output'];
};

export type UserHobbyTag = {
  __typename?: 'UserHobbyTag';
  hobbyTag: HobbyTag;
  hobbyTagId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  userId: Scalars['Float']['output'];
};

export type UserInfoForIdentifyOutput = {
  __typename?: 'UserInfoForIdentifyOutput';
  birthday: Scalars['Date']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type UserInfoInput = {
  adjustDeviceId?: InputMaybe<Scalars['String']['input']>;
  advertisingId?: InputMaybe<Scalars['String']['input']>;
  appInstanceId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  hasPushNotifyPermission?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrackingPermission?: InputMaybe<Scalars['Boolean']['input']>;
  lastAccessedAt?: InputMaybe<Scalars['Date']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['PlatformType']['input']>;
};

export type UserInstallConversion = {
  __typename?: 'UserInstallConversion';
  afCampaign?: Maybe<Scalars['String']['output']>;
  afConversionData?: Maybe<Scalars['String']['output']>;
  afMediaSource?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  installType: Scalars['InstallType']['output'];
  platform: Scalars['PlatformType']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export const UserLifecycleType = {
  ExistingNew: 'ExistingNew',
  GenuineNew: 'GenuineNew',
  ImmediateResume: 'ImmediateResume',
  NotImmediateResume: 'NotImmediateResume'
} as const;

export type UserLifecycleType = typeof UserLifecycleType[keyof typeof UserLifecycleType];
export type UserSearchCondition = {
  __typename?: 'UserSearchCondition';
  ageFrom?: Maybe<Scalars['Int']['output']>;
  ageTo?: Maybe<Scalars['Int']['output']>;
  birthPrefectures?: Maybe<Array<Scalars['String']['output']>>;
  bodyShapes?: Maybe<Array<Scalars['String']['output']>>;
  childrenExists?: Maybe<Array<Scalars['String']['output']>>;
  communicationTypes?: Maybe<Array<Scalars['String']['output']>>;
  drinkings?: Maybe<Array<Scalars['String']['output']>>;
  firstDatePaymentPreferences?: Maybe<Array<Scalars['String']['output']>>;
  graduations?: Maybe<Array<Scalars['String']['output']>>;
  hasSelfIntroduction?: Maybe<Scalars['Boolean']['output']>;
  hasSubProfileImages?: Maybe<Scalars['Boolean']['output']>;
  heightFrom?: Maybe<Scalars['Int']['output']>;
  heightTo?: Maybe<Scalars['Int']['output']>;
  hobbyTagIds?: Maybe<Array<Scalars['Int']['output']>>;
  holidays?: Maybe<Array<Scalars['String']['output']>>;
  houseWorks?: Maybe<Array<Scalars['String']['output']>>;
  housemates?: Maybe<Array<Scalars['String']['output']>>;
  incomeFrom?: Maybe<Scalars['Int']['output']>;
  incomeTo?: Maybe<Scalars['Int']['output']>;
  isHighDatingIntent?: Maybe<Scalars['Boolean']['output']>;
  isIdentified?: Maybe<Scalars['Boolean']['output']>;
  isIncomeConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isJobCertified?: Maybe<Scalars['Boolean']['output']>;
  isSingleCertified?: Maybe<Scalars['Boolean']['output']>;
  jobCategoryIds?: Maybe<Array<Scalars['Int']['output']>>;
  marriageHistories?: Maybe<Array<Scalars['String']['output']>>;
  marriageViews?: Maybe<Array<Scalars['String']['output']>>;
  mbtis?: Maybe<Array<Scalars['String']['output']>>;
  profileImagePublicSettings?: Maybe<Array<Scalars['String']['output']>>;
  residencePrefectures?: Maybe<Array<Scalars['String']['output']>>;
  shouldShowApproachedUsers?: Maybe<Scalars['Boolean']['output']>;
  smokings?: Maybe<Array<Scalars['String']['output']>>;
  wantChilds?: Maybe<Array<Scalars['String']['output']>>;
};

export type UserSetting = {
  __typename?: 'UserSetting';
  celebrityBadgePublicSetting: Scalars['CelebrityBadgePublicStatus']['output'];
  enableFirstMessageTemplateDialog?: Maybe<Scalars['Boolean']['output']>;
  firstMessageTemplate?: Maybe<Scalars['String']['output']>;
  hasTrackingPermission: Scalars['Boolean']['output'];
  incomePublicSetting: Scalars['IncomePublicSetting']['output'];
  isAdvertisingEmailEnable: Scalars['Boolean']['output'];
  /** @deprecated celebrityBadgePublicSetting へ移行 */
  isCelebrityBadgeVisible: Scalars['Boolean']['output'];
  isEmailEnable: Scalars['Boolean']['output'];
  isFootprintHidden: Scalars['Boolean']['output'];
  isPickupHidden: Scalars['Boolean']['output'];
  isSearchAndRecommendHidden: Scalars['Boolean']['output'];
  profileImagePublicSetting: Scalars['ProfileImagePublicStatus']['output'];
  receiveAdminNotification: Scalars['Boolean']['output'];
  receiveDailyPickupNotification: Scalars['Boolean']['output'];
  receiveLikeNotification: Scalars['Boolean']['output'];
  receiveMatchNotification: Scalars['Boolean']['output'];
  receiveMessageNotification: Scalars['Boolean']['output'];
  receiveVideoCallNotification: Scalars['Boolean']['output'];
};

export type UserSettingPreference = {
  __typename?: 'UserSettingPreference';
  ageFrom?: Maybe<Scalars['Int']['output']>;
  ageTo?: Maybe<Scalars['Int']['output']>;
  approachFilterCondition: UserSearchCondition;
  prefectures: Array<Scalars['String']['output']>;
  searchCondition: UserSearchCondition;
  sortCondition: Scalars['String']['output'];
};

export type UserSupportMemo = {
  __typename?: 'UserSupportMemo';
  administrator: Administrator;
  administratorId: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type ValidateRewardCodeOutput = {
  __typename?: 'ValidateRewardCodeOutput';
  campaignCode?: Maybe<CampaignCodeInfo>;
  isValid: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type VersionRequirement = {
  __typename?: 'VersionRequirement';
  minimumAvailableVersionForAndroid?: Maybe<Scalars['String']['output']>;
  minimumAvailableVersionForIos?: Maybe<Scalars['String']['output']>;
};

export type VideoCall = {
  __typename?: 'VideoCall';
  agoraChannelName?: Maybe<Scalars['String']['output']>;
  callerUserId?: Maybe<Scalars['Int']['output']>;
  cancelReason?: Maybe<VideoCallCancelReasonEnum>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  match: Match;
  matchId: Scalars['Int']['output'];
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  startAt?: Maybe<Scalars['Date']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<VideoCallStatusEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export const VideoCallCancelReasonEnum = {
  CallerCanceled: 'CallerCanceled',
  Declined: 'Declined',
  NoAnswer: 'NoAnswer'
} as const;

export type VideoCallCancelReasonEnum = typeof VideoCallCancelReasonEnum[keyof typeof VideoCallCancelReasonEnum];
export type VideoCallSession = {
  __typename?: 'VideoCallSession';
  agoraChannelName: Scalars['String']['output'];
  agoraToken?: Maybe<Scalars['String']['output']>;
  videoCall: VideoCall;
};

export const VideoCallStatusEnum = {
  Cancelled: 'Cancelled',
  Ended: 'Ended',
  InProgress: 'InProgress',
  Ringing: 'Ringing'
} as const;

export type VideoCallStatusEnum = typeof VideoCallStatusEnum[keyof typeof VideoCallStatusEnum];
export type WebAuthOutput = {
  __typename?: 'WebAuthOutput';
  accessToken: Scalars['String']['output'];
  user: WebCurrentUser;
};

export type WebCancelHelloPayCardSetupInput = {
  registrationId: Scalars['String']['input'];
  /** 本人認証の戻りURLに付くsetup_intent_id */
  setupIntentId: Scalars['String']['input'];
};

export type WebChangeHelloPaySubscriptionCardInput = {
  /** 3Dセキュア認証済みのカード登録ID */
  helloPayCardId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};

export type WebCreateCardEditLinkOutput = {
  __typename?: 'WebCreateCardEditLinkOutput';
  cardEditUrl: Scalars['String']['output'];
};

export type WebCreateCheckoutLinkOutput = {
  __typename?: 'WebCreateCheckoutLinkOutput';
  checkoutUrl: Scalars['String']['output'];
};

export type WebCreateDateTicketCheckoutLinkInput = {
  dateTicketMenu: Scalars['String']['input'];
};

export type WebCreateSubscriptionCheckoutLinkInput = {
  productId: Scalars['Int']['input'];
};

export type WebCreateSubscriptionUpgradeCheckoutLinkInput = {
  productId: Scalars['Int']['input'];
};

export type WebCreateTicketCheckoutLinkInput = {
  ticketMenuId: Scalars['Int']['input'];
};

export type WebCreateTicketOrderInput = {
  requestId: Scalars['String']['input'];
  ticketMenuId: Scalars['Int']['input'];
};

export type WebCreateUpgradeCheckoutLinkOutput = {
  __typename?: 'WebCreateUpgradeCheckoutLinkOutput';
  checkoutUrl: Scalars['String']['output'];
};

export type WebCurrentUser = {
  __typename?: 'WebCurrentUser';
  abTestAppSubscriptionsToWeb?: Maybe<Scalars['String']['output']>;
  abTestContinuousBlur?: Maybe<Scalars['String']['output']>;
  abTestPaidPlanScreen?: Maybe<Scalars['String']['output']>;
  abTestPickupLikeLimitForMan: Scalars['String']['output'];
  abTestRecommendPaidPlanForMan: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  activeWebSubscription?: Maybe<WebPaymentSubscription>;
  age: Scalars['Int']['output'];
  appVersion?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['Date']['output']>;
  canReapplyForScreening: Scalars['Boolean']['output'];
  canReferralTradingCompany: Scalars['Boolean']['output'];
  canStartSingleCertification: Scalars['Boolean']['output'];
  canUnsuspend: Scalars['Boolean']['output'];
  canUseGoldSearchFilters: Scalars['Boolean']['output'];
  canUseHobbyTagSearch: Scalars['Boolean']['output'];
  canViewOnlineStatus: Scalars['Boolean']['output'];
  celebrityCertificationStatus?: Maybe<Scalars['ScreeningStatus']['output']>;
  celebrityCertifications?: Maybe<Array<CelebrityCertification>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentPaymentPlatform: PaymentPlatformTypeEnum;
  email?: Maybe<Scalars['String']['output']>;
  existingNewSale: ExistingNewSale;
  expoPushToken?: Maybe<Scalars['String']['output']>;
  extraGuerrillaCampaignSale: ExtraGuerrillaCampaignSale;
  extraTicketSale: ExtraTicketSaleV2;
  extraTicketSaleOnSubscription: ExtraTicketSaleOnSubscription;
  featureFlags: FeatureFlagsForUser;
  fiveLevelRank: Scalars['String']['output'];
  fiveYenTicketSale: FiveYenTicketSale;
  gender: Scalars['Gender']['output'];
  hasFirstDateEnded: Scalars['Boolean']['output'];
  hasFirstMessageTemplate: Scalars['Boolean']['output'];
  hasPushNotifyPermission: Scalars['Boolean']['output'];
  hasSubscribed: Scalars['Boolean']['output'];
  hasUnreadRankReward: Scalars['Boolean']['output'];
  highIncomeHighMatchSale: HighIncomeHighMatchSale;
  id: Scalars['Int']['output'];
  identificationStatus: Scalars['ScreeningStatus']['output'];
  incomeConfirmationStatus: Scalars['ScreeningStatus']['output'];
  infiniteWelcomeTicketSale: InfiniteWelcomeTicketSale;
  inquiries?: Maybe<Array<Inquiry>>;
  isAllCertified: Scalars['Boolean']['output'];
  isAvailableFlashReferralCampaign: Scalars['Boolean']['output'];
  isAvailableTopPicksBulkLike: Scalars['Boolean']['output'];
  isBoosting: Scalars['Boolean']['output'];
  isCelebrityCertified: Scalars['Boolean']['output'];
  /** @deprecated （友人推薦）アプリ内導線強化 が安定後削除予定 */
  isCompletedALLBonusTicket: Scalars['Boolean']['output'];
  /** @deprecated （友人推薦）アプリ内導線強化 が安定後削除予定 */
  isCompletedAmbassadorBonusTicket: Scalars['Boolean']['output'];
  isCompletedOnboardingBonusTicket: Scalars['Boolean']['output'];
  isContinuationBonusAvailable: Scalars['Boolean']['output'];
  isDateCancellationFeeAgreed: Scalars['Boolean']['output'];
  isEligibleForIntroPrice: Scalars['Boolean']['output'];
  isFirstPassedDateEntryValidCardCheck: Scalars['Boolean']['output'];
  isFreeGoldSearchFilterAvailable: Scalars['Boolean']['output'];
  isFreeGoldSearchFilterPromotionTarget: Scalars['Boolean']['output'];
  isGoldMember: Scalars['Boolean']['output'];
  isGorgeousDateAvailable: Scalars['Boolean']['output'];
  isIdentificationPromotionActive: Scalars['Boolean']['output'];
  isIdentified: Scalars['Boolean']['output'];
  isIncomeConfirmed: Scalars['Boolean']['output'];
  isIncomeGte: Scalars['Boolean']['output'];
  isJobCertified: Scalars['Boolean']['output'];
  isLineUser: Scalars['Boolean']['output'];
  isMan: Scalars['Boolean']['output'];
  isMessageFreePeriod: Scalars['Boolean']['output'];
  isMessageListUpgradeBannerTarget: Scalars['Boolean']['output'];
  isNewUser: Scalars['Boolean']['output'];
  isPaidContentAvailable: Scalars['Boolean']['output'];
  isPaidMember: Scalars['Boolean']['output'];
  isPaidPlanJoinable: Scalars['Boolean']['output'];
  isPaidWithoutFreeMember: Scalars['Boolean']['output'];
  isPlatinumMember: Scalars['Boolean']['output'];
  isPlatinumUpgradableInApp: Scalars['Boolean']['output'];
  isProfileFilledForGorgeousDate: Scalars['Boolean']['output'];
  isProfileImagePrivate: Scalars['Boolean']['output'];
  isRankRewardUnlocked: Scalars['Boolean']['output'];
  isReadStatusDisplayEnabled: Scalars['Boolean']['output'];
  isReferralLimitUnlocked: Scalars['Boolean']['output'];
  isRescreening: Scalars['Boolean']['output'];
  isScreeningFailedByPhoto: Scalars['Boolean']['output'];
  isScreeningReapplicationSuspended: Scalars['Boolean']['output'];
  isScreenshotAllowed: Scalars['Boolean']['output'];
  isSearchSortBadgeTarget: Scalars['Boolean']['output'];
  isSingleCertified: Scalars['Boolean']['output'];
  isSuspending: Scalars['Boolean']['output'];
  isTicket999Available: Scalars['Boolean']['output'];
  isTopGorgeous: Scalars['Boolean']['output'];
  isTopGorgeousAmbassadorReferralBonusActive: Scalars['Boolean']['output'];
  isTopPicksBulkLikeBadgeTarget: Scalars['Boolean']['output'];
  isTopPicksBulkLikeDiscountCampaignActive: Scalars['Boolean']['output'];
  isTrialGold: Scalars['Boolean']['output'];
  isTrustMode: Scalars['Boolean']['output'];
  isWelcomeReferralCampaignActive: Scalars['Boolean']['output'];
  isWelcomeSale: Scalars['Boolean']['output'];
  jobCertificationStatus: Scalars['ScreeningStatus']['output'];
  lastAccessedAt?: Maybe<Scalars['Date']['output']>;
  lastCelebrityCertificationFailedMessage?: Maybe<Scalars['String']['output']>;
  latestIncome?: Maybe<IncomeObject>;
  latestSelfIntroduction?: Maybe<SelfIntroduction>;
  latestSubscription?: Maybe<Subscription>;
  memberStatus: Scalars['MemberStatus']['output'];
  needsGorgeousDateOnboarding: Scalars['Boolean']['output'];
  needsRequestAppReview: Scalars['Boolean']['output'];
  needsShowFirstHyperLikeFromMyLikeListGuide: Scalars['Boolean']['output'];
  needsShowFirstLikeFromFootprintListGuide: Scalars['Boolean']['output'];
  needsShowFirstLikeFromSearchGuide: Scalars['Boolean']['output'];
  needsShowFirstLikeFromTopPicksGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromFootprintListGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromMyLikeListGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromPickupGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromSearchGuide: Scalars['Boolean']['output'];
  needsShowFirstSuperLikeFromTopPicksGuide: Scalars['Boolean']['output'];
  needsShowFirstUltraLikeFromMyLikeListGuide: Scalars['Boolean']['output'];
  needsShowMessageTutorial: Scalars['Boolean']['output'];
  needsShowPickupTutorial: Scalars['Boolean']['output'];
  notImmediateResumeSale: NotImmediateResumeSale;
  onboardingBonusTicketStatus?: Maybe<OnboardingBonusTicketStatus>;
  onlineStatus?: Maybe<Scalars['String']['output']>;
  /** @deprecated 終了済み機能。旧アプリ互換のため一時的に維持 */
  passedSomeoneIds: Array<Scalars['Int']['output']>;
  platform?: Maybe<Scalars['PlatformType']['output']>;
  profile?: Maybe<Profile>;
  profileImages?: Maybe<Array<ProfileImage>>;
  profileInputRate: Scalars['Float']['output'];
  receivedAmbassadorReferralComments: Array<ReceivedAmbassadorReferralComment>;
  recommendHigherLikeWhenLikedByOthers?: Maybe<Scalars['Boolean']['output']>;
  remainingReferralCount: Scalars['Int']['output'];
  resizedProfileImages?: Maybe<Array<ResizedProfileImage>>;
  satisfiesGorgeousDateEntryRequirement: Scalars['Boolean']['output'];
  screeningFailedReason: Scalars['String']['output'];
  secondWelcomeBackSale: SecondWelcomeBackSale;
  secondWelcomeSale: SecondWelcomeSale;
  secondWelcomeTicketSale: SecondWelcomeTicketSale;
  shouldShowCelebrityBadge: Scalars['Boolean']['output'];
  singleCertificationStatus: SingleCertificationDisplayStatus;
  singleCertifiedAt?: Maybe<Scalars['Date']['output']>;
  specialSale: SubscriptionSpecialSale;
  starterPackSale: StarterPackSale;
  status: Scalars['UserStatus']['output'];
  subSubscriptionSpecialSale: SubSubscriptionSpecialSale;
  subWebSubscriptionSpecialSale: SubWebSubscriptionSpecialSale;
  subscriptionSpecialSale: SubscriptionSpecialSaleV2;
  trialGold: TrialGold;
  trialTicketSale: TrialTicketSale;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userComputed?: Maybe<UserComputed>;
  userHistory?: Maybe<UserHistory>;
  userHobbyTags?: Maybe<Array<UserHobbyTag>>;
  userInstallConversion?: Maybe<UserInstallConversion>;
  userSetting?: Maybe<UserSetting>;
  userSettingPreference?: Maybe<UserSettingPreference>;
  uuid: Scalars['String']['output'];
  visibleReceivedAmbassadorReferralComments: Array<ReceivedAmbassadorReferralComment>;
  webSubscriptionSpecialSale: SubscriptionSpecialSaleV2;
  webSubscriptionUpgradeSale: WebSubscriptionUpgradeSale;
  welcomeBackSale: WelcomeBackSale;
  welcomeSale: WelcomeSale;
  world: Scalars['UserWorld']['output'];
};

export type WebDateTicketHistoriesOutput = {
  __typename?: 'WebDateTicketHistoriesOutput';
  dateTicketHistories: Array<DateTicketHistoryItem>;
};

export type WebGetSubscriptionUpgradePriceInput = {
  upgradeProductId: Scalars['Int']['input'];
};

export type WebGetSubscriptionUpgradePriceOutput = {
  __typename?: 'WebGetSubscriptionUpgradePriceOutput';
  /** アップグレードできない期間（isUpgradable=false）はnull */
  availableUpgradePrice?: Maybe<Scalars['Float']['output']>;
  /** 有効期限当日・更新処理中などの理由でアップグレードできない場合はfalse */
  isUpgradable: Scalars['Boolean']['output'];
  /** @deprecated isUpgradable と availableUpgradePrice を使う */
  upgradePrice: Scalars['Float']['output'];
};

export type WebHelloPayAvailabilityOutput = {
  __typename?: 'WebHelloPayAvailabilityOutput';
  /** カードを新しく登録できるか。対象外になってもHelloPayの契約が続く人は登録できる */
  canRegisterCard: Scalars['Boolean']['output'];
  hasActiveCards: Scalars['Boolean']['output'];
  isHelloPayTarget: Scalars['Boolean']['output'];
  paymentInProgressOrder?: Maybe<WebHelloPayPaymentInProgressOrder>;
};

export type WebHelloPayCard = {
  __typename?: 'WebHelloPayCard';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  isExpired: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
  registrationId: Scalars['String']['output'];
};

export type WebHelloPayCardRegistrationInput = {
  registrationId: Scalars['String']['input'];
};

export type WebHelloPayCardRegistrationOutput = {
  __typename?: 'WebHelloPayCardRegistrationOutput';
  redirectUrl?: Maybe<Scalars['String']['output']>;
  registrationId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type WebHelloPayCardsOutput = {
  __typename?: 'WebHelloPayCardsOutput';
  cards: Array<WebHelloPayCard>;
  maxCards: Scalars['Int']['output'];
  pendingCardDetails?: Maybe<Array<WebHelloPayPendingCardDetails>>;
  pendingRegistrationIds: Array<Scalars['String']['output']>;
};

export type WebHelloPayPaymentInProgressOrder = {
  __typename?: 'WebHelloPayPaymentInProgressOrder';
  cardRegistrationId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  ticketMenuId: Scalars['Int']['output'];
};

export type WebHelloPayPendingCardDetails = {
  __typename?: 'WebHelloPayPendingCardDetails';
  brand: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  registrationId: Scalars['String']['output'];
};

export type WebHelloPaySubscriptionInitialFailure = {
  __typename?: 'WebHelloPaySubscriptionInitialFailure';
  failureReason?: Maybe<Scalars['String']['output']>;
};

export type WebHelloPaySubscriptionUpgradeQuote = {
  __typename?: 'WebHelloPaySubscriptionUpgradeQuote';
  /** 今回請求する差額 */
  amount: Scalars['Int']['output'];
  /** 金額を確認した時刻（Unix秒） */
  prorationDate: Scalars['Int']['output'];
};

export type WebPayHelloPayTicketOrderInput = {
  cardRegistrationId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type WebPaymentSubscription = {
  __typename?: 'WebPaymentSubscription';
  cancelText?: Maybe<Scalars['String']['output']>;
  expiredAt: Scalars['Date']['output'];
  isCanceled: Scalars['Boolean']['output'];
  nextRenewalAt?: Maybe<Scalars['Date']['output']>;
  productId: Scalars['Float']['output'];
  /** 期間による理由でアップグレードできない場合の文言。アップグレードの入口はnullのときだけ出す */
  upgradeUnavailableText?: Maybe<Scalars['String']['output']>;
};

export type WebStartHelloPayCardRegistrationInput = {
  requestId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type WebStartHelloPaySubscriptionInput = {
  /** 3Dセキュア認証済みのカード登録ID */
  helloPayCardId: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  requestId: Scalars['String']['input'];
};

export const WebSubscriptionSalePriceOptionEnum = {
  GoldOneYear30000: 'GoldOneYear30000',
  GoldOneYearHalf: 'GoldOneYearHalf',
  PlatinumOneYear59800: 'PlatinumOneYear59800',
  PlatinumOneYearHalf: 'PlatinumOneYearHalf'
} as const;

export type WebSubscriptionSalePriceOptionEnum = typeof WebSubscriptionSalePriceOptionEnum[keyof typeof WebSubscriptionSalePriceOptionEnum];
export type WebSubscriptionUpgradeSale = {
  __typename?: 'WebSubscriptionUpgradeSale';
  bannerImageUrl: Scalars['String']['output'];
  carouselBannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isWebSubscriptionUpgradeSaleAvailable: Scalars['Boolean']['output'];
  middleareaBannerUrl: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  textForBanner: Scalars['String']['output'];
};

export type WebTicketOrderInput = {
  orderId: Scalars['String']['input'];
};

export type WebTicketOrderOutput = {
  __typename?: 'WebTicketOrderOutput';
  bonusTicketCount: Scalars['Int']['output'];
  /** 支払いを開始したカード登録ID。支払い開始前はnull */
  cardRegistrationId?: Maybe<Scalars['String']['output']>;
  /** 確定したカード決済失敗の理由 */
  failureReason?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  status: Scalars['String']['output'];
  ticketCount: Scalars['Int']['output'];
};

export type WebUpgradeHelloPaySubscriptionInput = {
  /** webHelloPaySubscriptionUpgradeQuoteで表示した差額。請求額と異なる場合は請求しない */
  amount: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  /** webHelloPaySubscriptionUpgradeQuoteで受け取った値。確認した金額で請求する */
  prorationDate: Scalars['Int']['input'];
  requestId: Scalars['String']['input'];
};

export type WelcomeBackSale = {
  __typename?: 'WelcomeBackSale';
  bannerImageUrl: Scalars['String']['output'];
  carouselBannerImageUrl: Scalars['String']['output'];
  discountRatePercentages: Scalars['Float']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isAvailableForGold: Scalars['Boolean']['output'];
  isAvailableForPlatinum: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
  textForWebBanner: Scalars['String']['output'];
};

export type WelcomeSale = {
  __typename?: 'WelcomeSale';
  bannerImageUrl: Scalars['String']['output'];
  carouselBannerImageUrl: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isAvailableForGold: Scalars['Boolean']['output'];
  isAvailableForPlatinum: Scalars['Boolean']['output'];
  textForBanner: Scalars['String']['output'];
  textForWebBanner: Scalars['String']['output'];
};

export type WithdrawInput = {
  lineLinkUuid?: InputMaybe<Scalars['String']['input']>;
  otherDescription?: InputMaybe<Scalars['String']['input']>;
  pointOfImprovement?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonForUsingGorgeous?: InputMaybe<Scalars['String']['input']>;
  wantedFeatures?: InputMaybe<Scalars['String']['input']>;
  withdrawalSurveyLoveStory?: InputMaybe<WithdrawalSurveyLoveStoryInput>;
};

export type WithdrawUserByAdminInput = {
  userId: Scalars['Int']['input'];
};

export type WithdrawalSurveyLoveStoryInput = {
  detailOfLover?: InputMaybe<Scalars['String']['input']>;
  isInterestedInGorgeousReport: Scalars['Boolean']['input'];
  loverId?: InputMaybe<Scalars['Float']['input']>;
  periodFromMatchingToFirstMeeting: Scalars['String']['input'];
  periodFromMatchingToRelationship: Scalars['String']['input'];
  reasonForRelationship?: InputMaybe<Scalars['String']['input']>;
};

export type WebSendVerificationCodeMutationVariables = Exact<{
  phoneNumberInput: PhoneNumberInput;
}>;


export type WebSendVerificationCodeMutation = { __typename?: 'Mutation', webSendVerificationCode: boolean };

export type WebLoginWithPhoneMutationVariables = Exact<{
  loginWithPhoneInput: LoginWithPhoneInput;
}>;


export type WebLoginWithPhoneMutation = { __typename?: 'Mutation', webLoginWithPhone?: { __typename?: 'WebAuthOutput', accessToken: string, user: { __typename?: 'WebCurrentUser', id: number, uuid: string, status: any } } | null };

export type WebLoginWithLineMutationVariables = Exact<{
  loginWithLineInput: LoginWithLineInput;
}>;


export type WebLoginWithLineMutation = { __typename?: 'Mutation', webLoginWithLine?: { __typename?: 'WebAuthOutput', accessToken: string, user: { __typename?: 'WebCurrentUser', id: number, uuid: string, status: any } } | null };

export type WebLoginWithAppleMutationVariables = Exact<{
  loginWithAppleInput: LoginWithAppleInput;
}>;


export type WebLoginWithAppleMutation = { __typename?: 'Mutation', webLoginWithApple?: { __typename?: 'WebAuthOutput', accessToken: string, user: { __typename?: 'WebCurrentUser', id: number, uuid: string, status: any } } | null };

export type WebLoginWithAuthExchangeCodeMutationVariables = Exact<{
  authExchangeCodeInput: AuthExchangeCodeInput;
}>;


export type WebLoginWithAuthExchangeCodeMutation = { __typename?: 'Mutation', webLoginWithAuthExchangeCode?: { __typename?: 'WebAuthOutput', accessToken: string, user: { __typename?: 'WebCurrentUser', id: number, uuid: string, status: any } } | null };

export type WebFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type WebFeatureFlagsQuery = { __typename?: 'Query', featureFlags: { __typename?: 'FeatureFlags', featureFlagWebPaymentError: boolean } };

export type WebCurrentUserFragmentFragment = { __typename?: 'WebCurrentUser', id: number, uuid: string, gender: any, isMan: boolean, age: number, status: any, isSuspending: boolean, memberStatus: any, isTicket999Available: boolean, identificationStatus: any, jobCertificationStatus: any, incomeConfirmationStatus: any, isIdentified: boolean, isCelebrityCertified: boolean, celebrityCertificationStatus?: any | null, isTrialGold: boolean, isPaidMember: boolean, isPaidPlanJoinable: boolean, isPaidWithoutFreeMember: boolean, currentPaymentPlatform: PaymentPlatformTypeEnum, platform?: any | null, activeWebSubscription?: { __typename?: 'WebPaymentSubscription', productId: number, expiredAt: number, cancelText?: string | null, isCanceled: boolean, upgradeUnavailableText?: string | null } | null, profile?: { __typename?: 'Profile', income: any, nickname: string, residencePrefecture: any } | null, resizedProfileImages?: Array<{ __typename?: 'ResizedProfileImage', id: number, imageUrlMediumNonBlur?: string | null, imageUrlMedium: string, imageUrlSmall: string, isMain: boolean, isPrivate: boolean, status?: any | null, publicSetting: any }> | null, featureFlags: { __typename?: 'FeatureFlagsForUser', featureFlagWebSubscription: boolean, featureFlagInitialSubscriptionTutorial: boolean, featureFlagWebSubscriptionInitialDiscount: boolean }, extraTicketSale: { __typename?: 'ExtraTicketSaleV2', isAvailable: boolean, isCampaignAvailable: boolean, isVisible: boolean, dueDate: number, campaignDueDate: number, campaignTargetTicketKind?: Array<number> | null, campaignTextForBanner: string, textForBanner: string, bannerImageUrl: string, campaignBonuses?: Array<{ __typename?: 'TicketSaleBonus', ticketCount: number, bonusCount: number }> | null }, extraTicketSaleOnSubscription: { __typename?: 'ExtraTicketSaleOnSubscription', isAvailable: boolean, dueDate: number, textForBanner: string, isHighIncomeTarget: boolean, isLowIncomeTargetUnder30: boolean, isLowIncomeTargetOver30: boolean }, secondWelcomeTicketSale: { __typename?: 'SecondWelcomeTicketSale', bannerImageUrl: string, isCampaignAvailable: boolean, isAvailable: boolean, dueDate: number, textForBanner: string, isBoostTarget: boolean, isDiscountTarget: boolean, isHighIncomeTarget: boolean, isLowIncomeTargetUnder30: boolean, isLowIncomeTargetOver30: boolean }, infiniteWelcomeTicketSale: { __typename?: 'InfiniteWelcomeTicketSale', bannerImageUrl: string, isAvailable: boolean, dueDate: number, textForBanner: string, isDiscountTarget: boolean }, fiveYenTicketSale: { __typename?: 'FiveYenTicketSale', isAvailable: boolean }, webSubscriptionSpecialSale: { __typename?: 'SubscriptionSpecialSaleV2', carouselBannerImageUrl?: string | null, isWebSubscrptionSaleAvailable: boolean, isAvailableForPlatinum: boolean, isAvailableForGold: boolean, dueDate: number, textForBanner: string, bannerImageUrl: string, planName: string, isCommonSaleHalfPrice: boolean, webSalePriceProductIds: Array<number> }, subWebSubscriptionSpecialSale: { __typename?: 'SubWebSubscriptionSpecialSale', isWebSubscrptionSaleAvailable: boolean, isAvailableForPlatinum: boolean, isAvailableForGold: boolean, dueDate: number, textForBanner: string, bannerImageUrl: string, planName: string }, webSubscriptionUpgradeSale: { __typename?: 'WebSubscriptionUpgradeSale', isWebSubscriptionUpgradeSaleAvailable: boolean, dueDate: number, textForBanner: string, bannerImageUrl: string, carouselBannerImageUrl: string, planName: string }, welcomeSale: { __typename?: 'WelcomeSale', carouselBannerImageUrl: string, isAvailableForGold: boolean, isAvailableForPlatinum: boolean, dueDate: number, textForWebBanner: string, bannerImageUrl: string }, welcomeBackSale: { __typename?: 'WelcomeBackSale', carouselBannerImageUrl: string, isAvailable: boolean, isAvailableForGold: boolean, isAvailableForPlatinum: boolean, dueDate: number, textForBanner: string, textForWebBanner: string, bannerImageUrl: string, discountRatePercentages: number }, notImmediateResumeSale: { __typename?: 'NotImmediateResumeSale', carouselBannerImageUrl: string, isAvailable: boolean, dueDate: number, textForBanner: string, textForWebBanner: string, bannerImageUrl: string, discountRatePercentages: number }, existingNewSale: { __typename?: 'ExistingNewSale', carouselBannerImageUrl: string, isAvailable: boolean, isWebHalfPrice: boolean, dueDate: number, textForBanner: string, textForWebBanner: string, bannerImageUrl: string }, secondWelcomeSale: { __typename?: 'SecondWelcomeSale', carouselBannerImageUrl: string, isAvailable: boolean, dueDate: number, textForWebBanner: string, bannerImageUrl: string }, secondWelcomeBackSale: { __typename?: 'SecondWelcomeBackSale', carouselBannerImageUrl: string, isAvailable: boolean, isAvailableForGold: boolean, isAvailableForPlatinum: boolean, dueDate: number, textForBanner: string, textForWebBanner: string, bannerImageUrl: string, discountRatePercentages: number } };

export type WebResizedProfileImageFragmentFragment = { __typename?: 'ResizedProfileImage', id: number, imageUrlMediumNonBlur?: string | null, imageUrlMedium: string, imageUrlSmall: string, isMain: boolean, isPrivate: boolean, status?: any | null, publicSetting: any };

export type WebHelloPaySubscriptionFieldsFragment = { __typename?: 'HelloPaySubscription', id: number, status: string, productId: number, helloPayCardId: string, expiredAt?: number | null, isCanceled: boolean, isPastDue: boolean, isUnderReview: boolean, cancelText?: string | null };

export type WebHelloPaySubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type WebHelloPaySubscriptionQuery = { __typename?: 'Query', webHelloPaySubscription?: { __typename?: 'HelloPaySubscription', id: number, status: string, productId: number, helloPayCardId: string, expiredAt?: number | null, isCanceled: boolean, isPastDue: boolean, isUnderReview: boolean, cancelText?: string | null } | null };

export type WebHelloPaySubscriptionInitialFailureQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type WebHelloPaySubscriptionInitialFailureQuery = { __typename?: 'Query', webHelloPaySubscriptionInitialFailure?: { __typename?: 'WebHelloPaySubscriptionInitialFailure', failureReason?: string | null } | null };

export type WebHelloPaySubscriptionUpgradeQuoteQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type WebHelloPaySubscriptionUpgradeQuoteQuery = { __typename?: 'Query', webHelloPaySubscriptionUpgradeQuote: { __typename?: 'WebHelloPaySubscriptionUpgradeQuote', amount: number, prorationDate: number } };

export type WebStartHelloPaySubscriptionMutationVariables = Exact<{
  input: WebStartHelloPaySubscriptionInput;
}>;


export type WebStartHelloPaySubscriptionMutation = { __typename?: 'Mutation', webStartHelloPaySubscription: { __typename?: 'HelloPaySubscription', id: number, status: string, productId: number, helloPayCardId: string, expiredAt?: number | null, isCanceled: boolean, isPastDue: boolean, isUnderReview: boolean, cancelText?: string | null } };

export type WebSyncHelloPaySubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type WebSyncHelloPaySubscriptionMutation = { __typename?: 'Mutation', webSyncHelloPaySubscription?: { __typename?: 'HelloPaySubscription', id: number, status: string, productId: number, helloPayCardId: string, expiredAt?: number | null, isCanceled: boolean, isPastDue: boolean, isUnderReview: boolean, cancelText?: string | null } | null };

export type WebUpgradeHelloPaySubscriptionMutationVariables = Exact<{
  input: WebUpgradeHelloPaySubscriptionInput;
}>;


export type WebUpgradeHelloPaySubscriptionMutation = { __typename?: 'Mutation', webUpgradeHelloPaySubscription: { __typename?: 'HelloPaySubscription', id: number, status: string, productId: number, helloPayCardId: string, expiredAt?: number | null, isCanceled: boolean, isPastDue: boolean, isUnderReview: boolean, cancelText?: string | null } };

export type WebCancelHelloPaySubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type WebCancelHelloPaySubscriptionMutation = { __typename?: 'Mutation', webCancelHelloPaySubscription: { __typename?: 'HelloPaySubscription', id: number, status: string, productId: number, helloPayCardId: string, expiredAt?: number | null, isCanceled: boolean, isPastDue: boolean, isUnderReview: boolean, cancelText?: string | null } };

export type WebHelloPayAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type WebHelloPayAvailabilityQuery = { __typename?: 'Query', webHelloPayAvailability: { __typename?: 'WebHelloPayAvailabilityOutput', isHelloPayTarget: boolean, canRegisterCard: boolean, hasActiveCards: boolean, paymentInProgressOrder?: { __typename?: 'WebHelloPayPaymentInProgressOrder', orderId: string, cardRegistrationId: string, ticketMenuId: number } | null } };

export type WebHelloPayCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type WebHelloPayCardsQuery = { __typename?: 'Query', webHelloPayCards: { __typename?: 'WebHelloPayCardsOutput', pendingRegistrationIds: Array<string>, maxCards: number, cards: Array<{ __typename?: 'WebHelloPayCard', registrationId: string, brand: string, last4: string, expMonth: number, expYear: number, isExpired: boolean }>, pendingCardDetails?: Array<{ __typename?: 'WebHelloPayPendingCardDetails', registrationId: string, brand: string, last4: string }> | null } };

export type WebStartHelloPayCardRegistrationMutationVariables = Exact<{
  input: WebStartHelloPayCardRegistrationInput;
}>;


export type WebStartHelloPayCardRegistrationMutation = { __typename?: 'Mutation', webStartHelloPayCardRegistration: { __typename?: 'WebHelloPayCardRegistrationOutput', registrationId: string, status: string, redirectUrl?: string | null } };

export type WebSyncHelloPayCardRegistrationMutationVariables = Exact<{
  input: WebHelloPayCardRegistrationInput;
}>;


export type WebSyncHelloPayCardRegistrationMutation = { __typename?: 'Mutation', webSyncHelloPayCardRegistration: { __typename?: 'WebHelloPayCardRegistrationOutput', registrationId: string, status: string, redirectUrl?: string | null } };

export type WebCancelHelloPayCardSetupMutationVariables = Exact<{
  input: WebCancelHelloPayCardSetupInput;
}>;


export type WebCancelHelloPayCardSetupMutation = { __typename?: 'Mutation', webCancelHelloPayCardSetup: { __typename?: 'WebHelloPayCardRegistrationOutput', registrationId: string, status: string, redirectUrl?: string | null } };

export type WebDeleteHelloPayCardMutationVariables = Exact<{
  input: WebHelloPayCardRegistrationInput;
}>;


export type WebDeleteHelloPayCardMutation = { __typename?: 'Mutation', webDeleteHelloPayCard: boolean };

export type WebCreateTicketOrderMutationVariables = Exact<{
  input: WebCreateTicketOrderInput;
}>;


export type WebCreateTicketOrderMutation = { __typename?: 'Mutation', webCreateTicketOrder: { __typename?: 'WebTicketOrderOutput', orderId: string, status: string } };

export type WebPayHelloPayTicketOrderMutationVariables = Exact<{
  input: WebPayHelloPayTicketOrderInput;
}>;


export type WebPayHelloPayTicketOrderMutation = { __typename?: 'Mutation', webPayHelloPayTicketOrder: { __typename?: 'WebTicketOrderOutput', orderId: string, status: string } };

export type WebTicketOrderQueryVariables = Exact<{
  input: WebTicketOrderInput;
}>;


export type WebTicketOrderQuery = { __typename?: 'Query', webTicketOrder: { __typename?: 'WebTicketOrderOutput', orderId: string, status: string, failureReason?: string | null, cardRegistrationId?: string | null, ticketCount: number, bonusTicketCount: number } };

export type WebMasterQueryVariables = Exact<{ [key: string]: never; }>;


export type WebMasterQuery = { __typename?: 'Query', webTicketMenus: Array<{ __typename?: 'TicketMenu', id: number, name: string, price: number, numberOfTicket: number, webProductId?: string | null }>, webProducts: Array<{ __typename?: 'Product', id: number, name: string, price: number, renewalPrice?: number | null, duration?: any | null }> };

export type WebCreateTicketCheckoutLinkMutationVariables = Exact<{
  input: WebCreateTicketCheckoutLinkInput;
}>;


export type WebCreateTicketCheckoutLinkMutation = { __typename?: 'Mutation', webCreateTicketCheckoutLink: { __typename?: 'WebCreateCheckoutLinkOutput', checkoutUrl: string } };

export type WebCreateCardEditLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type WebCreateCardEditLinkMutation = { __typename?: 'Mutation', webCreateCardEditLink: { __typename?: 'WebCreateCardEditLinkOutput', cardEditUrl: string } };

export type WebCreateSubscriptionCheckoutLinkMutationVariables = Exact<{
  input: WebCreateSubscriptionCheckoutLinkInput;
}>;


export type WebCreateSubscriptionCheckoutLinkMutation = { __typename?: 'Mutation', webCreateSubscriptionCheckoutLink: { __typename?: 'WebCreateCheckoutLinkOutput', checkoutUrl: string } };

export type WebCreateSubscriptionUpgradeCheckoutLinkMutationVariables = Exact<{
  input: WebCreateSubscriptionUpgradeCheckoutLinkInput;
}>;


export type WebCreateSubscriptionUpgradeCheckoutLinkMutation = { __typename?: 'Mutation', webCreateSubscriptionUpgradeCheckoutLink: { __typename?: 'WebCreateUpgradeCheckoutLinkOutput', checkoutUrl: string } };

export type WebCancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type WebCancelSubscriptionMutation = { __typename?: 'Mutation', webCancelSubscription: boolean };

export type WebSyncSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type WebSyncSubscriptionMutation = { __typename?: 'Mutation', webSyncSubscription: boolean };

export type WebGetSubscriptionUpgradePriceQueryVariables = Exact<{
  input: WebGetSubscriptionUpgradePriceInput;
}>;


export type WebGetSubscriptionUpgradePriceQuery = { __typename?: 'Query', webGetSubscriptionUpgradePrice: { __typename?: 'WebGetSubscriptionUpgradePriceOutput', availableUpgradePrice?: number | null, isUpgradable: boolean } };

export type WebTicketPurchaseMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type WebTicketPurchaseMenuQuery = { __typename?: 'Query', webTicketPurchaseMenu: { __typename?: 'TicketPurchaseMenu', viewerId: number, isV4: boolean, saleKind: string, saleEndsAt?: number | null, items: Array<{ __typename?: 'TicketPurchaseItem', ticketMenuId: number, name: string, numberOfTicket: number, price: number, bonusCount: number, referencePrice: number, isDiscount: boolean, isRecommended: boolean, iosProductId: string, androidProductId: string, webProductId?: string | null, offeringIdentifier?: string | null, packageIdentifier?: string | null }> } };

export type WebCurrentTicketQueryVariables = Exact<{ [key: string]: never; }>;


export type WebCurrentTicketQuery = { __typename?: 'Query', webCurrentTicket: { __typename?: 'CurrentTicket', totalTicket: number, bonusTicket: number, purchaseTicket: number } };

export type WebCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type WebCurrentUserQuery = { __typename?: 'Query', webCurrentUser: { __typename?: 'WebCurrentUser', id: number, uuid: string, gender: any, isMan: boolean, age: number, status: any, isSuspending: boolean, memberStatus: any, isTicket999Available: boolean, identificationStatus: any, jobCertificationStatus: any, incomeConfirmationStatus: any, isIdentified: boolean, isCelebrityCertified: boolean, celebrityCertificationStatus?: any | null, isTrialGold: boolean, isPaidMember: boolean, isPaidPlanJoinable: boolean, isPaidWithoutFreeMember: boolean, currentPaymentPlatform: PaymentPlatformTypeEnum, platform?: any | null, activeWebSubscription?: { __typename?: 'WebPaymentSubscription', productId: number, expiredAt: number, cancelText?: string | null, isCanceled: boolean, upgradeUnavailableText?: string | null } | null, profile?: { __typename?: 'Profile', income: any, nickname: string, residencePrefecture: any } | null, resizedProfileImages?: Array<{ __typename?: 'ResizedProfileImage', id: number, imageUrlMediumNonBlur?: string | null, imageUrlMedium: string, imageUrlSmall: string, isMain: boolean, isPrivate: boolean, status?: any | null, publicSetting: any }> | null, featureFlags: { __typename?: 'FeatureFlagsForUser', featureFlagWebSubscription: boolean, featureFlagInitialSubscriptionTutorial: boolean, featureFlagWebSubscriptionInitialDiscount: boolean }, extraTicketSale: { __typename?: 'ExtraTicketSaleV2', isAvailable: boolean, isCampaignAvailable: boolean, isVisible: boolean, dueDate: number, campaignDueDate: number, campaignTargetTicketKind?: Array<number> | null, campaignTextForBanner: string, textForBanner: string, bannerImageUrl: string, campaignBonuses?: Array<{ __typename?: 'TicketSaleBonus', ticketCount: number, bonusCount: number }> | null }, extraTicketSaleOnSubscription: { __typename?: 'ExtraTicketSaleOnSubscription', isAvailable: boolean, dueDate: number, textForBanner: string, isHighIncomeTarget: boolean, isLowIncomeTargetUnder30: boolean, isLowIncomeTargetOver30: boolean }, secondWelcomeTicketSale: { __typename?: 'SecondWelcomeTicketSale', bannerImageUrl: string, isCampaignAvailable: boolean, isAvailable: boolean, dueDate: number, textForBanner: string, isBoostTarget: boolean, isDiscountTarget: boolean, isHighIncomeTarget: boolean, isLowIncomeTargetUnder30: boolean, isLowIncomeTargetOver30: boolean }, infiniteWelcomeTicketSale: { __typename?: 'InfiniteWelcomeTicketSale', bannerImageUrl: string, isAvailable: boolean, dueDate: number, textForBanner: string, isDiscountTarget: boolean }, fiveYenTicketSale: { __typename?: 'FiveYenTicketSale', isAvailable: boolean }, webSubscriptionSpecialSale: { __typename?: 'SubscriptionSpecialSaleV2', carouselBannerImageUrl?: string | null, isWebSubscrptionSaleAvailable: boolean, isAvailableForPlatinum: boolean, isAvailableForGold: boolean, dueDate: number, textForBanner: string, bannerImageUrl: string, planName: string, isCommonSaleHalfPrice: boolean, webSalePriceProductIds: Array<number> }, subWebSubscriptionSpecialSale: { __typename?: 'SubWebSubscriptionSpecialSale', isWebSubscrptionSaleAvailable: boolean, isAvailableForPlatinum: boolean, isAvailableForGold: boolean, dueDate: number, textForBanner: string, bannerImageUrl: string, planName: string }, webSubscriptionUpgradeSale: { __typename?: 'WebSubscriptionUpgradeSale', isWebSubscriptionUpgradeSaleAvailable: boolean, dueDate: number, textForBanner: string, bannerImageUrl: string, carouselBannerImageUrl: string, planName: string }, welcomeSale: { __typename?: 'WelcomeSale', carouselBannerImageUrl: string, isAvailableForGold: boolean, isAvailableForPlatinum: boolean, dueDate: number, textForWebBanner: string, bannerImageUrl: string }, welcomeBackSale: { __typename?: 'WelcomeBackSale', carouselBannerImageUrl: string, isAvailable: boolean, isAvailableForGold: boolean, isAvailableForPlatinum: boolean, dueDate: number, textForBanner: string, textForWebBanner: string, bannerImageUrl: string, discountRatePercentages: number }, notImmediateResumeSale: { __typename?: 'NotImmediateResumeSale', carouselBannerImageUrl: string, isAvailable: boolean, dueDate: number, textForBanner: string, textForWebBanner: string, bannerImageUrl: string, discountRatePercentages: number }, existingNewSale: { __typename?: 'ExistingNewSale', carouselBannerImageUrl: string, isAvailable: boolean, isWebHalfPrice: boolean, dueDate: number, textForBanner: string, textForWebBanner: string, bannerImageUrl: string }, secondWelcomeSale: { __typename?: 'SecondWelcomeSale', carouselBannerImageUrl: string, isAvailable: boolean, dueDate: number, textForWebBanner: string, bannerImageUrl: string }, secondWelcomeBackSale: { __typename?: 'SecondWelcomeBackSale', carouselBannerImageUrl: string, isAvailable: boolean, isAvailableForGold: boolean, isAvailableForPlatinum: boolean, dueDate: number, textForBanner: string, textForWebBanner: string, bannerImageUrl: string, discountRatePercentages: number } } };

export type WebStarterPackSaleQueryVariables = Exact<{ [key: string]: never; }>;


export type WebStarterPackSaleQuery = { __typename?: 'Query', webCurrentUser: { __typename?: 'WebCurrentUser', id: number, starterPackSale: { __typename?: 'StarterPackSale', isAvailable: boolean, dueDate: number, name: string, shortName: string, productId: number } } };

export type WebGetCurrentUserLoginProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type WebGetCurrentUserLoginProviderQuery = { __typename?: 'Query', webGetCurrentUserLoginProvider?: LoginProviderEnum | null };

export const WebResizedProfileImageFragmentFragmentDoc = gql`
    fragment webResizedProfileImageFragment on ResizedProfileImage {
  id
  imageUrlMediumNonBlur
  imageUrlMedium
  imageUrlSmall
  isMain
  isPrivate
  status
  publicSetting
}
    `;
export const WebCurrentUserFragmentFragmentDoc = gql`
    fragment webCurrentUserFragment on WebCurrentUser {
  id
  uuid
  gender
  isMan
  age
  status
  isSuspending
  memberStatus
  isTicket999Available
  identificationStatus
  jobCertificationStatus
  incomeConfirmationStatus
  isIdentified
  isCelebrityCertified
  celebrityCertificationStatus
  isTrialGold
  isPaidMember
  isPaidPlanJoinable
  isPaidWithoutFreeMember
  activeWebSubscription {
    productId
    expiredAt
    cancelText
    isCanceled
    upgradeUnavailableText
  }
  currentPaymentPlatform
  platform
  profile {
    income
    nickname
    residencePrefecture
  }
  resizedProfileImages {
    ...webResizedProfileImageFragment
  }
  featureFlags {
    featureFlagWebSubscription
    featureFlagInitialSubscriptionTutorial
    featureFlagWebSubscriptionInitialDiscount
  }
  extraTicketSale {
    isAvailable
    isCampaignAvailable
    isVisible
    dueDate
    campaignDueDate
    campaignTargetTicketKind
    campaignBonuses {
      ticketCount
      bonusCount
    }
    campaignTextForBanner
    textForBanner
    bannerImageUrl
  }
  extraTicketSaleOnSubscription {
    isAvailable
    dueDate
    textForBanner
    isHighIncomeTarget
    isLowIncomeTargetUnder30
    isLowIncomeTargetOver30
  }
  secondWelcomeTicketSale {
    bannerImageUrl
    isCampaignAvailable
    isAvailable
    dueDate
    textForBanner
    isBoostTarget
    isDiscountTarget
    isHighIncomeTarget
    isLowIncomeTargetUnder30
    isLowIncomeTargetOver30
  }
  infiniteWelcomeTicketSale {
    bannerImageUrl
    isAvailable
    dueDate
    textForBanner
    isDiscountTarget
  }
  fiveYenTicketSale {
    isAvailable
  }
  webSubscriptionSpecialSale {
    carouselBannerImageUrl
    isWebSubscrptionSaleAvailable
    isAvailableForPlatinum
    isAvailableForGold
    dueDate
    textForBanner
    bannerImageUrl
    planName
    isCommonSaleHalfPrice
    webSalePriceProductIds
  }
  subWebSubscriptionSpecialSale {
    isWebSubscrptionSaleAvailable
    isAvailableForPlatinum
    isAvailableForGold
    dueDate
    textForBanner
    bannerImageUrl
    planName
  }
  webSubscriptionUpgradeSale {
    isWebSubscriptionUpgradeSaleAvailable
    dueDate
    textForBanner
    bannerImageUrl
    carouselBannerImageUrl
    planName
  }
  welcomeSale {
    carouselBannerImageUrl
    isAvailableForGold
    isAvailableForPlatinum
    dueDate
    textForWebBanner
    bannerImageUrl
  }
  welcomeBackSale {
    carouselBannerImageUrl
    isAvailable
    isAvailableForGold
    isAvailableForPlatinum
    dueDate
    textForBanner
    textForWebBanner
    bannerImageUrl
    discountRatePercentages
  }
  notImmediateResumeSale {
    carouselBannerImageUrl
    isAvailable
    dueDate
    textForBanner
    textForWebBanner
    bannerImageUrl
    discountRatePercentages
  }
  existingNewSale {
    carouselBannerImageUrl
    isAvailable
    isWebHalfPrice
    dueDate
    textForBanner
    textForWebBanner
    bannerImageUrl
  }
  secondWelcomeSale {
    carouselBannerImageUrl
    isAvailable
    dueDate
    textForWebBanner
    bannerImageUrl
  }
  secondWelcomeBackSale {
    carouselBannerImageUrl
    isAvailable
    isAvailableForGold
    isAvailableForPlatinum
    dueDate
    textForBanner
    textForWebBanner
    bannerImageUrl
    discountRatePercentages
  }
}
    ${WebResizedProfileImageFragmentFragmentDoc}`;
export const WebHelloPaySubscriptionFieldsFragmentDoc = gql`
    fragment WebHelloPaySubscriptionFields on HelloPaySubscription {
  id
  status
  productId
  helloPayCardId
  expiredAt
  isCanceled
  isPastDue
  isUnderReview
  cancelText
}
    `;
export const WebSendVerificationCodeDocument = gql`
    mutation WebSendVerificationCode($phoneNumberInput: PhoneNumberInput!) {
  webSendVerificationCode(phoneNumberInput: $phoneNumberInput)
}
    `;
export type WebSendVerificationCodeMutationFn = Apollo.MutationFunction<WebSendVerificationCodeMutation, WebSendVerificationCodeMutationVariables>;

/**
 * __useWebSendVerificationCodeMutation__
 *
 * To run a mutation, you first call `useWebSendVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebSendVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webSendVerificationCodeMutation, { data, loading, error }] = useWebSendVerificationCodeMutation({
 *   variables: {
 *      phoneNumberInput: // value for 'phoneNumberInput'
 *   },
 * });
 */
export function useWebSendVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<WebSendVerificationCodeMutation, WebSendVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebSendVerificationCodeMutation, WebSendVerificationCodeMutationVariables>(WebSendVerificationCodeDocument, options);
      }
export type WebSendVerificationCodeMutationHookResult = ReturnType<typeof useWebSendVerificationCodeMutation>;
export type WebSendVerificationCodeMutationResult = Apollo.MutationResult<WebSendVerificationCodeMutation>;
export type WebSendVerificationCodeMutationOptions = Apollo.BaseMutationOptions<WebSendVerificationCodeMutation, WebSendVerificationCodeMutationVariables>;
export const WebLoginWithPhoneDocument = gql`
    mutation WebLoginWithPhone($loginWithPhoneInput: LoginWithPhoneInput!) {
  webLoginWithPhone(loginWithPhoneInput: $loginWithPhoneInput) {
    user {
      id
      uuid
      status
    }
    accessToken
  }
}
    `;
export type WebLoginWithPhoneMutationFn = Apollo.MutationFunction<WebLoginWithPhoneMutation, WebLoginWithPhoneMutationVariables>;

/**
 * __useWebLoginWithPhoneMutation__
 *
 * To run a mutation, you first call `useWebLoginWithPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebLoginWithPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webLoginWithPhoneMutation, { data, loading, error }] = useWebLoginWithPhoneMutation({
 *   variables: {
 *      loginWithPhoneInput: // value for 'loginWithPhoneInput'
 *   },
 * });
 */
export function useWebLoginWithPhoneMutation(baseOptions?: Apollo.MutationHookOptions<WebLoginWithPhoneMutation, WebLoginWithPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebLoginWithPhoneMutation, WebLoginWithPhoneMutationVariables>(WebLoginWithPhoneDocument, options);
      }
export type WebLoginWithPhoneMutationHookResult = ReturnType<typeof useWebLoginWithPhoneMutation>;
export type WebLoginWithPhoneMutationResult = Apollo.MutationResult<WebLoginWithPhoneMutation>;
export type WebLoginWithPhoneMutationOptions = Apollo.BaseMutationOptions<WebLoginWithPhoneMutation, WebLoginWithPhoneMutationVariables>;
export const WebLoginWithLineDocument = gql`
    mutation WebLoginWithLine($loginWithLineInput: LoginWithLineInput!) {
  webLoginWithLine(loginWithLineInput: $loginWithLineInput) {
    user {
      id
      uuid
      status
    }
    accessToken
  }
}
    `;
export type WebLoginWithLineMutationFn = Apollo.MutationFunction<WebLoginWithLineMutation, WebLoginWithLineMutationVariables>;

/**
 * __useWebLoginWithLineMutation__
 *
 * To run a mutation, you first call `useWebLoginWithLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebLoginWithLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webLoginWithLineMutation, { data, loading, error }] = useWebLoginWithLineMutation({
 *   variables: {
 *      loginWithLineInput: // value for 'loginWithLineInput'
 *   },
 * });
 */
export function useWebLoginWithLineMutation(baseOptions?: Apollo.MutationHookOptions<WebLoginWithLineMutation, WebLoginWithLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebLoginWithLineMutation, WebLoginWithLineMutationVariables>(WebLoginWithLineDocument, options);
      }
export type WebLoginWithLineMutationHookResult = ReturnType<typeof useWebLoginWithLineMutation>;
export type WebLoginWithLineMutationResult = Apollo.MutationResult<WebLoginWithLineMutation>;
export type WebLoginWithLineMutationOptions = Apollo.BaseMutationOptions<WebLoginWithLineMutation, WebLoginWithLineMutationVariables>;
export const WebLoginWithAppleDocument = gql`
    mutation WebLoginWithApple($loginWithAppleInput: LoginWithAppleInput!) {
  webLoginWithApple(loginWithAppleInput: $loginWithAppleInput) {
    user {
      id
      uuid
      status
    }
    accessToken
  }
}
    `;
export type WebLoginWithAppleMutationFn = Apollo.MutationFunction<WebLoginWithAppleMutation, WebLoginWithAppleMutationVariables>;

/**
 * __useWebLoginWithAppleMutation__
 *
 * To run a mutation, you first call `useWebLoginWithAppleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebLoginWithAppleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webLoginWithAppleMutation, { data, loading, error }] = useWebLoginWithAppleMutation({
 *   variables: {
 *      loginWithAppleInput: // value for 'loginWithAppleInput'
 *   },
 * });
 */
export function useWebLoginWithAppleMutation(baseOptions?: Apollo.MutationHookOptions<WebLoginWithAppleMutation, WebLoginWithAppleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebLoginWithAppleMutation, WebLoginWithAppleMutationVariables>(WebLoginWithAppleDocument, options);
      }
export type WebLoginWithAppleMutationHookResult = ReturnType<typeof useWebLoginWithAppleMutation>;
export type WebLoginWithAppleMutationResult = Apollo.MutationResult<WebLoginWithAppleMutation>;
export type WebLoginWithAppleMutationOptions = Apollo.BaseMutationOptions<WebLoginWithAppleMutation, WebLoginWithAppleMutationVariables>;
export const WebLoginWithAuthExchangeCodeDocument = gql`
    mutation WebLoginWithAuthExchangeCode($authExchangeCodeInput: AuthExchangeCodeInput!) {
  webLoginWithAuthExchangeCode(authExchangeCodeInput: $authExchangeCodeInput) {
    user {
      id
      uuid
      status
    }
    accessToken
  }
}
    `;
export type WebLoginWithAuthExchangeCodeMutationFn = Apollo.MutationFunction<WebLoginWithAuthExchangeCodeMutation, WebLoginWithAuthExchangeCodeMutationVariables>;

/**
 * __useWebLoginWithAuthExchangeCodeMutation__
 *
 * To run a mutation, you first call `useWebLoginWithAuthExchangeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebLoginWithAuthExchangeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webLoginWithAuthExchangeCodeMutation, { data, loading, error }] = useWebLoginWithAuthExchangeCodeMutation({
 *   variables: {
 *      authExchangeCodeInput: // value for 'authExchangeCodeInput'
 *   },
 * });
 */
export function useWebLoginWithAuthExchangeCodeMutation(baseOptions?: Apollo.MutationHookOptions<WebLoginWithAuthExchangeCodeMutation, WebLoginWithAuthExchangeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebLoginWithAuthExchangeCodeMutation, WebLoginWithAuthExchangeCodeMutationVariables>(WebLoginWithAuthExchangeCodeDocument, options);
      }
export type WebLoginWithAuthExchangeCodeMutationHookResult = ReturnType<typeof useWebLoginWithAuthExchangeCodeMutation>;
export type WebLoginWithAuthExchangeCodeMutationResult = Apollo.MutationResult<WebLoginWithAuthExchangeCodeMutation>;
export type WebLoginWithAuthExchangeCodeMutationOptions = Apollo.BaseMutationOptions<WebLoginWithAuthExchangeCodeMutation, WebLoginWithAuthExchangeCodeMutationVariables>;
export const WebFeatureFlagsDocument = gql`
    query WebFeatureFlags {
  featureFlags {
    featureFlagWebPaymentError
  }
}
    `;

/**
 * __useWebFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useWebFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<WebFeatureFlagsQuery, WebFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebFeatureFlagsQuery, WebFeatureFlagsQueryVariables>(WebFeatureFlagsDocument, options);
      }
export function useWebFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebFeatureFlagsQuery, WebFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebFeatureFlagsQuery, WebFeatureFlagsQueryVariables>(WebFeatureFlagsDocument, options);
        }
export function useWebFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebFeatureFlagsQuery, WebFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebFeatureFlagsQuery, WebFeatureFlagsQueryVariables>(WebFeatureFlagsDocument, options);
        }
export type WebFeatureFlagsQueryHookResult = ReturnType<typeof useWebFeatureFlagsQuery>;
export type WebFeatureFlagsLazyQueryHookResult = ReturnType<typeof useWebFeatureFlagsLazyQuery>;
export type WebFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useWebFeatureFlagsSuspenseQuery>;
export type WebFeatureFlagsQueryResult = Apollo.QueryResult<WebFeatureFlagsQuery, WebFeatureFlagsQueryVariables>;
export const WebHelloPaySubscriptionDocument = gql`
    query WebHelloPaySubscription {
  webHelloPaySubscription {
    ...WebHelloPaySubscriptionFields
  }
}
    ${WebHelloPaySubscriptionFieldsFragmentDoc}`;

/**
 * __useWebHelloPaySubscriptionQuery__
 *
 * To run a query within a React component, call `useWebHelloPaySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebHelloPaySubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebHelloPaySubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebHelloPaySubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<WebHelloPaySubscriptionQuery, WebHelloPaySubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebHelloPaySubscriptionQuery, WebHelloPaySubscriptionQueryVariables>(WebHelloPaySubscriptionDocument, options);
      }
export function useWebHelloPaySubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebHelloPaySubscriptionQuery, WebHelloPaySubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebHelloPaySubscriptionQuery, WebHelloPaySubscriptionQueryVariables>(WebHelloPaySubscriptionDocument, options);
        }
export function useWebHelloPaySubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebHelloPaySubscriptionQuery, WebHelloPaySubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebHelloPaySubscriptionQuery, WebHelloPaySubscriptionQueryVariables>(WebHelloPaySubscriptionDocument, options);
        }
export type WebHelloPaySubscriptionQueryHookResult = ReturnType<typeof useWebHelloPaySubscriptionQuery>;
export type WebHelloPaySubscriptionLazyQueryHookResult = ReturnType<typeof useWebHelloPaySubscriptionLazyQuery>;
export type WebHelloPaySubscriptionSuspenseQueryHookResult = ReturnType<typeof useWebHelloPaySubscriptionSuspenseQuery>;
export type WebHelloPaySubscriptionQueryResult = Apollo.QueryResult<WebHelloPaySubscriptionQuery, WebHelloPaySubscriptionQueryVariables>;
export const WebHelloPaySubscriptionInitialFailureDocument = gql`
    query WebHelloPaySubscriptionInitialFailure($requestId: String!) {
  webHelloPaySubscriptionInitialFailure(requestId: $requestId) {
    failureReason
  }
}
    `;

/**
 * __useWebHelloPaySubscriptionInitialFailureQuery__
 *
 * To run a query within a React component, call `useWebHelloPaySubscriptionInitialFailureQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebHelloPaySubscriptionInitialFailureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebHelloPaySubscriptionInitialFailureQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useWebHelloPaySubscriptionInitialFailureQuery(baseOptions: Apollo.QueryHookOptions<WebHelloPaySubscriptionInitialFailureQuery, WebHelloPaySubscriptionInitialFailureQueryVariables> & ({ variables: WebHelloPaySubscriptionInitialFailureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebHelloPaySubscriptionInitialFailureQuery, WebHelloPaySubscriptionInitialFailureQueryVariables>(WebHelloPaySubscriptionInitialFailureDocument, options);
      }
export function useWebHelloPaySubscriptionInitialFailureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebHelloPaySubscriptionInitialFailureQuery, WebHelloPaySubscriptionInitialFailureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebHelloPaySubscriptionInitialFailureQuery, WebHelloPaySubscriptionInitialFailureQueryVariables>(WebHelloPaySubscriptionInitialFailureDocument, options);
        }
export function useWebHelloPaySubscriptionInitialFailureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebHelloPaySubscriptionInitialFailureQuery, WebHelloPaySubscriptionInitialFailureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebHelloPaySubscriptionInitialFailureQuery, WebHelloPaySubscriptionInitialFailureQueryVariables>(WebHelloPaySubscriptionInitialFailureDocument, options);
        }
export type WebHelloPaySubscriptionInitialFailureQueryHookResult = ReturnType<typeof useWebHelloPaySubscriptionInitialFailureQuery>;
export type WebHelloPaySubscriptionInitialFailureLazyQueryHookResult = ReturnType<typeof useWebHelloPaySubscriptionInitialFailureLazyQuery>;
export type WebHelloPaySubscriptionInitialFailureSuspenseQueryHookResult = ReturnType<typeof useWebHelloPaySubscriptionInitialFailureSuspenseQuery>;
export type WebHelloPaySubscriptionInitialFailureQueryResult = Apollo.QueryResult<WebHelloPaySubscriptionInitialFailureQuery, WebHelloPaySubscriptionInitialFailureQueryVariables>;
export const WebHelloPaySubscriptionUpgradeQuoteDocument = gql`
    query WebHelloPaySubscriptionUpgradeQuote($productId: Int!) {
  webHelloPaySubscriptionUpgradeQuote(productId: $productId) {
    amount
    prorationDate
  }
}
    `;

/**
 * __useWebHelloPaySubscriptionUpgradeQuoteQuery__
 *
 * To run a query within a React component, call `useWebHelloPaySubscriptionUpgradeQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebHelloPaySubscriptionUpgradeQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebHelloPaySubscriptionUpgradeQuoteQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useWebHelloPaySubscriptionUpgradeQuoteQuery(baseOptions: Apollo.QueryHookOptions<WebHelloPaySubscriptionUpgradeQuoteQuery, WebHelloPaySubscriptionUpgradeQuoteQueryVariables> & ({ variables: WebHelloPaySubscriptionUpgradeQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebHelloPaySubscriptionUpgradeQuoteQuery, WebHelloPaySubscriptionUpgradeQuoteQueryVariables>(WebHelloPaySubscriptionUpgradeQuoteDocument, options);
      }
export function useWebHelloPaySubscriptionUpgradeQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebHelloPaySubscriptionUpgradeQuoteQuery, WebHelloPaySubscriptionUpgradeQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebHelloPaySubscriptionUpgradeQuoteQuery, WebHelloPaySubscriptionUpgradeQuoteQueryVariables>(WebHelloPaySubscriptionUpgradeQuoteDocument, options);
        }
export function useWebHelloPaySubscriptionUpgradeQuoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebHelloPaySubscriptionUpgradeQuoteQuery, WebHelloPaySubscriptionUpgradeQuoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebHelloPaySubscriptionUpgradeQuoteQuery, WebHelloPaySubscriptionUpgradeQuoteQueryVariables>(WebHelloPaySubscriptionUpgradeQuoteDocument, options);
        }
export type WebHelloPaySubscriptionUpgradeQuoteQueryHookResult = ReturnType<typeof useWebHelloPaySubscriptionUpgradeQuoteQuery>;
export type WebHelloPaySubscriptionUpgradeQuoteLazyQueryHookResult = ReturnType<typeof useWebHelloPaySubscriptionUpgradeQuoteLazyQuery>;
export type WebHelloPaySubscriptionUpgradeQuoteSuspenseQueryHookResult = ReturnType<typeof useWebHelloPaySubscriptionUpgradeQuoteSuspenseQuery>;
export type WebHelloPaySubscriptionUpgradeQuoteQueryResult = Apollo.QueryResult<WebHelloPaySubscriptionUpgradeQuoteQuery, WebHelloPaySubscriptionUpgradeQuoteQueryVariables>;
export const WebStartHelloPaySubscriptionDocument = gql`
    mutation WebStartHelloPaySubscription($input: WebStartHelloPaySubscriptionInput!) {
  webStartHelloPaySubscription(input: $input) {
    ...WebHelloPaySubscriptionFields
  }
}
    ${WebHelloPaySubscriptionFieldsFragmentDoc}`;
export type WebStartHelloPaySubscriptionMutationFn = Apollo.MutationFunction<WebStartHelloPaySubscriptionMutation, WebStartHelloPaySubscriptionMutationVariables>;

/**
 * __useWebStartHelloPaySubscriptionMutation__
 *
 * To run a mutation, you first call `useWebStartHelloPaySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebStartHelloPaySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webStartHelloPaySubscriptionMutation, { data, loading, error }] = useWebStartHelloPaySubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebStartHelloPaySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<WebStartHelloPaySubscriptionMutation, WebStartHelloPaySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebStartHelloPaySubscriptionMutation, WebStartHelloPaySubscriptionMutationVariables>(WebStartHelloPaySubscriptionDocument, options);
      }
export type WebStartHelloPaySubscriptionMutationHookResult = ReturnType<typeof useWebStartHelloPaySubscriptionMutation>;
export type WebStartHelloPaySubscriptionMutationResult = Apollo.MutationResult<WebStartHelloPaySubscriptionMutation>;
export type WebStartHelloPaySubscriptionMutationOptions = Apollo.BaseMutationOptions<WebStartHelloPaySubscriptionMutation, WebStartHelloPaySubscriptionMutationVariables>;
export const WebSyncHelloPaySubscriptionDocument = gql`
    mutation WebSyncHelloPaySubscription {
  webSyncHelloPaySubscription {
    ...WebHelloPaySubscriptionFields
  }
}
    ${WebHelloPaySubscriptionFieldsFragmentDoc}`;
export type WebSyncHelloPaySubscriptionMutationFn = Apollo.MutationFunction<WebSyncHelloPaySubscriptionMutation, WebSyncHelloPaySubscriptionMutationVariables>;

/**
 * __useWebSyncHelloPaySubscriptionMutation__
 *
 * To run a mutation, you first call `useWebSyncHelloPaySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebSyncHelloPaySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webSyncHelloPaySubscriptionMutation, { data, loading, error }] = useWebSyncHelloPaySubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useWebSyncHelloPaySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<WebSyncHelloPaySubscriptionMutation, WebSyncHelloPaySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebSyncHelloPaySubscriptionMutation, WebSyncHelloPaySubscriptionMutationVariables>(WebSyncHelloPaySubscriptionDocument, options);
      }
export type WebSyncHelloPaySubscriptionMutationHookResult = ReturnType<typeof useWebSyncHelloPaySubscriptionMutation>;
export type WebSyncHelloPaySubscriptionMutationResult = Apollo.MutationResult<WebSyncHelloPaySubscriptionMutation>;
export type WebSyncHelloPaySubscriptionMutationOptions = Apollo.BaseMutationOptions<WebSyncHelloPaySubscriptionMutation, WebSyncHelloPaySubscriptionMutationVariables>;
export const WebUpgradeHelloPaySubscriptionDocument = gql`
    mutation WebUpgradeHelloPaySubscription($input: WebUpgradeHelloPaySubscriptionInput!) {
  webUpgradeHelloPaySubscription(input: $input) {
    ...WebHelloPaySubscriptionFields
  }
}
    ${WebHelloPaySubscriptionFieldsFragmentDoc}`;
export type WebUpgradeHelloPaySubscriptionMutationFn = Apollo.MutationFunction<WebUpgradeHelloPaySubscriptionMutation, WebUpgradeHelloPaySubscriptionMutationVariables>;

/**
 * __useWebUpgradeHelloPaySubscriptionMutation__
 *
 * To run a mutation, you first call `useWebUpgradeHelloPaySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebUpgradeHelloPaySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webUpgradeHelloPaySubscriptionMutation, { data, loading, error }] = useWebUpgradeHelloPaySubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebUpgradeHelloPaySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<WebUpgradeHelloPaySubscriptionMutation, WebUpgradeHelloPaySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebUpgradeHelloPaySubscriptionMutation, WebUpgradeHelloPaySubscriptionMutationVariables>(WebUpgradeHelloPaySubscriptionDocument, options);
      }
export type WebUpgradeHelloPaySubscriptionMutationHookResult = ReturnType<typeof useWebUpgradeHelloPaySubscriptionMutation>;
export type WebUpgradeHelloPaySubscriptionMutationResult = Apollo.MutationResult<WebUpgradeHelloPaySubscriptionMutation>;
export type WebUpgradeHelloPaySubscriptionMutationOptions = Apollo.BaseMutationOptions<WebUpgradeHelloPaySubscriptionMutation, WebUpgradeHelloPaySubscriptionMutationVariables>;
export const WebCancelHelloPaySubscriptionDocument = gql`
    mutation WebCancelHelloPaySubscription {
  webCancelHelloPaySubscription {
    ...WebHelloPaySubscriptionFields
  }
}
    ${WebHelloPaySubscriptionFieldsFragmentDoc}`;
export type WebCancelHelloPaySubscriptionMutationFn = Apollo.MutationFunction<WebCancelHelloPaySubscriptionMutation, WebCancelHelloPaySubscriptionMutationVariables>;

/**
 * __useWebCancelHelloPaySubscriptionMutation__
 *
 * To run a mutation, you first call `useWebCancelHelloPaySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebCancelHelloPaySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webCancelHelloPaySubscriptionMutation, { data, loading, error }] = useWebCancelHelloPaySubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useWebCancelHelloPaySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<WebCancelHelloPaySubscriptionMutation, WebCancelHelloPaySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebCancelHelloPaySubscriptionMutation, WebCancelHelloPaySubscriptionMutationVariables>(WebCancelHelloPaySubscriptionDocument, options);
      }
export type WebCancelHelloPaySubscriptionMutationHookResult = ReturnType<typeof useWebCancelHelloPaySubscriptionMutation>;
export type WebCancelHelloPaySubscriptionMutationResult = Apollo.MutationResult<WebCancelHelloPaySubscriptionMutation>;
export type WebCancelHelloPaySubscriptionMutationOptions = Apollo.BaseMutationOptions<WebCancelHelloPaySubscriptionMutation, WebCancelHelloPaySubscriptionMutationVariables>;
export const WebHelloPayAvailabilityDocument = gql`
    query WebHelloPayAvailability {
  webHelloPayAvailability {
    isHelloPayTarget
    canRegisterCard
    hasActiveCards
    paymentInProgressOrder {
      orderId
      cardRegistrationId
      ticketMenuId
    }
  }
}
    `;

/**
 * __useWebHelloPayAvailabilityQuery__
 *
 * To run a query within a React component, call `useWebHelloPayAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebHelloPayAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebHelloPayAvailabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebHelloPayAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<WebHelloPayAvailabilityQuery, WebHelloPayAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebHelloPayAvailabilityQuery, WebHelloPayAvailabilityQueryVariables>(WebHelloPayAvailabilityDocument, options);
      }
export function useWebHelloPayAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebHelloPayAvailabilityQuery, WebHelloPayAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebHelloPayAvailabilityQuery, WebHelloPayAvailabilityQueryVariables>(WebHelloPayAvailabilityDocument, options);
        }
export function useWebHelloPayAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebHelloPayAvailabilityQuery, WebHelloPayAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebHelloPayAvailabilityQuery, WebHelloPayAvailabilityQueryVariables>(WebHelloPayAvailabilityDocument, options);
        }
export type WebHelloPayAvailabilityQueryHookResult = ReturnType<typeof useWebHelloPayAvailabilityQuery>;
export type WebHelloPayAvailabilityLazyQueryHookResult = ReturnType<typeof useWebHelloPayAvailabilityLazyQuery>;
export type WebHelloPayAvailabilitySuspenseQueryHookResult = ReturnType<typeof useWebHelloPayAvailabilitySuspenseQuery>;
export type WebHelloPayAvailabilityQueryResult = Apollo.QueryResult<WebHelloPayAvailabilityQuery, WebHelloPayAvailabilityQueryVariables>;
export const WebHelloPayCardsDocument = gql`
    query WebHelloPayCards {
  webHelloPayCards {
    cards {
      registrationId
      brand
      last4
      expMonth
      expYear
      isExpired
    }
    pendingRegistrationIds
    pendingCardDetails {
      registrationId
      brand
      last4
    }
    maxCards
  }
}
    `;

/**
 * __useWebHelloPayCardsQuery__
 *
 * To run a query within a React component, call `useWebHelloPayCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebHelloPayCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebHelloPayCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebHelloPayCardsQuery(baseOptions?: Apollo.QueryHookOptions<WebHelloPayCardsQuery, WebHelloPayCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebHelloPayCardsQuery, WebHelloPayCardsQueryVariables>(WebHelloPayCardsDocument, options);
      }
export function useWebHelloPayCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebHelloPayCardsQuery, WebHelloPayCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebHelloPayCardsQuery, WebHelloPayCardsQueryVariables>(WebHelloPayCardsDocument, options);
        }
export function useWebHelloPayCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebHelloPayCardsQuery, WebHelloPayCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebHelloPayCardsQuery, WebHelloPayCardsQueryVariables>(WebHelloPayCardsDocument, options);
        }
export type WebHelloPayCardsQueryHookResult = ReturnType<typeof useWebHelloPayCardsQuery>;
export type WebHelloPayCardsLazyQueryHookResult = ReturnType<typeof useWebHelloPayCardsLazyQuery>;
export type WebHelloPayCardsSuspenseQueryHookResult = ReturnType<typeof useWebHelloPayCardsSuspenseQuery>;
export type WebHelloPayCardsQueryResult = Apollo.QueryResult<WebHelloPayCardsQuery, WebHelloPayCardsQueryVariables>;
export const WebStartHelloPayCardRegistrationDocument = gql`
    mutation WebStartHelloPayCardRegistration($input: WebStartHelloPayCardRegistrationInput!) {
  webStartHelloPayCardRegistration(input: $input) {
    registrationId
    status
    redirectUrl
  }
}
    `;
export type WebStartHelloPayCardRegistrationMutationFn = Apollo.MutationFunction<WebStartHelloPayCardRegistrationMutation, WebStartHelloPayCardRegistrationMutationVariables>;

/**
 * __useWebStartHelloPayCardRegistrationMutation__
 *
 * To run a mutation, you first call `useWebStartHelloPayCardRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebStartHelloPayCardRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webStartHelloPayCardRegistrationMutation, { data, loading, error }] = useWebStartHelloPayCardRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebStartHelloPayCardRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<WebStartHelloPayCardRegistrationMutation, WebStartHelloPayCardRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebStartHelloPayCardRegistrationMutation, WebStartHelloPayCardRegistrationMutationVariables>(WebStartHelloPayCardRegistrationDocument, options);
      }
export type WebStartHelloPayCardRegistrationMutationHookResult = ReturnType<typeof useWebStartHelloPayCardRegistrationMutation>;
export type WebStartHelloPayCardRegistrationMutationResult = Apollo.MutationResult<WebStartHelloPayCardRegistrationMutation>;
export type WebStartHelloPayCardRegistrationMutationOptions = Apollo.BaseMutationOptions<WebStartHelloPayCardRegistrationMutation, WebStartHelloPayCardRegistrationMutationVariables>;
export const WebSyncHelloPayCardRegistrationDocument = gql`
    mutation WebSyncHelloPayCardRegistration($input: WebHelloPayCardRegistrationInput!) {
  webSyncHelloPayCardRegistration(input: $input) {
    registrationId
    status
    redirectUrl
  }
}
    `;
export type WebSyncHelloPayCardRegistrationMutationFn = Apollo.MutationFunction<WebSyncHelloPayCardRegistrationMutation, WebSyncHelloPayCardRegistrationMutationVariables>;

/**
 * __useWebSyncHelloPayCardRegistrationMutation__
 *
 * To run a mutation, you first call `useWebSyncHelloPayCardRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebSyncHelloPayCardRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webSyncHelloPayCardRegistrationMutation, { data, loading, error }] = useWebSyncHelloPayCardRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebSyncHelloPayCardRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<WebSyncHelloPayCardRegistrationMutation, WebSyncHelloPayCardRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebSyncHelloPayCardRegistrationMutation, WebSyncHelloPayCardRegistrationMutationVariables>(WebSyncHelloPayCardRegistrationDocument, options);
      }
export type WebSyncHelloPayCardRegistrationMutationHookResult = ReturnType<typeof useWebSyncHelloPayCardRegistrationMutation>;
export type WebSyncHelloPayCardRegistrationMutationResult = Apollo.MutationResult<WebSyncHelloPayCardRegistrationMutation>;
export type WebSyncHelloPayCardRegistrationMutationOptions = Apollo.BaseMutationOptions<WebSyncHelloPayCardRegistrationMutation, WebSyncHelloPayCardRegistrationMutationVariables>;
export const WebCancelHelloPayCardSetupDocument = gql`
    mutation WebCancelHelloPayCardSetup($input: WebCancelHelloPayCardSetupInput!) {
  webCancelHelloPayCardSetup(input: $input) {
    registrationId
    status
    redirectUrl
  }
}
    `;
export type WebCancelHelloPayCardSetupMutationFn = Apollo.MutationFunction<WebCancelHelloPayCardSetupMutation, WebCancelHelloPayCardSetupMutationVariables>;

/**
 * __useWebCancelHelloPayCardSetupMutation__
 *
 * To run a mutation, you first call `useWebCancelHelloPayCardSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebCancelHelloPayCardSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webCancelHelloPayCardSetupMutation, { data, loading, error }] = useWebCancelHelloPayCardSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebCancelHelloPayCardSetupMutation(baseOptions?: Apollo.MutationHookOptions<WebCancelHelloPayCardSetupMutation, WebCancelHelloPayCardSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebCancelHelloPayCardSetupMutation, WebCancelHelloPayCardSetupMutationVariables>(WebCancelHelloPayCardSetupDocument, options);
      }
export type WebCancelHelloPayCardSetupMutationHookResult = ReturnType<typeof useWebCancelHelloPayCardSetupMutation>;
export type WebCancelHelloPayCardSetupMutationResult = Apollo.MutationResult<WebCancelHelloPayCardSetupMutation>;
export type WebCancelHelloPayCardSetupMutationOptions = Apollo.BaseMutationOptions<WebCancelHelloPayCardSetupMutation, WebCancelHelloPayCardSetupMutationVariables>;
export const WebDeleteHelloPayCardDocument = gql`
    mutation WebDeleteHelloPayCard($input: WebHelloPayCardRegistrationInput!) {
  webDeleteHelloPayCard(input: $input)
}
    `;
export type WebDeleteHelloPayCardMutationFn = Apollo.MutationFunction<WebDeleteHelloPayCardMutation, WebDeleteHelloPayCardMutationVariables>;

/**
 * __useWebDeleteHelloPayCardMutation__
 *
 * To run a mutation, you first call `useWebDeleteHelloPayCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebDeleteHelloPayCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webDeleteHelloPayCardMutation, { data, loading, error }] = useWebDeleteHelloPayCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebDeleteHelloPayCardMutation(baseOptions?: Apollo.MutationHookOptions<WebDeleteHelloPayCardMutation, WebDeleteHelloPayCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebDeleteHelloPayCardMutation, WebDeleteHelloPayCardMutationVariables>(WebDeleteHelloPayCardDocument, options);
      }
export type WebDeleteHelloPayCardMutationHookResult = ReturnType<typeof useWebDeleteHelloPayCardMutation>;
export type WebDeleteHelloPayCardMutationResult = Apollo.MutationResult<WebDeleteHelloPayCardMutation>;
export type WebDeleteHelloPayCardMutationOptions = Apollo.BaseMutationOptions<WebDeleteHelloPayCardMutation, WebDeleteHelloPayCardMutationVariables>;
export const WebCreateTicketOrderDocument = gql`
    mutation WebCreateTicketOrder($input: WebCreateTicketOrderInput!) {
  webCreateTicketOrder(input: $input) {
    orderId
    status
  }
}
    `;
export type WebCreateTicketOrderMutationFn = Apollo.MutationFunction<WebCreateTicketOrderMutation, WebCreateTicketOrderMutationVariables>;

/**
 * __useWebCreateTicketOrderMutation__
 *
 * To run a mutation, you first call `useWebCreateTicketOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebCreateTicketOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webCreateTicketOrderMutation, { data, loading, error }] = useWebCreateTicketOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebCreateTicketOrderMutation(baseOptions?: Apollo.MutationHookOptions<WebCreateTicketOrderMutation, WebCreateTicketOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebCreateTicketOrderMutation, WebCreateTicketOrderMutationVariables>(WebCreateTicketOrderDocument, options);
      }
export type WebCreateTicketOrderMutationHookResult = ReturnType<typeof useWebCreateTicketOrderMutation>;
export type WebCreateTicketOrderMutationResult = Apollo.MutationResult<WebCreateTicketOrderMutation>;
export type WebCreateTicketOrderMutationOptions = Apollo.BaseMutationOptions<WebCreateTicketOrderMutation, WebCreateTicketOrderMutationVariables>;
export const WebPayHelloPayTicketOrderDocument = gql`
    mutation WebPayHelloPayTicketOrder($input: WebPayHelloPayTicketOrderInput!) {
  webPayHelloPayTicketOrder(input: $input) {
    orderId
    status
  }
}
    `;
export type WebPayHelloPayTicketOrderMutationFn = Apollo.MutationFunction<WebPayHelloPayTicketOrderMutation, WebPayHelloPayTicketOrderMutationVariables>;

/**
 * __useWebPayHelloPayTicketOrderMutation__
 *
 * To run a mutation, you first call `useWebPayHelloPayTicketOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebPayHelloPayTicketOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webPayHelloPayTicketOrderMutation, { data, loading, error }] = useWebPayHelloPayTicketOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebPayHelloPayTicketOrderMutation(baseOptions?: Apollo.MutationHookOptions<WebPayHelloPayTicketOrderMutation, WebPayHelloPayTicketOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebPayHelloPayTicketOrderMutation, WebPayHelloPayTicketOrderMutationVariables>(WebPayHelloPayTicketOrderDocument, options);
      }
export type WebPayHelloPayTicketOrderMutationHookResult = ReturnType<typeof useWebPayHelloPayTicketOrderMutation>;
export type WebPayHelloPayTicketOrderMutationResult = Apollo.MutationResult<WebPayHelloPayTicketOrderMutation>;
export type WebPayHelloPayTicketOrderMutationOptions = Apollo.BaseMutationOptions<WebPayHelloPayTicketOrderMutation, WebPayHelloPayTicketOrderMutationVariables>;
export const WebTicketOrderDocument = gql`
    query WebTicketOrder($input: WebTicketOrderInput!) {
  webTicketOrder(input: $input) {
    orderId
    status
    failureReason
    cardRegistrationId
    ticketCount
    bonusTicketCount
  }
}
    `;

/**
 * __useWebTicketOrderQuery__
 *
 * To run a query within a React component, call `useWebTicketOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebTicketOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebTicketOrderQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebTicketOrderQuery(baseOptions: Apollo.QueryHookOptions<WebTicketOrderQuery, WebTicketOrderQueryVariables> & ({ variables: WebTicketOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebTicketOrderQuery, WebTicketOrderQueryVariables>(WebTicketOrderDocument, options);
      }
export function useWebTicketOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebTicketOrderQuery, WebTicketOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebTicketOrderQuery, WebTicketOrderQueryVariables>(WebTicketOrderDocument, options);
        }
export function useWebTicketOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebTicketOrderQuery, WebTicketOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebTicketOrderQuery, WebTicketOrderQueryVariables>(WebTicketOrderDocument, options);
        }
export type WebTicketOrderQueryHookResult = ReturnType<typeof useWebTicketOrderQuery>;
export type WebTicketOrderLazyQueryHookResult = ReturnType<typeof useWebTicketOrderLazyQuery>;
export type WebTicketOrderSuspenseQueryHookResult = ReturnType<typeof useWebTicketOrderSuspenseQuery>;
export type WebTicketOrderQueryResult = Apollo.QueryResult<WebTicketOrderQuery, WebTicketOrderQueryVariables>;
export const WebMasterDocument = gql`
    query WebMaster {
  webTicketMenus {
    id
    name
    price
    numberOfTicket
    webProductId
  }
  webProducts {
    id
    name
    price
    renewalPrice
    duration
  }
}
    `;

/**
 * __useWebMasterQuery__
 *
 * To run a query within a React component, call `useWebMasterQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebMasterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebMasterQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebMasterQuery(baseOptions?: Apollo.QueryHookOptions<WebMasterQuery, WebMasterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebMasterQuery, WebMasterQueryVariables>(WebMasterDocument, options);
      }
export function useWebMasterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebMasterQuery, WebMasterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebMasterQuery, WebMasterQueryVariables>(WebMasterDocument, options);
        }
export function useWebMasterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebMasterQuery, WebMasterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebMasterQuery, WebMasterQueryVariables>(WebMasterDocument, options);
        }
export type WebMasterQueryHookResult = ReturnType<typeof useWebMasterQuery>;
export type WebMasterLazyQueryHookResult = ReturnType<typeof useWebMasterLazyQuery>;
export type WebMasterSuspenseQueryHookResult = ReturnType<typeof useWebMasterSuspenseQuery>;
export type WebMasterQueryResult = Apollo.QueryResult<WebMasterQuery, WebMasterQueryVariables>;
export const WebCreateTicketCheckoutLinkDocument = gql`
    mutation WebCreateTicketCheckoutLink($input: WebCreateTicketCheckoutLinkInput!) {
  webCreateTicketCheckoutLink(input: $input) {
    checkoutUrl
  }
}
    `;
export type WebCreateTicketCheckoutLinkMutationFn = Apollo.MutationFunction<WebCreateTicketCheckoutLinkMutation, WebCreateTicketCheckoutLinkMutationVariables>;

/**
 * __useWebCreateTicketCheckoutLinkMutation__
 *
 * To run a mutation, you first call `useWebCreateTicketCheckoutLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebCreateTicketCheckoutLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webCreateTicketCheckoutLinkMutation, { data, loading, error }] = useWebCreateTicketCheckoutLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebCreateTicketCheckoutLinkMutation(baseOptions?: Apollo.MutationHookOptions<WebCreateTicketCheckoutLinkMutation, WebCreateTicketCheckoutLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebCreateTicketCheckoutLinkMutation, WebCreateTicketCheckoutLinkMutationVariables>(WebCreateTicketCheckoutLinkDocument, options);
      }
export type WebCreateTicketCheckoutLinkMutationHookResult = ReturnType<typeof useWebCreateTicketCheckoutLinkMutation>;
export type WebCreateTicketCheckoutLinkMutationResult = Apollo.MutationResult<WebCreateTicketCheckoutLinkMutation>;
export type WebCreateTicketCheckoutLinkMutationOptions = Apollo.BaseMutationOptions<WebCreateTicketCheckoutLinkMutation, WebCreateTicketCheckoutLinkMutationVariables>;
export const WebCreateCardEditLinkDocument = gql`
    mutation WebCreateCardEditLink {
  webCreateCardEditLink {
    cardEditUrl
  }
}
    `;
export type WebCreateCardEditLinkMutationFn = Apollo.MutationFunction<WebCreateCardEditLinkMutation, WebCreateCardEditLinkMutationVariables>;

/**
 * __useWebCreateCardEditLinkMutation__
 *
 * To run a mutation, you first call `useWebCreateCardEditLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebCreateCardEditLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webCreateCardEditLinkMutation, { data, loading, error }] = useWebCreateCardEditLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useWebCreateCardEditLinkMutation(baseOptions?: Apollo.MutationHookOptions<WebCreateCardEditLinkMutation, WebCreateCardEditLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebCreateCardEditLinkMutation, WebCreateCardEditLinkMutationVariables>(WebCreateCardEditLinkDocument, options);
      }
export type WebCreateCardEditLinkMutationHookResult = ReturnType<typeof useWebCreateCardEditLinkMutation>;
export type WebCreateCardEditLinkMutationResult = Apollo.MutationResult<WebCreateCardEditLinkMutation>;
export type WebCreateCardEditLinkMutationOptions = Apollo.BaseMutationOptions<WebCreateCardEditLinkMutation, WebCreateCardEditLinkMutationVariables>;
export const WebCreateSubscriptionCheckoutLinkDocument = gql`
    mutation WebCreateSubscriptionCheckoutLink($input: WebCreateSubscriptionCheckoutLinkInput!) {
  webCreateSubscriptionCheckoutLink(input: $input) {
    checkoutUrl
  }
}
    `;
export type WebCreateSubscriptionCheckoutLinkMutationFn = Apollo.MutationFunction<WebCreateSubscriptionCheckoutLinkMutation, WebCreateSubscriptionCheckoutLinkMutationVariables>;

/**
 * __useWebCreateSubscriptionCheckoutLinkMutation__
 *
 * To run a mutation, you first call `useWebCreateSubscriptionCheckoutLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebCreateSubscriptionCheckoutLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webCreateSubscriptionCheckoutLinkMutation, { data, loading, error }] = useWebCreateSubscriptionCheckoutLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebCreateSubscriptionCheckoutLinkMutation(baseOptions?: Apollo.MutationHookOptions<WebCreateSubscriptionCheckoutLinkMutation, WebCreateSubscriptionCheckoutLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebCreateSubscriptionCheckoutLinkMutation, WebCreateSubscriptionCheckoutLinkMutationVariables>(WebCreateSubscriptionCheckoutLinkDocument, options);
      }
export type WebCreateSubscriptionCheckoutLinkMutationHookResult = ReturnType<typeof useWebCreateSubscriptionCheckoutLinkMutation>;
export type WebCreateSubscriptionCheckoutLinkMutationResult = Apollo.MutationResult<WebCreateSubscriptionCheckoutLinkMutation>;
export type WebCreateSubscriptionCheckoutLinkMutationOptions = Apollo.BaseMutationOptions<WebCreateSubscriptionCheckoutLinkMutation, WebCreateSubscriptionCheckoutLinkMutationVariables>;
export const WebCreateSubscriptionUpgradeCheckoutLinkDocument = gql`
    mutation WebCreateSubscriptionUpgradeCheckoutLink($input: WebCreateSubscriptionUpgradeCheckoutLinkInput!) {
  webCreateSubscriptionUpgradeCheckoutLink(input: $input) {
    checkoutUrl
  }
}
    `;
export type WebCreateSubscriptionUpgradeCheckoutLinkMutationFn = Apollo.MutationFunction<WebCreateSubscriptionUpgradeCheckoutLinkMutation, WebCreateSubscriptionUpgradeCheckoutLinkMutationVariables>;

/**
 * __useWebCreateSubscriptionUpgradeCheckoutLinkMutation__
 *
 * To run a mutation, you first call `useWebCreateSubscriptionUpgradeCheckoutLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebCreateSubscriptionUpgradeCheckoutLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webCreateSubscriptionUpgradeCheckoutLinkMutation, { data, loading, error }] = useWebCreateSubscriptionUpgradeCheckoutLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebCreateSubscriptionUpgradeCheckoutLinkMutation(baseOptions?: Apollo.MutationHookOptions<WebCreateSubscriptionUpgradeCheckoutLinkMutation, WebCreateSubscriptionUpgradeCheckoutLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebCreateSubscriptionUpgradeCheckoutLinkMutation, WebCreateSubscriptionUpgradeCheckoutLinkMutationVariables>(WebCreateSubscriptionUpgradeCheckoutLinkDocument, options);
      }
export type WebCreateSubscriptionUpgradeCheckoutLinkMutationHookResult = ReturnType<typeof useWebCreateSubscriptionUpgradeCheckoutLinkMutation>;
export type WebCreateSubscriptionUpgradeCheckoutLinkMutationResult = Apollo.MutationResult<WebCreateSubscriptionUpgradeCheckoutLinkMutation>;
export type WebCreateSubscriptionUpgradeCheckoutLinkMutationOptions = Apollo.BaseMutationOptions<WebCreateSubscriptionUpgradeCheckoutLinkMutation, WebCreateSubscriptionUpgradeCheckoutLinkMutationVariables>;
export const WebCancelSubscriptionDocument = gql`
    mutation WebCancelSubscription {
  webCancelSubscription
}
    `;
export type WebCancelSubscriptionMutationFn = Apollo.MutationFunction<WebCancelSubscriptionMutation, WebCancelSubscriptionMutationVariables>;

/**
 * __useWebCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useWebCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webCancelSubscriptionMutation, { data, loading, error }] = useWebCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useWebCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<WebCancelSubscriptionMutation, WebCancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebCancelSubscriptionMutation, WebCancelSubscriptionMutationVariables>(WebCancelSubscriptionDocument, options);
      }
export type WebCancelSubscriptionMutationHookResult = ReturnType<typeof useWebCancelSubscriptionMutation>;
export type WebCancelSubscriptionMutationResult = Apollo.MutationResult<WebCancelSubscriptionMutation>;
export type WebCancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<WebCancelSubscriptionMutation, WebCancelSubscriptionMutationVariables>;
export const WebSyncSubscriptionDocument = gql`
    mutation WebSyncSubscription {
  webSyncSubscription
}
    `;
export type WebSyncSubscriptionMutationFn = Apollo.MutationFunction<WebSyncSubscriptionMutation, WebSyncSubscriptionMutationVariables>;

/**
 * __useWebSyncSubscriptionMutation__
 *
 * To run a mutation, you first call `useWebSyncSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebSyncSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webSyncSubscriptionMutation, { data, loading, error }] = useWebSyncSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useWebSyncSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<WebSyncSubscriptionMutation, WebSyncSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebSyncSubscriptionMutation, WebSyncSubscriptionMutationVariables>(WebSyncSubscriptionDocument, options);
      }
export type WebSyncSubscriptionMutationHookResult = ReturnType<typeof useWebSyncSubscriptionMutation>;
export type WebSyncSubscriptionMutationResult = Apollo.MutationResult<WebSyncSubscriptionMutation>;
export type WebSyncSubscriptionMutationOptions = Apollo.BaseMutationOptions<WebSyncSubscriptionMutation, WebSyncSubscriptionMutationVariables>;
export const WebGetSubscriptionUpgradePriceDocument = gql`
    query WebGetSubscriptionUpgradePrice($input: WebGetSubscriptionUpgradePriceInput!) {
  webGetSubscriptionUpgradePrice(input: $input) {
    availableUpgradePrice
    isUpgradable
  }
}
    `;

/**
 * __useWebGetSubscriptionUpgradePriceQuery__
 *
 * To run a query within a React component, call `useWebGetSubscriptionUpgradePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebGetSubscriptionUpgradePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebGetSubscriptionUpgradePriceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebGetSubscriptionUpgradePriceQuery(baseOptions: Apollo.QueryHookOptions<WebGetSubscriptionUpgradePriceQuery, WebGetSubscriptionUpgradePriceQueryVariables> & ({ variables: WebGetSubscriptionUpgradePriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebGetSubscriptionUpgradePriceQuery, WebGetSubscriptionUpgradePriceQueryVariables>(WebGetSubscriptionUpgradePriceDocument, options);
      }
export function useWebGetSubscriptionUpgradePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebGetSubscriptionUpgradePriceQuery, WebGetSubscriptionUpgradePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebGetSubscriptionUpgradePriceQuery, WebGetSubscriptionUpgradePriceQueryVariables>(WebGetSubscriptionUpgradePriceDocument, options);
        }
export function useWebGetSubscriptionUpgradePriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebGetSubscriptionUpgradePriceQuery, WebGetSubscriptionUpgradePriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebGetSubscriptionUpgradePriceQuery, WebGetSubscriptionUpgradePriceQueryVariables>(WebGetSubscriptionUpgradePriceDocument, options);
        }
export type WebGetSubscriptionUpgradePriceQueryHookResult = ReturnType<typeof useWebGetSubscriptionUpgradePriceQuery>;
export type WebGetSubscriptionUpgradePriceLazyQueryHookResult = ReturnType<typeof useWebGetSubscriptionUpgradePriceLazyQuery>;
export type WebGetSubscriptionUpgradePriceSuspenseQueryHookResult = ReturnType<typeof useWebGetSubscriptionUpgradePriceSuspenseQuery>;
export type WebGetSubscriptionUpgradePriceQueryResult = Apollo.QueryResult<WebGetSubscriptionUpgradePriceQuery, WebGetSubscriptionUpgradePriceQueryVariables>;
export const WebTicketPurchaseMenuDocument = gql`
    query webTicketPurchaseMenu {
  webTicketPurchaseMenu {
    viewerId
    isV4
    saleKind
    saleEndsAt
    items {
      ticketMenuId
      name
      numberOfTicket
      price
      bonusCount
      referencePrice
      isDiscount
      isRecommended
      iosProductId
      androidProductId
      webProductId
      offeringIdentifier
      packageIdentifier
    }
  }
}
    `;

/**
 * __useWebTicketPurchaseMenuQuery__
 *
 * To run a query within a React component, call `useWebTicketPurchaseMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebTicketPurchaseMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebTicketPurchaseMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebTicketPurchaseMenuQuery(baseOptions?: Apollo.QueryHookOptions<WebTicketPurchaseMenuQuery, WebTicketPurchaseMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebTicketPurchaseMenuQuery, WebTicketPurchaseMenuQueryVariables>(WebTicketPurchaseMenuDocument, options);
      }
export function useWebTicketPurchaseMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebTicketPurchaseMenuQuery, WebTicketPurchaseMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebTicketPurchaseMenuQuery, WebTicketPurchaseMenuQueryVariables>(WebTicketPurchaseMenuDocument, options);
        }
export function useWebTicketPurchaseMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebTicketPurchaseMenuQuery, WebTicketPurchaseMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebTicketPurchaseMenuQuery, WebTicketPurchaseMenuQueryVariables>(WebTicketPurchaseMenuDocument, options);
        }
export type WebTicketPurchaseMenuQueryHookResult = ReturnType<typeof useWebTicketPurchaseMenuQuery>;
export type WebTicketPurchaseMenuLazyQueryHookResult = ReturnType<typeof useWebTicketPurchaseMenuLazyQuery>;
export type WebTicketPurchaseMenuSuspenseQueryHookResult = ReturnType<typeof useWebTicketPurchaseMenuSuspenseQuery>;
export type WebTicketPurchaseMenuQueryResult = Apollo.QueryResult<WebTicketPurchaseMenuQuery, WebTicketPurchaseMenuQueryVariables>;
export const WebCurrentTicketDocument = gql`
    query WebCurrentTicket {
  webCurrentTicket {
    totalTicket
    bonusTicket
    purchaseTicket
  }
}
    `;

/**
 * __useWebCurrentTicketQuery__
 *
 * To run a query within a React component, call `useWebCurrentTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebCurrentTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebCurrentTicketQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebCurrentTicketQuery(baseOptions?: Apollo.QueryHookOptions<WebCurrentTicketQuery, WebCurrentTicketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebCurrentTicketQuery, WebCurrentTicketQueryVariables>(WebCurrentTicketDocument, options);
      }
export function useWebCurrentTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebCurrentTicketQuery, WebCurrentTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebCurrentTicketQuery, WebCurrentTicketQueryVariables>(WebCurrentTicketDocument, options);
        }
export function useWebCurrentTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebCurrentTicketQuery, WebCurrentTicketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebCurrentTicketQuery, WebCurrentTicketQueryVariables>(WebCurrentTicketDocument, options);
        }
export type WebCurrentTicketQueryHookResult = ReturnType<typeof useWebCurrentTicketQuery>;
export type WebCurrentTicketLazyQueryHookResult = ReturnType<typeof useWebCurrentTicketLazyQuery>;
export type WebCurrentTicketSuspenseQueryHookResult = ReturnType<typeof useWebCurrentTicketSuspenseQuery>;
export type WebCurrentTicketQueryResult = Apollo.QueryResult<WebCurrentTicketQuery, WebCurrentTicketQueryVariables>;
export const WebCurrentUserDocument = gql`
    query WebCurrentUser {
  webCurrentUser {
    ...webCurrentUserFragment
  }
}
    ${WebCurrentUserFragmentFragmentDoc}`;

/**
 * __useWebCurrentUserQuery__
 *
 * To run a query within a React component, call `useWebCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<WebCurrentUserQuery, WebCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebCurrentUserQuery, WebCurrentUserQueryVariables>(WebCurrentUserDocument, options);
      }
export function useWebCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebCurrentUserQuery, WebCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebCurrentUserQuery, WebCurrentUserQueryVariables>(WebCurrentUserDocument, options);
        }
export function useWebCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebCurrentUserQuery, WebCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebCurrentUserQuery, WebCurrentUserQueryVariables>(WebCurrentUserDocument, options);
        }
export type WebCurrentUserQueryHookResult = ReturnType<typeof useWebCurrentUserQuery>;
export type WebCurrentUserLazyQueryHookResult = ReturnType<typeof useWebCurrentUserLazyQuery>;
export type WebCurrentUserSuspenseQueryHookResult = ReturnType<typeof useWebCurrentUserSuspenseQuery>;
export type WebCurrentUserQueryResult = Apollo.QueryResult<WebCurrentUserQuery, WebCurrentUserQueryVariables>;
export const WebStarterPackSaleDocument = gql`
    query WebStarterPackSale {
  webCurrentUser {
    id
    starterPackSale {
      isAvailable
      dueDate
      name
      shortName
      productId
    }
  }
}
    `;

/**
 * __useWebStarterPackSaleQuery__
 *
 * To run a query within a React component, call `useWebStarterPackSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebStarterPackSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebStarterPackSaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebStarterPackSaleQuery(baseOptions?: Apollo.QueryHookOptions<WebStarterPackSaleQuery, WebStarterPackSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebStarterPackSaleQuery, WebStarterPackSaleQueryVariables>(WebStarterPackSaleDocument, options);
      }
export function useWebStarterPackSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebStarterPackSaleQuery, WebStarterPackSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebStarterPackSaleQuery, WebStarterPackSaleQueryVariables>(WebStarterPackSaleDocument, options);
        }
export function useWebStarterPackSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebStarterPackSaleQuery, WebStarterPackSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebStarterPackSaleQuery, WebStarterPackSaleQueryVariables>(WebStarterPackSaleDocument, options);
        }
export type WebStarterPackSaleQueryHookResult = ReturnType<typeof useWebStarterPackSaleQuery>;
export type WebStarterPackSaleLazyQueryHookResult = ReturnType<typeof useWebStarterPackSaleLazyQuery>;
export type WebStarterPackSaleSuspenseQueryHookResult = ReturnType<typeof useWebStarterPackSaleSuspenseQuery>;
export type WebStarterPackSaleQueryResult = Apollo.QueryResult<WebStarterPackSaleQuery, WebStarterPackSaleQueryVariables>;
export const WebGetCurrentUserLoginProviderDocument = gql`
    query WebGetCurrentUserLoginProvider {
  webGetCurrentUserLoginProvider
}
    `;

/**
 * __useWebGetCurrentUserLoginProviderQuery__
 *
 * To run a query within a React component, call `useWebGetCurrentUserLoginProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebGetCurrentUserLoginProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebGetCurrentUserLoginProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebGetCurrentUserLoginProviderQuery(baseOptions?: Apollo.QueryHookOptions<WebGetCurrentUserLoginProviderQuery, WebGetCurrentUserLoginProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebGetCurrentUserLoginProviderQuery, WebGetCurrentUserLoginProviderQueryVariables>(WebGetCurrentUserLoginProviderDocument, options);
      }
export function useWebGetCurrentUserLoginProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebGetCurrentUserLoginProviderQuery, WebGetCurrentUserLoginProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebGetCurrentUserLoginProviderQuery, WebGetCurrentUserLoginProviderQueryVariables>(WebGetCurrentUserLoginProviderDocument, options);
        }
export function useWebGetCurrentUserLoginProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebGetCurrentUserLoginProviderQuery, WebGetCurrentUserLoginProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebGetCurrentUserLoginProviderQuery, WebGetCurrentUserLoginProviderQueryVariables>(WebGetCurrentUserLoginProviderDocument, options);
        }
export type WebGetCurrentUserLoginProviderQueryHookResult = ReturnType<typeof useWebGetCurrentUserLoginProviderQuery>;
export type WebGetCurrentUserLoginProviderLazyQueryHookResult = ReturnType<typeof useWebGetCurrentUserLoginProviderLazyQuery>;
export type WebGetCurrentUserLoginProviderSuspenseQueryHookResult = ReturnType<typeof useWebGetCurrentUserLoginProviderSuspenseQuery>;
export type WebGetCurrentUserLoginProviderQueryResult = Apollo.QueryResult<WebGetCurrentUserLoginProviderQuery, WebGetCurrentUserLoginProviderQueryVariables>;